import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
}

.meetings-page,
.meetings-page *,
.modal-backdrop,
.modal-backdrop * {
  box-sizing: border-box;
}

.meetings-page {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 34px 36px 56px;
  color: #172033;
  background: radial-gradient(circle at 5% 0%, rgba(124, 58, 237, 0.08), transparent 27%), radial-gradient(circle at 96% 12%, rgba(244, 63, 94, 0.07), transparent 25%), #f7f8fc;
}

button,
input,
textarea,
select {
  font: inherit;
}

button {
  cursor: pointer;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;
  max-width: 1220px;
  margin: 0 auto 26px;
}

.eyebrow,
.modal-kicker,
.panel-kicker {
  margin: 0 0 8px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.page-header h1 {
  margin: 0;
  color: #111827;
  font-size: 29px;
  font-weight: 900;
  letter-spacing: -0.04em;
}

.header-copy {
  margin: 9px 0 0;
  color: #667085;
  font-size: 13px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 9px;
}

.primary-button,
.secondary-button,
.cancel-button,
.banner-button,
.text-button,
.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 800;
  transition: transform 150ms ease, box-shadow 150ms ease, border-color 150ms ease, background 150ms ease;
}

.primary-button,
.secondary-button {
  min-height: 42px;
  padding: 0 16px;
}

.primary-button {
  border: 1px solid #7c3aed;
  color: #fff;
  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
  box-shadow: 0 10px 22px rgba(124, 58, 237, 0.2);
}

.primary-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 13px 26px rgba(124, 58, 237, 0.26);
}

.secondary-button,
.cancel-button {
  border: 1px solid #d9ddea;
  color: #475467;
  background: #fff;
}

.secondary-button:hover,
.cancel-button:hover:not(:disabled) {
  border-color: #c4b5fd;
  color: #6d28d9;
  background: #faf8ff;
}

.primary-button svg,
.secondary-button svg,
.banner-button svg,
.back-button svg {
  width: 17px;
  height: 17px;
}

.primary-button:disabled,
.cancel-button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  max-width: 1220px;
  margin: 0 auto 22px;
}

.summary-card {
  display: flex;
  align-items: center;
  gap: 13px;
  min-height: 84px;
  padding: 15px 17px;
  border: 1px solid rgba(222, 226, 237, 0.88);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 9px 28px rgba(34, 25, 60, 0.05);
}

.summary-icon {
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  width: 43px;
  height: 43px;
  border-radius: 12px;
}

.summary-icon svg {
  width: 21px;
  height: 21px;
}

.summary-card.violet .summary-icon {
  color: #7c3aed;
  background: #f1eafe;
}

.summary-card.rose .summary-icon {
  color: #e11d48;
  background: #fff0f4;
}

.summary-card.amber .summary-icon {
  color: #d97706;
  background: #fff7e7;
}

.summary-card div:last-child {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.summary-card span {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.summary-card strong {
  color: #101828;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: -0.04em;
}

.meetings-section {
  max-width: 1220px;
  min-height: 344px;
  margin: 0 auto 22px;
  padding: 23px;
  border: 1px solid rgba(219, 224, 235, 0.94);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 15px 38px rgba(34, 25, 60, 0.055);
}

.section-heading,
.panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.section-heading {
  margin-bottom: 18px;
}

.section-heading h2,
.panel-heading h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.section-heading p {
  margin: 5px 0 0;
  color: #98a2b3;
  font-size: 11px;
}

.search-field,
.large-search {
  display: flex;
  align-items: center;
  border: 1px solid #e0e4ed;
  color: #98a2b3;
  background: #f9fafc;
  transition: border-color 150ms ease, box-shadow 150ms ease, background 150ms ease;
}

.search-field {
  width: 228px;
  height: 38px;
  padding: 0 12px;
  border-radius: 10px;
}

.search-field:focus-within,
.large-search:focus-within {
  border-color: #a78bfa;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.search-field svg,
.large-search svg {
  flex: 0 0 auto;
  width: 17px;
  height: 17px;
}

.search-field input,
.large-search input {
  width: 100%;
  border: 0;
  outline: 0;
  color: #344054;
  background: transparent;
}

.search-field input {
  padding: 0 0 0 8px;
  font-size: 11px;
}

.meeting-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 15px;
}

.meeting-card {
  overflow: hidden;
  width: 100%;
  padding: 0;
  border: 1px solid #e5e8ef;
  border-radius: 13px;
  text-align: left;
  background: #fff;
  box-shadow: 0 6px 16px rgba(23, 32, 51, 0.035);
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
}

.meeting-card:hover {
  transform: translateY(-3px);
  border-color: #d8ccfa;
  box-shadow: 0 15px 30px rgba(76, 48, 130, 0.12);
}

.meeting-cover {
  position: relative;
  overflow: hidden;
  height: 118px;
  background: #ede9fe;
}

.meeting-cover img,
.detail-cover img,
.image-uploader img,
.result-image img,
.selected-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-0 {
  background: linear-gradient(145deg, #7c3aed, #c4b5fd);
}

.cover-1 {
  background: linear-gradient(145deg, #e11d48, #fda4af);
}

.cover-2 {
  background: linear-gradient(145deg, #0f766e, #5eead4);
}

.cover-3 {
  background: linear-gradient(145deg, #d97706, #fcd34d);
}

.cover-pattern {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at 18% 25%, rgba(255, 255, 255, 0.27) 0 10px, transparent 11px), radial-gradient(circle at 83% 76%, rgba(255, 255, 255, 0.22) 0 34px, transparent 35px), linear-gradient(120deg, transparent 50%, rgba(255, 255, 255, 0.12) 50%);
}

.cover-pattern span {
  color: rgba(255, 255, 255, 0.92);
  font-size: 38px;
  font-weight: 900;
  text-shadow: 0 3px 14px rgba(0, 0, 0, 0.12);
}

.role-badge {
  position: absolute;
  top: 11px;
  left: 11px;
  padding: 5px 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  background: rgba(17, 24, 39, 0.34);
  backdrop-filter: blur(8px);
}

.meeting-card-body {
  padding: 14px 15px 15px;
}

.meeting-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.meeting-title-row h3 {
  overflow: hidden;
  margin: 0;
  color: #172033;
  font-size: 14px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.meeting-title-row svg {
  flex: 0 0 auto;
  width: 15px;
  height: 15px;
  color: #c0c6d2;
}

.meeting-card-body > p {
  display: -webkit-box;
  overflow: hidden;
  min-height: 32px;
  margin: 7px 0 13px;
  color: #7b8494;
  font-size: 11px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.meeting-meta {
  display: flex;
  align-items: center;
  gap: 13px;
  padding-top: 11px;
  border-top: 1px solid #f0f2f6;
}

.meeting-meta span,
.schedule-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #98a2b3;
  font-size: 10px;
  font-weight: 700;
}

.meeting-meta svg,
.schedule-meta svg {
  width: 13px;
  height: 13px;
}

.loading-state,
.empty-state {
  display: flex;
  min-height: 244px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.loading-state p {
  margin: 13px 0 0;
  color: #98a2b3;
  font-size: 11px;
}

.spinner,
.button-spinner {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 2px solid #e6e1f2;
  border-top-color: #7c3aed;
  border-radius: 999px;
  animation: spin 800ms linear infinite;
}

.spinner.small {
  width: 17px;
  height: 17px;
}

.button-spinner {
  width: 14px;
  height: 14px;
  border-color: rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.empty-visual {
  position: relative;
  width: 68px;
  height: 58px;
  margin-bottom: 13px;
}

.empty-visual span {
  position: absolute;
  width: 31px;
  height: 31px;
  border: 3px solid #b8a4ee;
  border-radius: 999px;
  background: #f6f2ff;
}

.empty-visual span:first-child {
  top: 0;
  left: 18px;
}

.empty-visual span:nth-child(2) {
  bottom: 0;
  left: 0;
  border-color: #f3a5b7;
  background: #fff3f6;
}

.empty-visual span:nth-child(3) {
  right: 0;
  bottom: 0;
  border-color: #f4c879;
  background: #fff9ed;
}

.empty-state h3 {
  margin: 0;
  color: #344054;
  font-size: 14px;
  font-weight: 900;
}

.empty-state > p {
  margin: 7px 0 0;
  color: #98a2b3;
  font-size: 11px;
}

.empty-actions {
  display: flex;
  gap: 9px;
  margin-top: 17px;
}

.empty-actions .primary-button,
.empty-actions .secondary-button {
  min-height: 37px;
  padding: 0 13px;
  font-size: 11px;
}

.discover-banner {
  position: relative;
  display: grid;
  grid-template-columns: 120px 1fr auto;
  align-items: center;
  gap: 24px;
  overflow: hidden;
  max-width: 1220px;
  min-height: 128px;
  margin: 0 auto;
  padding: 23px 28px;
  border-radius: 17px;
  color: #fff;
  background: linear-gradient(115deg, #5b21b6 0%, #7c3aed 46%, #c026d3 100%);
  box-shadow: 0 18px 38px rgba(91, 33, 182, 0.18);
}

.discover-banner::after {
  position: absolute;
  top: -90px;
  right: 18%;
  width: 220px;
  height: 220px;
  border: 40px solid rgba(255, 255, 255, 0.055);
  border-radius: 999px;
  content: "";
}

.discover-art {
  position: relative;
  z-index: 1;
  height: 76px;
}

.art-card {
  position: absolute;
  width: 68px;
  height: 52px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.19);
  box-shadow: 0 8px 18px rgba(47, 15, 89, 0.2);
  backdrop-filter: blur(5px);
}

.art-card::before,
.art-card::after {
  position: absolute;
  content: "";
}

.art-card::before {
  top: 11px;
  left: 11px;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
}

.art-card::after {
  right: 10px;
  bottom: 12px;
  left: 10px;
  height: 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 -9px rgba(255, 255, 255, 0.3);
}

.art-card.one {
  top: 4px;
  left: 8px;
  transform: rotate(-9deg);
}

.art-card.two {
  right: 7px;
  bottom: 2px;
  transform: rotate(8deg);
}

.art-dot {
  position: absolute;
  top: 0;
  right: 3px;
  width: 13px;
  height: 13px;
  border: 3px solid rgba(255, 255, 255, 0.66);
  border-radius: 999px;
}

.discover-copy {
  position: relative;
  z-index: 1;
}

.discover-copy > span {
  color: #e9d5ff;
  font-size: 10px;
  font-weight: 800;
}

.discover-copy h2 {
  margin: 4px 0 5px;
  font-size: 18px;
  font-weight: 900;
}

.discover-copy p {
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
}

.banner-button {
  position: relative;
  z-index: 1;
  min-height: 40px;
  padding: 0 15px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #5b21b6;
  background: #fff;
  box-shadow: 0 9px 20px rgba(46, 16, 101, 0.18);
}

.banner-button:hover {
  transform: translateY(-1px);
}

.back-button {
  min-height: 36px;
  margin: 0 auto 14px;
  padding: 0;
  border: 0;
  color: #667085;
  background: transparent;
}

.detail-hero,
.detail-grid,
.back-button {
  width: 100%;
  max-width: 1220px;
}

.back-button {
  justify-content: flex-start;
}

.back-button:hover {
  color: #6d28d9;
}

.detail-loading-shell {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr) auto;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 1220px;
  min-height: 184px;
  margin: 0 auto;
  padding: 22px;
  border: 1px solid rgba(219, 224, 235, 0.95);
  border-radius: 17px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 38px rgba(34, 25, 60, 0.065);
}

.detail-loading-cover,
.detail-loading-line {
  overflow: hidden;
  position: relative;
  background: #eeeaf7;
}

.detail-loading-cover::after,
.detail-loading-line::after {
  position: absolute;
  inset: 0;
  content: "";
  background: linear-gradient(100deg, transparent 20%, rgba(255, 255, 255, 0.72) 45%, transparent 70%);
  transform: translateX(-100%);
  animation: detail-loading-shimmer 1.4s ease-in-out infinite;
}

.detail-loading-cover {
  height: 140px;
  border-radius: 13px;
}

.detail-loading-copy {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
}

.detail-loading-line {
  display: block;
  height: 11px;
  border-radius: 999px;
}

.detail-loading-line.badge {
  width: 86px;
  height: 21px;
}

.detail-loading-line.title {
  width: min(52%, 360px);
  height: 27px;
}

.detail-loading-line.description {
  width: min(76%, 560px);
}

.detail-loading-line.meta {
  width: min(42%, 280px);
}

@keyframes detail-loading-shimmer {
  to {
    transform: translateX(100%);
  }
}
.detail-hero {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr) auto;
  align-items: center;
  gap: 24px;
  min-height: 184px;
  margin: 0 auto 18px;
  padding: 22px;
  border: 1px solid rgba(219, 224, 235, 0.95);
  border-radius: 17px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 38px rgba(34, 25, 60, 0.065);
}

.detail-cover {
  overflow: hidden;
  height: 140px;
  border-radius: 13px;
  background: linear-gradient(145deg, #7c3aed, #d8b4fe);
}

.detail-cover-fallback {
  display: grid;
  width: 100%;
  height: 100%;
  place-items: center;
  background: radial-gradient(circle at 76% 24%, rgba(255, 255, 255, 0.22) 0 28px, transparent 29px), radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.13) 0 46px, transparent 47px);
}

.detail-cover-fallback span {
  color: #fff;
  font-size: 48px;
  font-weight: 900;
}

.detail-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.detail-badges span {
  color: #98a2b3;
  font-size: 10px;
  font-weight: 700;
}

.detail-badges .membership-badge {
  padding: 4px 8px;
  border-radius: 999px;
  color: #6d28d9;
  font-weight: 900;
  background: #f2ecff;
}

.detail-hero-copy h1 {
  margin: 0;
  color: #172033;
  font-size: 25px;
  font-weight: 900;
  letter-spacing: -0.035em;
}

.detail-hero-copy > p {
  max-width: 620px;
  margin: 8px 0 12px;
  color: #667085;
  font-size: 12px;
  line-height: 1.6;
}

.owner-line {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #98a2b3;
  font-size: 10px;
}

.detail-action {
  align-self: start;
}

.detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.9fr) minmax(250px, 0.8fr);
  align-items: start;
  gap: 18px;
  margin: 0 auto;
}

.detail-panel {
  padding: 22px;
  border: 1px solid rgba(219, 224, 235, 0.95);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 30px rgba(34, 25, 60, 0.05);
}

.panel-kicker {
  display: block;
  margin-bottom: 4px;
  font-size: 9px;
}

.count-pill {
  padding: 5px 9px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 900;
  background: #f3efff;
}

.panel-empty {
  display: flex;
  min-height: 270px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.panel-empty-icon {
  display: grid;
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
  place-items: center;
  border-radius: 14px;
  color: #8b5cf6;
  background: #f2edff;
}

.panel-empty-icon svg {
  width: 23px;
  height: 23px;
}

.panel-empty h3 {
  margin: 0;
  color: #344054;
  font-size: 13px;
  font-weight: 900;
}

.panel-empty p {
  margin: 6px 0 11px;
  color: #98a2b3;
  font-size: 10px;
}

.text-button {
  border: 0;
  color: #7c3aed;
  background: transparent;
}

.schedule-list {
  display: grid;
  gap: 11px;
  margin-top: 18px;
}

.schedule-item {
  display: grid;
  grid-template-columns: 145px minmax(0, 1fr);
  gap: 17px;
  padding: 16px;
  border: 1px solid #eaecf2;
  border-radius: 12px;
  background: #fcfcfd;
}

.date-block {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 7px;
  padding-right: 16px;
  border-right: 1px solid #eaecf2;
}

.date-block strong {
  color: #475467;
  font-size: 11px;
  line-height: 1.5;
  white-space: nowrap;
}

.date-block small {
  color: #667085;
  font-size: 10px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  white-space: nowrap;
}

.date-block span {
  padding: 3px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 900;
}

.schedule-date-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.date-block .schedule-month-badge {
  color: #667085;
  background: #f2f4f7;
}

.date-block .schedule-month-badge.current {
  color: #6d28d9;
  background: #f1ebff;
}

.date-block .schedule-month-badge.next {
  color: #b54708;
  background: #fff7ed;
}

.date-block .upcoming {
  color: #047857;
  background: #e9f9f2;
}

.date-block .past {
  color: #b42318;
  background: #fef3f2;
}

.schedule-content h3 {
  margin: 0;
  color: #172033;
  font-size: 13px;
  font-weight: 900;
}

.schedule-content > p {
  margin: 6px 0 9px;
  color: #7b8494;
  font-size: 10px;
  line-height: 1.55;
}

.schedule-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 11px;
  margin-top: 8px;
}

.member-list {
  display: grid;
  gap: 2px;
  margin-top: 15px;
}

.member-row {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f2f6;
}

.member-row:last-child {
  border-bottom: 0;
}

.avatar {
  display: grid;
  overflow: hidden;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  line-height: 1;
  background: #eee8ff;
}

.avatar > img,
.member-preview-avatar > img,
.poll-avatar > img,
.schedule-detail-participants i > img,
.poll-day-voter > img,
.mini-voter-avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-1 {
  color: #be123c;
  background: #ffe8ef;
}

.avatar-2 {
  color: #047857;
  background: #e4f8ef;
}

.avatar-3 {
  color: #b45309;
  background: #fff2d9;
}

.avatar.mini {
  width: 23px;
  height: 23px;
  font-size: 8px;
}

.member-row div {
  min-width: 0;
}

.member-row > div strong,
.member-row > div span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.member-row strong {
  color: #344054;
  font-size: 11px;
  font-weight: 900;
}

.member-row div > span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 9px;
}

.member-row em {
  padding: 4px 7px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  background: #f3efff;
}

.member-row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.member-panel-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}

.member-add-button {
  display: inline-flex;
  min-height: 34px;
  padding: 0 12px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #7c3aed;
  border-radius: 9px;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  background: linear-gradient(135deg, #7c3aed, #8b5cf6);
  box-shadow: 0 7px 16px rgba(124, 58, 237, 0.16);
  transition: transform 150ms ease, box-shadow 150ms ease;
}

.member-add-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(124, 58, 237, 0.22);
}

.member-add-button svg {
  width: 15px;
  height: 15px;
}

.member-remove-button {
  min-height: 28px;
  padding: 0 9px;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  color: #be123c;
  font-size: 8px;
  font-weight: 900;
  background: #fffafb;
}

.member-remove-button:hover:not(:disabled) {
  border-color: #fda4af;
  background: #fff1f3;
}

.member-remove-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.modal-backdrop {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(17, 24, 39, 0.48);
  backdrop-filter: blur(5px);
}

.modal-card {
  overflow: hidden;
  width: 100%;
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 28px 70px rgba(16, 24, 40, 0.26);
}

.create-modal {
  max-width: 760px;
}

.join-modal {
  max-width: 590px;
}

.schedule-modal {
  max-width: 650px;
}

.settings-modal {
  max-width: 820px;
}

.add-member-modal {
  max-width: 520px;
}

.add-member-body {
  display: grid;
  gap: 19px;
}

.add-member-guide {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e4dcfb;
  border-radius: 12px;
  background: #faf8ff;
}

.add-member-guide-icon {
  display: grid;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 10px;
  color: #7c3aed;
  background: #eee8ff;
}

.add-member-guide-icon svg {
  width: 19px;
  height: 19px;
}

.add-member-guide strong {
  display: block;
  color: #4c1d95;
  font-size: 10px;
  font-weight: 900;
}

.add-member-guide p {
  margin: 4px 0 0;
  color: #7c6d99;
  font-size: 9px;
  line-height: 1.55;
}

.add-member-fields {
  gap: 14px;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 23px 25px 19px;
  border-bottom: 1px solid #edf0f4;
}

.modal-header h2 {
  margin: 0;
  color: #172033;
  font-size: 19px;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.modal-header p {
  margin: 6px 0 0;
  color: #98a2b3;
  font-size: 10px;
}

.modal-kicker {
  display: block;
  margin-bottom: 4px;
  font-size: 9px;
}

.close-button {
  display: grid;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  place-items: center;
  color: #667085;
  background: #fff;
}

.close-button:hover {
  color: #7c3aed;
  background: #faf8ff;
}

.close-button svg {
  width: 17px;
  height: 17px;
}

.modal-body {
  overflow-y: auto;
  max-height: calc(100vh - 210px);
  max-height: calc(100dvh - 210px);
  padding: 23px 25px;
}

.form-layout {
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr);
  gap: 24px;
}

.image-uploader {
  overflow: hidden;
  width: 100%;
  height: 178px;
  padding: 0;
  border: 1px dashed #cbbcf4;
  border-radius: 13px;
  color: #7c3aed;
  background: #faf8ff;
}

.image-uploader > div {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.image-uploader svg {
  width: 28px;
  height: 28px;
  margin-bottom: 10px;
}

.image-uploader strong,
.image-uploader span {
  display: block;
}

.image-uploader strong {
  color: #5b21b6;
  font-size: 11px;
  font-weight: 900;
}

.image-uploader span {
  margin-top: 4px;
  color: #a49bad;
  font-size: 9px;
}

.remove-image {
  width: 100%;
  margin-top: 7px;
  border: 0;
  color: #98a2b3;
  font-size: 9px;
  background: transparent;
}

.form-fields {
  display: grid;
  gap: 15px;
}

.form-field {
  position: relative;
  display: block;
}

.form-field > span {
  display: block;
  margin-bottom: 7px;
  color: #475467;
  font-size: 10px;
  font-weight: 900;
}

.form-field em {
  color: #e11d48;
  font-size: 8px;
  font-style: normal;
}

.form-field input,
.form-field textarea {
  display: block;
  width: 100%;
  border: 1px solid #dfe3eb;
  border-radius: 9px;
  outline: none;
  color: #344054;
  background: #fff;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.form-field input {
  height: 40px;
  padding: 0 12px;
  font-size: 11px;
}

.form-field textarea {
  min-height: 90px;
  padding: 10px 12px;
  font-size: 11px;
  line-height: 1.5;
  resize: vertical;
}

.form-field input:focus,
.form-field textarea:focus {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
}

.form-field input[readonly] {
  color: #667085;
  background: #f7f8fa;
  cursor: default;
}

.form-field small {
  display: block;
  margin-top: 5px;
  color: #98a2b3;
  font-size: 8px;
}

.form-field .character-count {
  position: absolute;
  right: 9px;
  bottom: 7px;
  padding-left: 5px;
  background: #fff;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  padding: 15px 25px;
  border-top: 1px solid #edf0f4;
  background: #fbfcfd;
}

.cancel-button {
  min-height: 40px;
  padding: 0 16px;
}

.modal-footer .primary-button {
  min-width: 118px;
}

.settings-body {
  display: grid;
  gap: 18px;
  background: #f8f9fc;
}

.settings-section {
  padding: 20px;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  background: #fff;
}

.settings-section-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 17px;
}

.settings-section-heading strong,
.management-card strong {
  display: block;
  color: #1d2939;
  font-size: 12px;
  font-weight: 900;
}

.settings-section-heading span,
.management-card p {
  display: block;
  margin: 4px 0 0;
  color: #98a2b3;
  font-size: 9px;
  line-height: 1.55;
}

.settings-section-heading .owner-only-badge {
  margin: 0;
  padding: 5px 8px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #f3efff;
}

.settings-form {
  display: grid;
  grid-template-columns: 170px minmax(0, 1fr);
  gap: 20px;
}

.settings-form .image-uploader {
  height: 145px;
}

.management-section {
  border-color: #ddd6fe;
}

.management-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  padding: 15px;
  border: 1px solid #ebe7f8;
  border-radius: 11px;
  background: #fbfaff;
}

.management-card.sole-owner {
  display: block;
}

.management-action {
  display: flex;
  align-items: center;
  gap: 8px;
}

.management-action-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.select-field select {
  min-width: 220px;
  height: 38px;
  padding: 0 32px 0 11px;
  border: 1px solid #dfe3eb;
  border-radius: 9px;
  outline: none;
  color: #344054;
  font-size: 10px;
  background: #fff;
}

.select-field select:focus {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
}

.outline-transfer-button,
.outline-danger-button,
.danger-button {
  min-height: 38px;
  padding: 0 13px;
  border-radius: 9px;
  font-size: 9px;
  font-weight: 900;
  white-space: nowrap;
}

.outline-transfer-button {
  border: 1px solid #c4b5fd;
  color: #6d28d9;
  background: #fff;
}

.outline-transfer-button:hover:not(:disabled) {
  border-color: #8b5cf6;
  background: #f5f1ff;
}

.outline-danger-button {
  border: 1px solid #fda4af;
  color: #be123c;
  background: #fff;
}

.outline-danger-button:hover:not(:disabled) {
  border-color: #e11d48;
  background: #fff1f3;
}

.danger-section {
  border-color: #fecdd3;
  background: #fffafb;
}

.danger-section .settings-section-heading strong {
  color: #9f1239;
}

.delete-meeting-box {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 12px;
}

.delete-meeting-box .form-field b {
  color: #9f1239;
}

.danger-button {
  min-height: 40px;
  border: 1px solid #be123c;
  color: #fff;
  background: #be123c;
}

.danger-button:hover:not(:disabled) {
  border-color: #9f1239;
  background: #9f1239;
}

.outline-transfer-button:disabled,
.outline-danger-button:disabled,
.danger-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.settings-footer {
  position: sticky;
  bottom: 0;
}

.sr-only {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.join-search-body {
  min-height: 340px;
}

.large-search {
  height: 48px;
  padding: 0 15px;
  border-radius: 12px;
}

.large-search input {
  padding: 0 10px;
  font-size: 12px;
}

.search-guide {
  display: flex;
  min-height: 235px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.search-guide.compact {
  min-height: 190px;
}

.guide-icon {
  display: grid;
  width: 50px;
  height: 50px;
  margin-bottom: 13px;
  border-radius: 15px;
  place-items: center;
  color: #8b5cf6;
  background: #f2edff;
}

.guide-icon svg {
  width: 24px;
  height: 24px;
}

.search-guide strong,
.search-guide span {
  display: block;
}

.search-guide strong {
  color: #475467;
  font-size: 12px;
  font-weight: 900;
}

.search-guide span {
  margin-top: 6px;
  color: #98a2b3;
  font-size: 9px;
}

.join-results {
  display: grid;
  gap: 9px;
  margin-top: 15px;
}

.join-result {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 9px;
  border: 1px solid #e7e9ef;
  border-radius: 11px;
  text-align: left;
  background: #fff;
}

.join-result:hover {
  border-color: #c9b8f6;
  background: #fcfaff;
}

.result-image {
  display: grid;
  overflow: hidden;
  width: 54px;
  height: 54px;
  border-radius: 9px;
  place-items: center;
  color: #fff;
  font-size: 18px;
  font-weight: 900;
}

.join-result > div:nth-child(2) {
  min-width: 0;
}

.join-result strong,
.join-result span,
.join-result small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.join-result strong {
  color: #344054;
  font-size: 11px;
  font-weight: 900;
}

.join-result span {
  margin: 3px 0;
  color: #98a2b3;
  font-size: 9px;
}

.join-result small {
  color: #7c3aed;
  font-size: 8px;
  font-weight: 800;
}

.join-result em {
  padding: 5px 8px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  background: #f1ebff;
}

.join-result em.joined {
  color: #047857;
  background: #e9f9f2;
}

.password-step {
  min-height: 300px;
}

.selected-meeting-card {
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding: 12px;
  border: 1px solid #e8e2f8;
  border-radius: 13px;
  background: #faf8ff;
}

.selected-image {
  display: grid;
  overflow: hidden;
  width: 76px;
  height: 66px;
  border-radius: 10px;
  place-items: center;
  color: #fff;
  font-size: 25px;
  font-weight: 900;
  background: linear-gradient(145deg, #7c3aed, #c4b5fd);
}

.selected-meeting-card div:last-child > span {
  color: #8b5cf6;
  font-size: 8px;
  font-weight: 900;
}

.selected-meeting-card strong {
  display: block;
  margin-top: 3px;
  color: #344054;
  font-size: 14px;
  font-weight: 900;
}

.selected-meeting-card p {
  margin: 5px 0 0;
  color: #98a2b3;
  font-size: 9px;
}

.password-note {
  margin: 8px 0 0;
  color: #98a2b3;
  font-size: 9px;
}

.schedule-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.schedule-form .full {
  grid-column: 1/-1;
}

.schedule-options-section {
  display: flex;
  flex-direction: column;
  gap: 13px;
  padding: 16px;
  border: 1px solid #e4dcfb;
  border-radius: 13px;
  background: #faf8ff;
}

.schedule-options-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.schedule-options-heading > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.schedule-section-toggle {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 4px;
  padding: 0 7px;
  border: 0;
  border-radius: 7px;
  color: #6d28d9;
  font: inherit;
  font-size: 9px;
  font-weight: 900;
  background: transparent;
  cursor: pointer;
}

.schedule-section-toggle:hover,
.schedule-section-toggle:focus-visible {
  outline: 0;
  background: #f0eafe;
}

.schedule-section-toggle svg {
  width: 13px;
  height: 13px;
  transition: transform 160ms ease;
}

.schedule-section-toggle svg.open {
  transform: rotate(180deg);
}

.schedule-section-body {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.schedule-option-buttons {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 7px;
  width: 100%;
}

.schedule-option-buttons button {
  min-height: 34px;
  min-width: 0;
  padding: 5px 4px;
  border: 1px solid #d9d0f2;
  border-radius: 9px;
  color: #667085;
  font: inherit;
  font-size: 9px;
  font-weight: 900;
  line-height: 1.25;
  background: #fff;
  cursor: pointer;
  transition: border-color 150ms ease, color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.schedule-option-buttons button:hover:not(:disabled),
.schedule-option-buttons button:focus-visible {
  border-color: #a78bfa;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
}

.schedule-option-buttons button.active {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
}

.schedule-option-buttons button:disabled {
  border-color: #e4e7ec;
  color: #98a2b3;
  background: #f9fafb;
  cursor: not-allowed;
  opacity: 0.72;
}

.schedule-options-heading strong,
.schedule-recurrence-end > strong,
.schedule-edit-scope > strong,
.schedule-weekday-field > span {
  color: #42307d;
  font-size: 11px;
  font-weight: 900;
}

.schedule-options-heading small {
  color: #98a2b3;
  font-size: 9px;
}

.schedule-options-section select,
.schedule-options-section input[type=number],
.schedule-options-section input[type=date] {
  height: 40px;
  border: 1px solid #d9d0f2;
  border-radius: 9px;
  outline: 0;
  color: #344054;
  font-size: 11px;
  background: #fff;
}

.schedule-options-section select {
  width: 100%;
  padding: 0 34px 0 12px;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

.schedule-select-shell {
  position: relative;
  width: 100%;
  min-width: 0;
}

.schedule-select-shell > svg {
  position: absolute;
  top: 50%;
  right: 12px;
  width: 14px;
  height: 14px;
  color: #7c3aed;
  pointer-events: none;
  transform: translateY(-50%);
  transition: color 150ms ease, transform 150ms ease;
}

.schedule-select-shell:focus-within > svg {
  color: #5b21b6;
  transform: translateY(-50%) scale(1.08);
}

.schedule-recurrence-custom,
.schedule-recurrence-end,
.schedule-edit-scope,
.schedule-reminder-list,
.schedule-weekday-field {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.schedule-interval-field > div,
.schedule-compact-input,
.schedule-reminder-row,
.schedule-reminder-custom {
  display: flex;
  align-items: center;
  gap: 8px;
}

.schedule-interval-field > div,
.schedule-compact-input {
  width: max-content;
  max-width: 100%;
  flex: 0 0 auto;
  flex-wrap: nowrap;
}

.schedule-interval-field,
.schedule-interval-field > div {
  width: 100%;
}

.schedule-interval-field > div {
  max-width: none;
  flex: 1 1 auto;
}

.schedule-reminder-row {
  width: 100%;
  flex-direction: column;
  align-items: stretch;
}

.schedule-reminder-option-buttons {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.schedule-reminder-option-buttons.with-none {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.schedule-reminder-row-heading {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  color: #667085;
  font-size: 9px;
  font-weight: 900;
}

.schedule-reminder-row-heading button {
  min-height: 27px;
  padding: 0 8px;
  border: 1px solid #fecdd3;
  border-radius: 7px;
  color: #be123c;
  font: inherit;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
  cursor: pointer;
}

.schedule-reminder-custom {
  flex: 1 1 100%;
}

.schedule-interval-field input,
.schedule-compact-input input,
.schedule-reminder-custom input {
  width: 105px;
  padding: 0 10px;
}

.schedule-interval-field input {
  width: auto;
  min-width: 0;
  flex: 1 1 auto;
}

.schedule-interval-field em,
.schedule-compact-input span,
.schedule-reminder-custom span {
  color: #667085;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
  white-space: nowrap;
}

.schedule-weekday-options {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 6px;
}

.schedule-weekday-options button {
  height: 32px;
  border: 1px solid #d9d0f2;
  border-radius: 9px;
  color: #667085;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.schedule-weekday-options button.active {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
}

.schedule-radio-options,
.schedule-edit-scope label {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 15px;
}

.schedule-end-choice > label:first-child,
.schedule-edit-scope label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #475467;
  font-size: 9px;
  font-weight: 800;
}

.schedule-radio-options {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px 20px;
}

.schedule-end-choice {
  display: flex;
  width: 100%;
  min-width: 0;
  gap: 7px;
}

.schedule-count-choice {
  align-items: center;
  flex-wrap: nowrap;
}

.schedule-count-choice .schedule-compact-input {
  width: auto;
  max-width: none;
  min-width: 0;
  flex: 1 1 auto;
}

.schedule-count-choice .schedule-compact-input input {
  width: auto;
  min-width: 0;
  flex: 1 1 auto;
}

.schedule-date-choice {
  align-items: flex-start;
  flex-direction: column;
  gap: 5px;
}

.schedule-date-input {
  position: relative;
  width: calc(100% - 20px);
  max-width: none;
  margin-left: 20px;
}

.schedule-date-input input {
  width: 100%;
  min-width: 0;
}

.schedule-reminder-add {
  min-height: 34px;
  border: 1px solid #d9d0f2;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.schedule-reminder-add {
  align-self: stretch;
  width: 100%;
  padding: 0 11px;
}

.schedule-reminder-add:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.schedule-all-day-toggle {
  position: relative;
  display: flex;
  width: max-content;
  min-height: 20px;
  justify-self: end;
  align-items: center;
  gap: 7px;
  margin-bottom: -8px;
  cursor: pointer;
}

.schedule-all-day-toggle:has(.styled-checkbox-input:disabled) {
  cursor: not-allowed;
  opacity: 0.58;
}

.schedule-all-day-toggle .styled-checkbox-box {
  width: 17px;
  height: 17px;
  margin: 0;
  border-radius: 5px;
}

.schedule-all-day-label {
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.schedule-place-link-input {
  display: flex;
  align-items: stretch;
  gap: 7px;
}

.schedule-place-link-input input {
  min-width: 0;
  flex: 1;
}

.schedule-place-link-input button {
  flex: 0 0 auto;
  padding: 0 12px;
  border: 1px solid #d9d0f2;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.schedule-place-link-input button:disabled {
  cursor: not-allowed;
  color: #98a2b3;
  background: #f6f7f9;
}

.schedule-place-reference {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #e7e1f7;
  border-radius: 9px;
  color: #667085;
  font-size: 9px;
  background: #faf8ff;
}

.schedule-place-reference a,
.schedule-detail-place-link {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  text-decoration: none;
}

.schedule-place-reference > div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.schedule-place-reference button {
  min-height: 26px;
  padding: 0 8px;
  border: 1px solid #d9d0f2;
  border-radius: 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
}

.schedule-place-reference button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.schedule-place-reference svg {
  width: 12px;
  height: 12px;
}

.schedule-participant-picker {
  padding: 12px;
  border: 1px solid #e2e5ec;
  border-radius: 10px;
  background: #fafbfc;
}

.schedule-participant-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
}

.schedule-participant-heading strong,
.schedule-participant-heading span {
  display: block;
}

.schedule-participant-heading strong {
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.schedule-participant-heading span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 8px;
}

.schedule-participant-heading button {
  min-height: 27px;
  padding: 0 9px;
  border: 1px solid #d9d0f2;
  border-radius: 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
}

.schedule-participant-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.schedule-participant {
  position: relative;
  display: grid;
  grid-template-columns: 18px 23px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  min-width: 0;
  padding: 8px;
  border: 1px solid #e6e8ee;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}

.schedule-participant:has(.styled-checkbox-input:checked) {
  border-color: #c4b5fd;
  background: #faf8ff;
}

.schedule-participant .styled-checkbox-box {
  width: 17px;
  height: 17px;
  margin: 0;
}

.schedule-participant .avatar {
  width: 23px;
  height: 23px;
}

.schedule-participant-copy {
  min-width: 0;
}

.schedule-participant-copy strong,
.schedule-participant-copy em {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-participant-copy strong {
  color: #475467;
  font-size: 9px;
  font-weight: 900;
}

.schedule-participant-copy em {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 7px;
  font-style: normal;
}

@media (max-width: 1050px) {
  .meeting-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .detail-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .members-panel {
    order: -1;
  }
}
@media (max-width: 780px) {
  .meetings-page {
    padding: 24px max(18px, env(safe-area-inset-right)) max(42px, env(safe-area-inset-bottom)) max(18px, env(safe-area-inset-left));
  }
  .page-header,
  .section-heading {
    align-items: stretch;
    flex-direction: column;
  }
  .header-actions {
    width: 100%;
    padding-top: 0;
  }
  .header-actions button {
    flex: 1;
  }
  .summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .search-field {
    width: 100%;
  }
  .meeting-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .discover-banner {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .discover-art {
    display: none;
  }
  .banner-button {
    justify-self: start;
  }
  .detail-hero,
  .detail-loading-shell {
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-cover,
  .detail-loading-cover {
    height: 190px;
  }
  .detail-action {
    width: 100%;
  }
  .schedule-item {
    grid-template-columns: minmax(0, 1fr);
  }
  .date-block {
    padding: 0 0 10px;
    border-right: 0;
    border-bottom: 1px solid #eaecf2;
  }
  .form-layout,
  .schedule-form {
    grid-template-columns: minmax(0, 1fr);
  }
  .schedule-form .full {
    grid-column: auto;
  }
  .image-uploader {
    height: 150px;
  }
}
@media (max-width: 520px) {
  .modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .modal-card {
    max-height: 94vh;
    max-height: 94dvh;
    border-radius: 18px 18px 0 0;
  }
  .modal-header,
  .modal-body,
  .modal-footer {
    padding-right: 18px;
    padding-left: 18px;
  }
  .modal-footer .primary-button,
  .modal-footer .cancel-button {
    flex: 1;
  }
  .modal-footer {
    padding-bottom: max(15px, env(safe-area-inset-bottom));
  }
  .summary-card {
    min-height: 72px;
  }
  .meetings-section {
    padding: 17px;
  }
}
.detail-actions {
  display: flex;
  align-self: start;
  gap: 9px;
}

.detail-actions .secondary-button,
.detail-actions .primary-button {
  min-height: 40px;
  padding: 0 14px;
  white-space: nowrap;
}

.detail-actions svg {
  width: 16px;
  height: 16px;
}

.detail-actions .poll-create-button {
  border-color: #a78bfa;
  color: #7c3aed;
  background: #fbf9ff;
}

.detail-actions .poll-create-button svg {
  color: #7c3aed;
}

.detail-actions .poll-create-button:hover {
  border-color: #7c3aed;
  color: #6d28d9;
  background: #f3efff;
  box-shadow: 0 7px 16px rgba(124, 58, 237, 0.1);
}

.detail-actions .meeting-settings-button {
  border-color: #d7dce7;
  color: #475467;
}

.detail-actions .meeting-leave-button {
  border-color: #fecdd3;
  color: #be123c;
  background: #fffafb;
}

.detail-actions .meeting-leave-button:hover {
  border-color: #fda4af;
  color: #9f1239;
  background: #fff1f3;
}

.detail-content {
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
}

.detail-tabs {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 11px;
  padding: 5px;
  border: 1px solid rgba(219, 224, 235, 0.95);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 8px 24px rgba(34, 25, 60, 0.04);
}

.detail-tabs button {
  display: flex;
  min-height: 39px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 17px;
  border: 0;
  border-radius: 9px;
  color: #7b8494;
  font-size: 11px;
  font-weight: 800;
  background: transparent;
}

.detail-tabs button.active {
  color: #6d28d9;
  background: #f2edff;
}

.detail-tabs em {
  display: grid;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  place-items: center;
  border-radius: 999px;
  font-size: 8px;
  font-style: normal;
  background: rgba(124, 58, 237, 0.08);
}

.detail-tab-panel {
  min-height: 355px;
}

.schedule-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.schedule-mine-filter {
  display: flex;
  min-height: 37px;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #d9ddea;
  border-radius: 9px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
}

.schedule-mine-filter.active {
  border-color: #a78bfa;
  color: #6d28d9;
  background: #f5f1ff;
}

@media (hover: hover) and (pointer: fine) {
  .schedule-mine-filter:hover {
    border-color: #a78bfa;
    color: #6d28d9;
    background: #f5f1ff;
  }
}
.schedule-mine-filter.active {
  box-shadow: inset 0 0 0 1px rgba(124, 58, 237, 0.12);
}

.schedule-mine-filter svg {
  width: 15px;
  height: 15px;
}

.schedule-mine-filter em {
  display: grid;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 999px;
  place-items: center;
  color: #7c3aed;
  font-size: 7px;
  font-style: normal;
  background: #eee8ff;
}

.view-toggle {
  display: flex;
  gap: 2px;
  padding: 3px;
  border: 1px solid #e5e8ef;
  border-radius: 9px;
  background: #f8f9fb;
}

.view-toggle button {
  display: flex;
  height: 31px;
  align-items: center;
  gap: 5px;
  padding: 0 10px;
  border: 0;
  border-radius: 7px;
  color: #98a2b3;
  font-size: 9px;
  font-weight: 800;
  background: transparent;
}

.view-toggle button.active {
  color: #6d28d9;
  background: #fff;
  box-shadow: 0 2px 7px rgba(55, 35, 89, 0.09);
}

.view-toggle svg {
  width: 14px;
  height: 14px;
}

.panel-empty-actions {
  display: flex;
  gap: 6px;
}

.subsection-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 11px;
}

.subsection-heading > div > span {
  color: #344054;
  font-size: 12px;
  font-weight: 900;
}

.subsection-heading p {
  margin: 3px 0 0;
  color: #98a2b3;
  font-size: 9px;
}

.poll-section,
.schedule-list-section {
  margin-top: 19px;
}

.schedule-list-section {
  padding-top: 18px;
  border-top: 1px solid #eff1f5;
}

.schedule-list-section.schedule-only-list {
  margin-top: 18px;
  padding-top: 0;
  border-top: 0;
}

.poll-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.poll-card {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 112px;
  padding: 14px;
  border: 1px solid #e6e1f5;
  border-left-width: 3px;
  border-radius: 12px;
  text-align: left;
  background: #fcfaff;
  transition: transform 150ms ease, border-color 150ms ease, box-shadow 150ms ease;
}

.poll-card.place {
  border-color: #dceee9 #dceee9 #dceee9 #98a2b3;
  background: #f8fcfb;
}

.poll-card.poll-open {
  border-left-color: #12b76a;
}

.poll-card.poll-closed {
  border-left-color: #98a2b3;
}

.poll-card.poll-stopped {
  border-left-color: #f04438;
}

.poll-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(71, 44, 118, 0.08);
}

.poll-card-icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 11px;
  color: #7c3aed;
  background: #eee8ff;
}

.poll-card.place .poll-card-icon {
  color: #047857;
  background: #e5f7f0;
}

.poll-card-icon svg {
  width: 20px;
  height: 20px;
}

.poll-card-copy {
  min-width: 0;
}

.poll-card-labels {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
}

.poll-kind-badge {
  flex: 0 0 auto;
  padding: 3px 6px;
  border-radius: 99px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #eee8ff;
}

.poll-card.place .poll-kind-badge {
  color: #047857;
  background: #e5f7f0;
}

.poll-card-copy strong,
.poll-card-copy p,
.poll-card-status-description {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.poll-card-copy strong {
  margin-top: 6px;
  color: #344054;
  font-size: 12px;
  font-weight: 900;
}

.poll-card-copy p {
  margin: 4px 0 0;
  color: #7b8494;
  font-size: 8px;
}

.poll-card-status-description {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 7px;
  font-weight: 700;
}

.participation-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 3px;
  padding: 3px 7px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
}

.participation-badge.joined {
  color: #175cd3;
  background: #eaf2ff;
}

.participation-badge.joined::before {
  content: "✓";
}

.participation-badge.not-joined {
  color: #7b8494;
  background: #f0f2f5;
}

.poll-card-side {
  display: flex;
  height: 100%;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
}

.poll-card-status {
  display: inline-flex;
  min-width: 62px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 6px 8px;
  border: 1px solid #a6f4c5;
  border-radius: 8px;
  color: #027a48;
  font-size: 8px;
  font-weight: 900;
  background: #ecfdf3;
  white-space: nowrap;
}

.poll-card-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #12b76a;
}

.poll-card-status.ended {
  border-color: #d0d5dd;
  color: #475467;
  background: #f2f4f7;
}

.poll-card-status.ended i {
  background: #98a2b3;
}

.poll-card-status.stopped {
  border-color: #fecdca;
  color: #b42318;
  background: #fef3f2;
}

.poll-card-status.stopped i {
  background: #f04438;
}

.poll-arrow,
.schedule-arrow {
  width: 16px;
  height: 16px;
  color: #b9bfca;
}

.schedule-item {
  position: relative;
  width: 100%;
  grid-template-columns: 210px minmax(0, 1fr) 18px;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.schedule-item:hover {
  border-color: #d5cafa;
  background: #fff;
  box-shadow: 0 8px 18px rgba(68, 45, 107, 0.055);
}

.schedule-content {
  min-width: 0;
}

.schedule-participant-preview {
  display: flex;
  max-width: 560px;
  min-width: 0;
  align-items: flex-start;
  gap: 8px;
  margin-top: 10px;
}

.schedule-participant-label {
  flex: 0 0 auto;
  padding-top: 4px;
  color: #98a2b3;
  font-size: 7px;
  font-weight: 800;
}

.schedule-participant-people {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 10px;
}

.schedule-participant-person {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.schedule-participant-avatar {
  display: grid;
  overflow: hidden;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 7px;
  font-weight: 900;
  background: linear-gradient(145deg, #7c3aed, #a78bfa);
}

.schedule-participant-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.schedule-participant-avatar em {
  font-style: normal;
}

.schedule-participant-name,
.schedule-no-participant {
  color: #475467;
  font-size: 9px;
  font-weight: 800;
  white-space: nowrap;
}

.schedule-my-participation {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  color: #667085;
  font-size: 7px;
  font-weight: 900;
  background: #eef0f4;
  white-space: nowrap;
}

.schedule-my-participation.joined {
  color: #175cd3;
  background: #eff6ff;
}

.schedule-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 16px;
}

.schedule-pagination button {
  display: grid;
  width: 31px;
  height: 31px;
  padding: 0;
  border: 1px solid #e2e5ec;
  border-radius: 8px;
  place-items: center;
  color: #667085;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.schedule-pagination button:hover:not(:disabled),
.schedule-pagination button.active {
  border-color: #c4b5fd;
  color: #6d28d9;
  background: #f5f1ff;
}

.schedule-pagination button.active {
  box-shadow: inset 0 0 0 1px #c4b5fd;
}

.schedule-pagination button:disabled {
  cursor: default;
  opacity: 0.35;
}

.schedule-pagination svg {
  width: 13px;
  height: 13px;
}

.poll-filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-top: 18px;
  padding: 12px 13px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  background: #f8f9fb;
}

.poll-filter-title {
  display: flex;
  min-width: 145px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  padding-right: 13px;
  border-right: 1px solid #e1e4ea;
}

.poll-filter-title svg {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  color: #7c3aed;
}

.poll-filter-title strong,
.poll-filter-title small {
  display: block;
}

.poll-filter-title strong {
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.poll-filter-title small {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 7px;
  white-space: nowrap;
}

.poll-select-filter {
  min-width: 170px;
  flex: 1 1 190px;
}

.poll-select-filter > span {
  display: block;
  margin: 0 0 5px 2px;
  color: #667085;
  font-size: 8px;
  font-weight: 900;
}

.poll-select-control {
  position: relative;
}

.poll-select-control select {
  width: 100%;
  height: 34px;
  appearance: none;
  padding: 0 34px 0 11px;
  border: 1px solid #e3e0ea;
  border-radius: 8px;
  outline: 0;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
  cursor: pointer;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.poll-select-control svg {
  position: absolute;
  top: 50%;
  right: 10px;
  width: 13px;
  height: 13px;
  color: #98a2b3;
  pointer-events: none;
  transform: translateY(-50%);
}

.kind-filter .poll-select-control:focus-within select {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.status-filter .poll-select-control:focus-within select {
  border-color: #84adf4;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}

.poll-filter-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
}

.poll-mine-toggle,
.poll-filter-reset {
  display: flex;
  height: 34px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #d9ddea;
  border-radius: 8px;
  color: #667085;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
  white-space: nowrap;
}

.poll-mine-toggle svg,
.poll-filter-reset svg {
  width: 14px;
  height: 14px;
}

.poll-mine-toggle em {
  display: grid;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 999px;
  place-items: center;
  color: #175cd3;
  font-size: 7px;
  font-style: normal;
  background: #eaf2ff;
}

.poll-mine-toggle:hover,
.poll-mine-toggle.active {
  border-color: #84adf4;
  color: #175cd3;
  background: #eff6ff;
}

.poll-mine-toggle.active {
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.1);
}

.poll-filter-reset {
  color: #7b8494;
}

.poll-filter-reset:hover {
  border-color: #b9c0cb;
  color: #475467;
  background: #f2f4f7;
}

.poll-tab-grid {
  margin-top: 14px;
}

.filter-empty {
  display: grid;
  min-height: 185px;
  place-content: center;
  text-align: center;
}

.filter-empty strong {
  color: #475467;
  font-size: 12px;
  font-weight: 900;
}

.filter-empty p {
  margin: 5px 0 0;
  color: #98a2b3;
  font-size: 9px;
}

.schedule-filter-empty button {
  justify-self: center;
  margin-top: 11px;
  padding: 7px 10px;
  border: 1px solid #c4b5fd;
  border-radius: 8px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #f5f1ff;
}

.calendar-view {
  margin-top: 18px;
}

.calendar-poll-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 13px;
  padding: 10px 12px;
  border: 1px solid #e5dcfb;
  border-radius: 10px;
  background: #faf8ff;
}

.calendar-poll-banner strong,
.calendar-poll-banner span {
  display: block;
}

.calendar-poll-banner strong {
  color: #5b21b6;
  font-size: 10px;
  font-weight: 900;
}

.calendar-poll-banner span {
  margin-top: 2px;
  color: #988ca8;
  font-size: 8px;
}

.calendar-poll-banner button {
  flex: 0 0 auto;
  padding: 6px 9px;
  border: 0;
  border-radius: 7px;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
  background: #7c3aed;
}

.calendar-toolbar,
.calendar-nav {
  display: flex;
  align-items: center;
}

.calendar-toolbar {
  justify-content: space-between;
  margin-bottom: 11px;
}

.calendar-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.calendar-drag-hint {
  color: #8a759f;
  font-size: 8px;
  font-weight: 700;
}

.calendar-nav {
  gap: 8px;
}

.calendar-nav h3 {
  min-width: 116px;
  margin: 0;
  color: #344054;
  font-size: 13px;
  font-weight: 900;
  text-align: center;
}

.calendar-nav button,
.today-button {
  display: grid;
  height: 30px;
  border: 1px solid #e3e6ed;
  border-radius: 8px;
  place-items: center;
  color: #667085;
  background: #fff;
}

.calendar-nav button {
  width: 30px;
  padding: 0;
}

.calendar-nav svg {
  width: 14px;
  height: 14px;
}

.today-button {
  padding: 0 10px;
  font-size: 9px;
  font-weight: 800;
}

.calendar-weekdays,
.calendar-week {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.calendar-weekdays {
  border: 1px solid #e6e9ef;
  border-bottom: 0;
  border-radius: 10px 10px 0 0;
  background: #f8f9fb;
}

.calendar-weekdays span {
  padding: 8px 4px;
  color: #98a2b3;
  font-size: 8px;
  font-weight: 900;
  text-align: center;
}

.calendar-weekdays span:first-child {
  color: #e11d48;
}

.calendar-grid {
  overflow: hidden;
  border-top: 1px solid #e6e9ef;
  border-left: 1px solid #e6e9ef;
  border-radius: 0 0 10px 10px;
}

.calendar-week {
  position: relative;
}

.calendar-day {
  position: relative;
  overflow: hidden;
  min-width: 0;
  min-height: 100%;
  padding: 7px;
  border-right: 1px solid #e6e9ef;
  border-bottom: 1px solid #e6e9ef;
  background: #fff;
}

.calendar-week-events {
  position: absolute;
  z-index: 2;
  top: 36px;
  right: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-auto-rows: 30px;
  gap: 3px 0;
  pointer-events: none;
}

.calendar-day.outside {
  background: #fafbfc;
}

.calendar-day-number {
  display: grid;
  width: 22px;
  height: 22px;
  place-items: center;
  border-radius: 999px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
}

.calendar-day.outside .calendar-day-number {
  color: #c5cad3;
}

.calendar-day.today .calendar-day-number {
  color: #fff;
  background: #7c3aed;
}

.calendar-day.drag-target {
  z-index: 4;
  background: #f3efff;
  box-shadow: inset 0 0 0 2px #8b5cf6;
}

.calendar-day.drag-target::after {
  position: absolute;
  z-index: 4;
  inset: 5px;
  border: 1px dashed #8b5cf6;
  border-radius: 8px;
  content: "";
  pointer-events: none;
}

.calendar-day.drag-target .calendar-day-number {
  position: relative;
  z-index: 5;
  color: #6d28d9;
  background: #ede9fe;
}

.calendar-drop-indicator {
  position: absolute;
  z-index: 6;
  top: 50%;
  left: 50%;
  display: inline-flex;
  max-width: calc(100% - 12px);
  padding: 5px 7px;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
  background: #7c3aed;
  box-shadow: 0 6px 16px rgba(109, 40, 217, 0.3);
  pointer-events: none;
  transform: translate(-50%, -50%);
}

.calendar-drop-indicator svg {
  width: 11px;
  height: 11px;
  flex: 0 0 auto;
}

.calendar-drop-indicator span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.calendar-add-button {
  position: absolute;
  z-index: 3;
  top: 7px;
  right: 7px;
  display: grid;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1px solid #c4b5fd;
  border-radius: 6px;
  place-items: center;
  opacity: 0;
  pointer-events: none;
  color: #7c3aed;
  background: #f5f3ff;
  box-shadow: 0 2px 6px rgba(124, 58, 237, 0.14);
  transform: translateY(-2px);
  transition: opacity 0.16s ease, color 0.16s ease, background 0.16s ease, transform 0.16s ease;
}

.calendar-add-button svg {
  width: 12px;
  height: 12px;
}

.calendar-day:hover .calendar-add-button,
.calendar-day:focus-within .calendar-add-button,
.calendar-add-button:focus-visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.calendar-add-button:hover {
  color: #fff;
  background: #7c3aed;
}

.calendar-add-button:focus-visible {
  outline: 2px solid #8b5cf6;
  outline-offset: 2px;
}

.calendar-events {
  display: grid;
  gap: 3px;
  margin-top: 4px;
}

.calendar-event {
  overflow: hidden;
  width: 100%;
  padding: 4px 5px;
  border: 0;
  border-radius: 5px;
  text-align: left;
}

.calendar-week-events .calendar-event {
  width: auto;
  height: 30px;
  margin: 0 7px;
  padding: 2px 6px;
  pointer-events: auto;
}

.calendar-event span {
  display: block;
  overflow: hidden;
  color: #475467;
  font-size: 7px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-event.schedule {
  background: #ede9fe;
}

.calendar-event.schedule.draggable {
  cursor: grab;
}

.calendar-event.schedule.draggable:active {
  cursor: grabbing;
}

.calendar-event.schedule.dragging {
  opacity: 0.45;
}

.calendar-event.schedule.moving {
  cursor: wait;
  opacity: 0.65;
}

.calendar-event.schedule.multi-day {
  background: linear-gradient(90deg, #ddd6fe, #ede9fe);
  box-shadow: inset 3px 0 #8b5cf6;
}

.calendar-event.schedule span {
  color: #6d28d9;
}

.calendar-event.schedule {
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  gap: 1px;
}

.calendar-event-main,
.calendar-event-participants {
  display: flex !important;
  min-width: 0;
  align-items: center;
}

.calendar-event-main {
  gap: 4px;
}

.calendar-memory-thumb {
  display: block !important;
  overflow: hidden !important;
  width: 18px;
  height: 18px;
  margin-left: auto;
  flex: 0 0 auto;
  border: 1px solid rgba(124, 58, 237, 0.18);
  border-radius: 5px;
  background: #fff;
}

.calendar-memory-thumb img,
.schedule-memory-thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.calendar-event-participants {
  overflow: hidden !important;
  gap: 5px;
}

.calendar-participant-person {
  display: inline-flex !important;
  overflow: visible !important;
  min-width: 0;
  flex: 0 0 auto;
  align-items: center;
  gap: 2px;
}

.calendar-participant-avatar {
  display: grid !important;
  overflow: hidden !important;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  place-items: center;
  color: #fff !important;
  font-size: 5px !important;
  line-height: 1;
  background: #8b5cf6;
}

.calendar-participant-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.calendar-participant-avatar em {
  font-style: normal;
}

.calendar-event.schedule .calendar-participant-name,
.calendar-event.schedule .calendar-no-participant {
  color: #7f6aaf;
  font-size: 6px;
  font-weight: 800;
}

.calendar-event.schedule .calendar-event-time {
  flex: 0 0 auto;
  color: #7c3aed;
  font-size: 6px;
  font-variant-numeric: tabular-nums;
}

.calendar-event.schedule .calendar-event-title {
  min-width: 0;
  flex: 1;
}

.calendar-event.poll {
  background: #e7f8f2;
}

.calendar-event.poll span {
  color: #047857;
}

@media (hover: none) {
  .calendar-add-button {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
}
.member-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28px;
}

.poll-create-modal {
  max-width: 720px;
}

.vote-modal {
  display: flex;
  max-width: 1180px;
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  flex-direction: column;
}

.schedule-detail-modal {
  max-width: 860px;
}

.schedule-detail-modal.itinerary-mode {
  max-width: 900px;
}

.poll-create-body,
.schedule-detail-body {
  max-height: calc(100vh - 205px);
  max-height: calc(100dvh - 205px);
}

.vote-body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  padding: 25px 30px;
}

.vote-modal .modal-header,
.vote-modal .modal-footer {
  flex: 0 0 auto;
}

.vote-modal .modal-header {
  padding: 25px 30px 21px;
}

.vote-modal .modal-header h2 {
  font-size: 22px;
}

.vote-modal .modal-header p {
  font-size: 12px;
}

.vote-modal .modal-kicker {
  font-size: 10px;
}

.vote-modal .modal-footer {
  position: relative;
  z-index: 2;
  padding: 16px 30px;
  box-shadow: 0 -8px 18px rgba(52, 64, 84, 0.05);
}

.poll-kind-selector {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 18px;
}

.poll-kind-selector button {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 11px;
  border: 1px solid #e2e5ec;
  border-radius: 11px;
  text-align: left;
  background: #fff;
}

.poll-kind-selector button.active {
  border-color: #a78bfa;
  background: #faf8ff;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.07);
}

.poll-kind-selector svg {
  width: 24px;
  height: 24px;
  color: #8b5cf6;
}

.poll-kind-selector span,
.poll-kind-selector strong,
.poll-kind-selector em {
  display: block;
}

.poll-kind-selector strong {
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.poll-kind-selector em {
  margin-top: 3px;
  color: #98a2b3;
  font-size: 8px;
  font-style: normal;
}

.poll-basic-fields {
  display: grid;
  gap: 13px;
}

.schedule-mode-selector {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
}

.schedule-mode-selector button {
  padding: 11px 12px;
  border: 1px solid #e1e5ec;
  border-radius: 10px;
  text-align: left;
  background: #fff;
}

.schedule-mode-selector button.active {
  border-color: #a78bfa;
  background: #faf8ff;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.07);
}

.schedule-mode-selector strong,
.schedule-mode-selector span {
  display: block;
}

.place-choice-selector {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 11px;
}

.place-choice-selector button {
  padding: 10px 11px;
  border: 1px solid #e1e5ec;
  border-radius: 9px;
  color: #667085;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.place-choice-selector button.active {
  border-color: #a78bfa;
  color: #6d28d9;
  background: #faf8ff;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.06);
}

.schedule-mode-selector strong {
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.schedule-mode-selector span {
  margin-top: 3px;
  color: #98a2b3;
  font-size: 8px;
  line-height: 1.45;
}

.poll-option-builder,
.created-options {
  margin-top: 17px;
  padding-top: 16px;
  border-top: 1px solid #eff1f5;
}

.builder-heading strong,
.builder-heading span {
  display: block;
}

.builder-heading strong,
.created-options-heading strong {
  color: #344054;
  font-size: 11px;
  font-weight: 900;
}

.builder-heading span {
  margin-top: 3px;
  color: #98a2b3;
  font-size: 8px;
}

.range-fields {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18px minmax(0, 1fr);
  align-items: end;
  gap: 8px;
  margin-top: 11px;
}

.range-separator {
  padding-bottom: 11px;
  color: #98a2b3;
  font-size: 10px;
  text-align: center;
}

.option-add-row {
  display: grid;
  align-items: end;
  gap: 8px;
  margin-top: 10px;
}

.schedule-option-add {
  grid-template-columns: minmax(0, 1.3fr) minmax(120px, 0.7fr) 62px;
}

.place-option-add {
  grid-template-columns: minmax(0, 1fr) 62px;
}

.place-option-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 11px;
}

.place-option-fields .full {
  grid-column: 1/-1;
}

.place-address-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px;
  align-items: end;
  gap: 8px;
}

.address-lookup-button {
  height: 40px;
  border: 1px solid #c4b5fd;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f7f3ff;
}

.address-lookup-button:disabled {
  cursor: default;
  opacity: 0.45;
}

.place-option-media {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-top: 9px;
}

.place-image-picker {
  overflow: hidden;
  width: 112px;
  height: 64px;
  padding: 0;
  border: 1px dashed #c9baf3;
  border-radius: 9px;
  color: #7c3aed;
  background: #faf8ff;
}

.place-image-picker img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.place-image-placeholder {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  font-size: 8px;
}

.place-image-placeholder svg {
  width: 20px;
  height: 20px;
}

.place-image-placeholder strong {
  font-size: 8px;
}

.place-image-remove {
  min-height: 32px;
  padding: 0 9px;
  border: 0;
  border-radius: 8px;
  color: #e11d48;
  font-size: 8px;
  font-weight: 800;
  background: #fff1f3;
}

.place-option-media .option-add-button {
  width: 78px;
  margin-left: auto;
}

.option-add-button {
  height: 40px;
  border: 1px solid #c4b5fd;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  background: #f7f3ff;
}

.option-add-button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.allow-option-additions {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 11px;
  padding: 10px 11px;
  border-radius: 9px;
  background: #f8f7fc;
  cursor: pointer;
}

.allow-option-additions .styled-checkbox-copy,
.allow-option-additions strong,
.allow-option-additions em {
  display: block;
}

.allow-option-additions strong {
  color: #475467;
  font-size: 9px;
  font-weight: 900;
}

.allow-option-additions em {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 8px;
  font-style: normal;
}

.styled-checkbox-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.styled-checkbox-box {
  display: grid !important;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  border: 1px solid #cfd4dc;
  border-radius: 6px;
  place-items: center;
  color: #fff;
  background: #fff;
  transition: border-color 140ms ease, background 140ms ease, box-shadow 140ms ease;
}

.styled-checkbox-box svg {
  width: 12px;
  height: 12px;
}

.styled-checkbox-input:checked + .styled-checkbox-box {
  border-color: #7c3aed;
  background: #7c3aed;
  box-shadow: 0 3px 8px rgba(124, 58, 237, 0.2);
}

.styled-checkbox-input:focus-visible + .styled-checkbox-box {
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.16);
}

.calendar-mode-guide {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 11px;
  padding: 12px;
  border: 1px solid #e4dcfb;
  border-radius: 10px;
  color: #7c3aed;
  background: #faf8ff;
}

.calendar-mode-guide svg {
  flex: 0 0 auto;
  width: 23px;
  height: 23px;
}

.calendar-mode-guide strong,
.calendar-mode-guide span {
  display: block;
}

.calendar-mode-guide strong {
  color: #5b21b6;
  font-size: 9px;
  font-weight: 900;
}

.calendar-mode-guide span {
  margin-top: 2px;
  color: #8d83a0;
  font-size: 8px;
}

.created-options-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.created-options-heading span {
  color: #8b5cf6;
  font-size: 9px;
  font-weight: 900;
}

.created-options-empty {
  margin-top: 9px;
  padding: 15px;
  border: 1px dashed #dfe3eb;
  border-radius: 9px;
  color: #a2a8b3;
  font-size: 8px;
  text-align: center;
  background: #fbfcfd;
}

.created-option-list {
  display: grid;
  gap: 6px;
  margin-top: 9px;
}

.created-option {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 26px;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 5px 7px;
  border: 1px solid #e9ebf0;
  border-radius: 8px;
  background: #fcfcfd;
}

.created-option.has-image {
  grid-template-columns: 24px 38px minmax(0, 1fr) 26px;
}

.created-option-image {
  width: 38px;
  height: 30px;
  border-radius: 6px;
  object-fit: cover;
}

.option-order {
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border-radius: 7px;
  color: #7c3aed;
  font-size: 8px;
  font-weight: 900;
  background: #f0ebff;
}

.created-option-copy {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}

.created-option-copy strong {
  display: block;
  overflow: hidden;
  color: #475467;
  font-size: 9px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.created-option-copy > div {
  min-width: 0;
}

.created-option-copy small {
  display: block;
  overflow: hidden;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.created-option-copy span {
  flex: 0 0 auto;
  padding: 2px 5px;
  border-radius: 99px;
  color: #7c3aed;
  font-size: 7px;
  font-weight: 800;
  background: #f1eafe;
}

.created-option button {
  display: grid;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 0;
  place-items: center;
  color: #a5abb5;
  background: transparent;
}

.created-option button:hover {
  color: #e11d48;
}

.created-option svg {
  width: 13px;
  height: 13px;
}

.multi-select-note {
  margin-right: auto;
  color: #98a2b3;
  font-size: 8px;
}

.poll-inline-message {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 12px;
  padding: 9px 10px;
  border-radius: 9px;
  font-size: 9px;
  font-weight: 800;
}

.poll-inline-message svg {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}

.poll-inline-message.error {
  border: 1px solid #fecdd3;
  color: #be123c;
  background: #fff1f3;
}

.poll-inline-message.success {
  border: 1px solid #bbf7d0;
  color: #047857;
  background: #ecfdf3;
}

.finalized-schedule-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid #bbf7d0;
  border-radius: 9px;
  color: #047857;
  font-size: 9px;
  font-weight: 800;
  background: #ecfdf3;
}

.finalized-schedule-notice button {
  min-height: 28px;
  flex: 0 0 auto;
  padding: 0 10px;
  border: 1px solid #86efac;
  border-radius: 7px;
  color: #047857;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
}

.finalized-schedule-notice button:hover {
  border-color: #22c55e;
  background: #f0fdf4;
}

.vote-guide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 9px;
  background: #f7f4ff;
}

.vote-guide strong,
.vote-guide span {
  display: block;
}

.vote-guide strong {
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
}

.vote-guide span {
  margin-top: 2px;
  color: #91869e;
  font-size: 8px;
}

.vote-guide em {
  flex: 0 0 auto;
  color: #7c3aed;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.poll-status-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 11px;
  padding: 8px 10px;
  border: 1px solid #ece8f6;
  border-radius: 9px;
  color: #667085;
  font-size: 8px;
  background: #fcfbff;
}

.poll-status-meta > span:last-child {
  min-width: 0;
  flex: 1;
  text-align: right;
}

.poll-status-badge {
  flex: 0 0 auto;
  padding: 3px 7px;
  border-radius: 99px;
  color: #6d28d9;
  font-weight: 900;
  background: #eee8ff;
}

.poll-status-badge.stopped {
  color: #b42318;
  background: #fee4e2;
}

.poll-status-badge.ended {
  color: #667085;
  background: #eaecf0;
}

.vote-option-list {
  display: grid;
  gap: 8px;
}

.poll-vote-calendar {
  margin-bottom: 14px;
  padding: 13px;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  background: #fcfcfd;
}

.poll-calendar-toolbar {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) 30px;
  align-items: center;
  margin-bottom: 10px;
}

.poll-calendar-toolbar strong {
  color: #344054;
  font-size: 11px;
  font-weight: 900;
  text-align: center;
}

.poll-calendar-toolbar button {
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid #e2e5eb;
  border-radius: 8px;
  place-items: center;
  color: #667085;
  background: #fff;
}

.poll-calendar-toolbar button:disabled {
  cursor: default;
  opacity: 0.35;
}

.poll-calendar-toolbar svg {
  width: 14px;
  height: 14px;
}

.poll-calendar-weekdays,
.poll-calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.poll-calendar-weekdays span {
  padding: 4px 0 6px;
  color: #98a2b3;
  font-size: 8px;
  font-weight: 800;
  text-align: center;
}

.poll-calendar-grid {
  gap: 4px;
}

.poll-calendar-grid button {
  position: relative;
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1px;
  padding: 4px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #475467;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
}

.poll-day-number {
  font-size: 9px;
}

.poll-day-voters {
  display: flex;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.poll-day-voter,
.mini-voter-avatar,
.user-color-dot,
.availability-color-bar {
  display: block;
  flex: 0 0 auto;
  border-radius: 99px;
}

.poll-day-voter {
  overflow: hidden;
  width: 10px;
  height: 10px;
  border: 1px solid rgba(255, 255, 255, 0.85);
}

.mini-voter-avatar {
  overflow: hidden;
  width: 13px;
  height: 13px;
}

.poll-day-voter.violet,
.mini-voter-avatar.violet,
.user-color-dot.violet,
.availability-color-bar.violet {
  background: #7c3aed;
}

.poll-day-voter.rose,
.mini-voter-avatar.rose,
.user-color-dot.rose,
.availability-color-bar.rose {
  background: #e11d48;
}

.poll-day-voter.blue,
.mini-voter-avatar.blue,
.user-color-dot.blue,
.availability-color-bar.blue {
  background: #2563eb;
}

.poll-day-voter.emerald,
.mini-voter-avatar.emerald,
.user-color-dot.emerald,
.availability-color-bar.emerald {
  background: #059669;
}

.poll-day-voter.amber,
.mini-voter-avatar.amber,
.user-color-dot.amber,
.availability-color-bar.amber {
  background: #d97706;
}

.poll-day-voter.cyan,
.mini-voter-avatar.cyan,
.user-color-dot.cyan,
.availability-color-bar.cyan {
  background: #0891b2;
}

.poll-day-voter.pink,
.mini-voter-avatar.pink,
.user-color-dot.pink,
.availability-color-bar.pink {
  background: #db2777;
}

.poll-day-voter.indigo,
.mini-voter-avatar.indigo,
.user-color-dot.indigo,
.availability-color-bar.indigo {
  background: #4f46e5;
}

.poll-day-voter.lime,
.mini-voter-avatar.lime,
.user-color-dot.lime,
.availability-color-bar.lime {
  background: #65a30d;
}

.poll-day-voter.orange,
.mini-voter-avatar.orange,
.user-color-dot.orange,
.availability-color-bar.orange {
  background: #ea580c;
}

.poll-day-voter.sky,
.mini-voter-avatar.sky,
.user-color-dot.sky,
.availability-color-bar.sky {
  background: #0284c7;
}

.poll-day-voter.fuchsia,
.mini-voter-avatar.fuchsia,
.user-color-dot.fuchsia,
.availability-color-bar.fuchsia {
  background: #c026d3;
}

.poll-calendar-grid button.outside {
  color: #c1c6d0;
  background: transparent;
}

.poll-calendar-grid button:disabled {
  cursor: default;
  color: #d0d5dd;
  background: transparent;
}

.poll-calendar-grid button.has-options:not(:disabled) {
  border-color: #ddd2fb;
  color: #6d28d9;
  background: #f8f5ff;
}

.poll-calendar-grid button.selected:not(:disabled) {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
  box-shadow: 0 5px 12px rgba(124, 58, 237, 0.2);
}

.poll-calendar-grid button em {
  font-size: 7px;
  font-style: normal;
  font-weight: 900;
}

.poll-calendar-grid button small {
  overflow: hidden;
  max-width: 100%;
  color: #7c3aed;
  font-size: 6px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.poll-calendar-grid button .my-time-summary {
  max-width: 100%;
  color: #6d28d9;
  font-size: 6px;
}

.poll-calendar-grid button .poll-day-voter-summary {
  max-width: 100%;
  color: #667085;
  font-size: 6px;
  font-weight: 800;
}

.poll-calendar-grid button.selected small {
  color: #ede9fe;
}

.poll-calendar-selection {
  display: flex;
  flex-wrap: wrap;
  align-items: end;
  gap: 8px;
  margin-top: 12px;
  padding-top: 11px;
  border-top: 1px solid #eceef2;
}

.poll-calendar-selection > div:first-child {
  flex: 1 1 145px;
}

.poll-calendar-selection > div span,
.poll-calendar-selection > div strong {
  display: block;
}

.all-day-toggle {
  position: relative;
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border: 1px solid #e1e5ec;
  border-radius: 9px;
  color: #475467;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
}

.all-day-toggle .styled-checkbox-box {
  width: 17px;
  height: 17px;
  margin: 0;
}

.time-range-field {
  flex: 0 1 105px;
}

.time-range-separator {
  padding-bottom: 11px;
  color: #98a2b3;
  font-size: 9px;
}

.poll-calendar-selection .option-add-button {
  flex: 0 0 92px;
}

.poll-calendar-stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 9px;
  padding: 8px 10px;
  border-radius: 8px;
  color: #667085;
  font-size: 8px;
  background: #f3f0fb;
}

.poll-calendar-stats strong {
  color: #6d28d9;
  font-size: 9px;
}

.poll-calendar-member-summary {
  display: flex;
  flex: 1 1 100%;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  padding-top: 7px;
  border-top: 1px solid #e5def7;
}

.poll-calendar-member-summary > strong {
  flex: 0 0 auto;
  color: #5b21b6;
}

.poll-calendar-member-summary > span {
  overflow: hidden;
  color: #667085;
  font-size: 8px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-availability-panel {
  margin-top: 11px;
  padding: 11px;
  border: 1px solid #e4dcfb;
  border-radius: 10px;
  background: #faf8ff;
}

.my-availability-heading,
.my-availability-heading > div {
  display: flex;
  align-items: center;
}

.my-availability-heading {
  justify-content: space-between;
  gap: 10px;
}

.my-availability-heading > div {
  gap: 6px;
}

.user-color-dot {
  width: 9px;
  height: 9px;
}

.my-availability-heading strong {
  color: #4c1d95;
  font-size: 9px;
  font-weight: 900;
}

.my-availability-heading em {
  color: #8b5cf6;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
}

.my-availability-list {
  display: grid;
  gap: 5px;
  margin-top: 8px;
}

.my-availability-item {
  display: grid;
  grid-template-columns: 4px minmax(0, 1fr) 28px;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  padding: 5px 6px;
  border: 1px solid #ece7f7;
  border-radius: 8px;
  background: #fff;
}

.availability-color-bar {
  width: 4px;
  height: 27px;
  border-radius: 99px;
}

.my-availability-item > div strong,
.my-availability-item > div span {
  display: block;
}

.my-availability-item > div strong {
  color: #344054;
  font-size: 9px;
  font-weight: 900;
}

.my-availability-item > div span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 7px;
}

.my-availability-item button {
  display: grid;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #e11d48;
  background: #fff1f3;
}

.my-availability-item button:disabled {
  cursor: default;
  color: #b7bdc7;
  background: #f1f3f5;
}

.my-availability-item svg {
  width: 13px;
  height: 13px;
}

.calendar-slot-overview {
  margin-top: 11px;
  padding-top: 11px;
  border-top: 1px solid #eceef2;
}

.calendar-slot-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.calendar-slot-heading strong {
  color: #475467;
  font-size: 9px;
  font-weight: 900;
}

.calendar-slot-heading span {
  color: #98a2b3;
  font-size: 8px;
}

.calendar-slot-empty {
  margin-top: 7px;
  padding: 11px;
  border: 1px dashed #dfe3eb;
  border-radius: 8px;
  color: #98a2b3;
  font-size: 8px;
  text-align: center;
  background: #fff;
}

.calendar-slot-list {
  display: grid;
  gap: 5px;
  margin-top: 7px;
}

.calendar-slot-item {
  display: grid;
  grid-template-columns: minmax(110px, 0.8fr) minmax(0, 1fr) auto auto;
  min-height: 38px;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid #e7e9ef;
  border-radius: 8px;
  background: #fff;
}

.calendar-slot-item > div:first-child strong,
.calendar-slot-item > div:first-child span {
  display: block;
}

.calendar-slot-item > div:first-child strong {
  color: #344054;
  font-size: 9px;
  font-weight: 900;
}

.calendar-slot-item > div:first-child span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 7px;
}

.calendar-slot-voters {
  display: flex;
  overflow: hidden;
  align-items: center;
  gap: 7px;
}

.calendar-slot-voters > .calendar-slot-voter {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  color: #667085;
  font-size: 7px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-slot-voter .voter-name,
.option-voter-chip .voter-name,
.schedule-detail-participants .participant-name {
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-slot-item em {
  padding: 3px 6px;
  border-radius: 99px;
  color: #7c3aed;
  font-size: 7px;
  font-style: normal;
  font-weight: 900;
  background: #f1eafe;
}

.poll-calendar-selection > div span {
  color: #98a2b3;
  font-size: 8px;
}

.poll-calendar-selection > div strong {
  margin-top: 3px;
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.member-option-adder {
  display: grid;
  grid-template-columns: minmax(150px, 1fr) 128px 105px 74px;
  align-items: end;
  gap: 8px;
  margin-bottom: 12px;
  padding: 11px;
  border: 1px dashed #cfc2f4;
  border-radius: 10px;
  background: #faf8ff;
}

.member-option-adder > div strong,
.member-option-adder > div span {
  display: block;
}

.member-option-adder > div strong {
  color: #5b21b6;
  font-size: 9px;
  font-weight: 900;
}

.member-option-adder > div span {
  margin-top: 3px;
  color: #91869e;
  font-size: 8px;
  line-height: 1.4;
}

.vote-options-empty {
  padding: 16px;
  border: 1px dashed #dfe3eb;
  border-radius: 9px;
  color: #98a2b3;
  font-size: 8px;
  text-align: center;
  background: #fbfcfd;
}

.vote-option-entry {
  display: grid;
  gap: 5px;
}

.vote-option {
  display: grid;
  grid-template-columns: 25px minmax(0, 1fr) 48px;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 11px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  text-align: left;
  background: #fff;
}

.vote-option.selected {
  border-color: #a78bfa;
  background: #fcfaff;
}

.vote-option:disabled {
  cursor: default;
  opacity: 0.72;
}

.vote-option.selected:disabled {
  opacity: 1;
}

.vote-option.has-image {
  grid-template-columns: 64px 25px minmax(0, 1fr) 48px;
}

.vote-option-image {
  width: 64px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
}

.vote-option-link {
  display: inline-flex;
  align-items: center;
  justify-self: end;
  gap: 4px;
  margin-right: 5px;
  padding: 4px 7px;
  border-radius: 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 800;
  text-decoration: none;
  background: #f3efff;
}

.vote-option-link:hover {
  color: #5b21b6;
  background: #ece5ff;
}

.vote-option-link svg {
  width: 11px;
  height: 11px;
}

.place-result-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-right: 5px;
}

.place-result-actions .vote-option-link {
  margin-right: 0;
}

.place-schedule-button,
.schedule-result-button {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  gap: 4px;
  padding: 0 9px;
  border: 1px solid #c4b5fd;
  border-radius: 7px;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
  background: #7c3aed;
}

.place-schedule-button:hover,
.schedule-result-button:hover {
  border-color: #6d28d9;
  background: #6d28d9;
}

.place-schedule-button svg,
.schedule-result-button svg {
  width: 11px;
  height: 11px;
}

.vote-checkbox {
  display: grid;
  width: 21px;
  height: 21px;
  border: 1px solid #d7dbe3;
  border-radius: 6px;
  place-items: center;
  color: #fff;
  background: #fff;
}

.vote-option.selected .vote-checkbox {
  border-color: #7c3aed;
  background: #7c3aed;
}

.vote-checkbox svg {
  width: 12px;
  height: 12px;
}

.vote-option-copy {
  min-width: 0;
}

.vote-option-copy > strong {
  display: block;
  overflow: hidden;
  color: #344054;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vote-option-address {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #667085;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vote-progress {
  overflow: hidden;
  height: 4px;
  margin-top: 7px;
  border-radius: 99px;
  background: #eef0f3;
}

.vote-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #8b5cf6, #c084fc);
}

.option-voter-list {
  display: flex;
  overflow: hidden;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
}

.option-voter-chip {
  display: inline-flex;
  min-width: 0;
  max-width: 138px;
  align-items: center;
  gap: 4px;
  color: #667085;
  font-size: 7px;
  font-weight: 800;
  white-space: nowrap;
}

.vote-result {
  text-align: right;
}

.vote-result strong,
.vote-result span {
  display: block;
}

.poll-manage-button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid transparent;
  border-radius: 9px;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.poll-manage-button.delete {
  border-color: #fecdd3;
  color: #be123c;
  background: #fff1f3;
}

.poll-manage-button.stop {
  border-color: #fed7aa;
  color: #c2410c;
  background: #fff7ed;
}

.poll-manage-button.finish {
  border-color: #c4b5fd;
  color: #6d28d9;
  background: #f5f3ff;
}

.poll-manage-button.response-cancel {
  border-color: #fda4af;
  color: #be123c;
  background: #fff1f3;
}

.poll-manage-button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.vote-result strong {
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
}

.vote-result span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 8px;
}

.schedule-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  padding: 13px;
  border: 1px solid #e7e9ef;
  border-radius: 11px;
  background: #fafbfc;
}

.schedule-summary div {
  min-width: 0;
}

.schedule-summary span,
.schedule-summary strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-summary span {
  color: #98a2b3;
  font-size: 8px;
}

.schedule-summary strong {
  margin-top: 3px;
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.schedule-summary p {
  grid-column: 1/-1;
  margin: 2px 0 0;
  padding-top: 10px;
  border-top: 1px solid #eaecf0;
  color: #667085;
  font-size: 9px;
  line-height: 1.55;
}

.schedule-summary .schedule-summary-time {
  grid-column: 1/-1;
  padding-top: 8px;
  border-top: 1px solid #eaecf0;
}

.schedule-summary .schedule-summary-time strong {
  color: #5b34b4;
  font-variant-numeric: tabular-nums;
}

.schedule-summary-address-value {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
}

.schedule-summary-address-value strong {
  min-width: 0;
  margin-top: 0;
}

.schedule-address-copy {
  display: grid;
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  padding: 0;
  border: 1px solid #ddd6fe;
  border-radius: 7px;
  place-items: center;
  color: #6d28d9;
  background: #fff;
}

.schedule-address-copy:hover {
  color: #fff;
  background: #7c3aed;
}

.schedule-address-copy svg {
  width: 14px;
  height: 14px;
}

.schedule-detail-place-link {
  grid-column: 1/-1;
  justify-self: start;
  padding: 5px 7px;
  border-radius: 7px;
  background: #f1eafe;
}

.schedule-detail-header-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
}

.schedule-detail-action-button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 11px;
  border: 1px solid #ddd6fe;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f8f5ff;
}

.schedule-detail-action-button svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

.schedule-detail-action-button.delete {
  border-color: #fecaca;
  color: #b42318;
  background: #fff7f7;
}

.schedule-detail-action-button:hover:not(:disabled) {
  border-color: #c4b5fd;
  background: #f2edff;
}

.schedule-detail-action-button.delete:hover:not(:disabled) {
  border-color: #fca5a5;
  background: #fef2f2;
}

.schedule-detail-action-button:disabled {
  cursor: not-allowed;
  border-color: #eaecf0;
  color: #98a2b3;
  background: #f8f9fb;
}

.schedule-utility-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.schedule-utility-button {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #d9d6fe;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f8f5ff;
}

.schedule-utility-button.calendar {
  border-color: #bbf7d0;
  color: #047857;
  background: #f0fdf4;
}

.schedule-utility-button:hover {
  border-color: #a78bfa;
  background: #f2edff;
}

.schedule-utility-button.calendar:hover {
  border-color: #4ade80;
  background: #dcfce7;
}

.schedule-utility-button svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}

.schedule-permission-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 9px;
  padding: 8px 10px;
  border: 1px solid #e4e7ec;
  border-radius: 9px;
  color: #667085;
  font-size: 8px;
  background: #f8f9fb;
}

.schedule-permission-notice.allowed {
  border-color: #d8cffa;
  color: #5b34b4;
  background: #f8f5ff;
}

.schedule-permission-notice em {
  color: #98a2b3;
  font-style: normal;
}

.schedule-detail-participants {
  margin-top: 9px;
  padding: 11px 12px;
  border: 1px solid #e7e9ef;
  border-radius: 10px;
  background: #fff;
}

.schedule-detail-participants > span {
  color: #667085;
  font-size: 8px;
  font-weight: 900;
}

.schedule-detail-participants > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.schedule-detail-participants em {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px 4px 4px;
  border-radius: 99px;
  color: #475467;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
  background: #f3f0fb;
}

.schedule-detail-participants i {
  display: grid;
  overflow: hidden;
  width: 18px;
  height: 18px;
  place-items: center;
  border-radius: 999px;
  color: #fff;
  font-size: 7px;
  font-style: normal;
  background: #8b5cf6;
}

.departed-member-badge {
  display: inline-flex;
  flex: 0 0 auto;
  min-height: 15px;
  align-items: center;
  padding: 1px 5px;
  border: 1px solid #d0d5dd;
  border-radius: 99px;
  color: #667085;
  font-size: 7px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.2;
  background: #f2f4f7;
  white-space: nowrap;
}

.schedule-meta .departed-member-badge,
.schedule-summary .departed-member-badge {
  display: inline-flex;
  margin-left: 5px;
  vertical-align: middle;
}

.poll-day-voter.departed-member-avatar,
.poll-avatar.departed-member-avatar {
  border-color: #98a2b3;
  filter: grayscale(0.65);
}

.poll-day-departed-badge {
  min-height: 12px;
  padding: 0 3px;
  font-size: 6px;
}

.poll-calendar-member-list,
.poll-calendar-member {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.poll-calendar-member + .poll-calendar-member::before {
  content: "·";
  color: #98a2b3;
}

.vote-modal .poll-status-meta {
  margin-top: 12px;
  padding: 10px 12px;
  font-size: 10px;
}

.vote-modal .participation-badge,
.vote-modal .poll-status-badge {
  font-size: 10px;
}

.vote-modal .vote-guide {
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 12px;
}

.vote-modal .vote-guide strong {
  font-size: 12px;
}

.vote-modal .vote-guide span {
  font-size: 11px;
  line-height: 1.45;
}

.vote-modal .vote-guide .vote-guide-detail {
  margin-top: 3px;
  color: #746985;
  font-weight: 800;
}

.vote-modal .vote-guide .vote-guide-edit-note {
  margin-top: 5px;
  color: #6d28d9;
  font-weight: 900;
}

.vote-modal .vote-guide em {
  font-size: 11px;
}

.vote-modal .poll-vote-calendar {
  padding: 18px;
  border-radius: 14px;
}

.vote-modal .poll-calendar-toolbar {
  grid-template-columns: 36px minmax(0, 1fr) 36px;
  margin-bottom: 13px;
}

.vote-modal .poll-calendar-toolbar strong {
  font-size: 15px;
}

.vote-modal .poll-calendar-toolbar button {
  width: 36px;
  height: 36px;
}

.vote-modal .poll-calendar-toolbar svg {
  width: 17px;
  height: 17px;
}

.vote-modal .poll-calendar-weekdays span {
  padding: 6px 0 9px;
  font-size: 11px;
}

.vote-modal .poll-calendar-grid {
  gap: 6px;
}

.vote-modal .poll-calendar-grid button {
  min-height: 78px;
  gap: 3px;
  padding: 6px;
  border-radius: 10px;
  font-size: 12px;
}

.vote-modal .poll-day-number {
  font-size: 12px;
}

.vote-modal .poll-calendar-grid button em {
  font-size: 9px;
}

.vote-modal .poll-calendar-grid button small,
.vote-modal .poll-calendar-grid button .my-time-summary,
.vote-modal .poll-calendar-grid button .poll-day-voter-summary {
  font-size: 8px;
}

.vote-modal .poll-day-voter {
  width: 15px;
  height: 15px;
}

.vote-modal .poll-calendar-selection {
  gap: 10px;
  margin-top: 16px;
  padding-top: 14px;
}

.vote-modal .poll-calendar-selection > div span,
.vote-modal .form-field span {
  font-size: 10px;
}

.vote-modal .poll-calendar-selection > div strong {
  font-size: 13px;
}

.vote-modal .all-day-toggle {
  min-height: 42px;
  font-size: 10px;
}

.vote-modal .form-field input {
  font-size: 11px;
}

.vote-modal .poll-calendar-stats {
  gap: 10px;
  padding: 10px 12px;
  font-size: 10px;
}

.vote-modal .poll-calendar-stats strong {
  font-size: 11px;
}

.vote-modal .poll-calendar-member-summary > span {
  font-size: 10px;
}

.vote-modal .my-availability-heading strong,
.vote-modal .calendar-slot-heading strong {
  font-size: 11px;
}

.vote-modal .my-availability-heading em,
.vote-modal .calendar-slot-heading span {
  font-size: 10px;
}

.vote-modal .my-availability-item > div strong,
.vote-modal .calendar-slot-item > div:first-child strong {
  font-size: 11px;
}

.vote-modal .my-availability-item > div span,
.vote-modal .calendar-slot-item > div:first-child span,
.vote-modal .calendar-slot-voters > .calendar-slot-voter {
  font-size: 9px;
}

.vote-modal .calendar-slot-item em,
.vote-modal .option-voter-chip {
  font-size: 9px;
}

.vote-modal .vote-option-copy > strong {
  font-size: 12px;
}

.vote-modal .vote-option-address {
  font-size: 10px;
}

.vote-modal .vote-result strong {
  font-size: 11px;
}

.vote-modal .vote-result span {
  font-size: 10px;
}

.vote-modal .multi-select-note {
  font-size: 10px;
}

.vote-modal .modal-footer button {
  font-size: 11px;
}

.poll-calendar-layout {
  display: grid;
  grid-template-columns: minmax(600px, 1.55fr) minmax(350px, 0.85fr);
  align-items: start;
  gap: 16px;
}

.poll-calendar-main,
.poll-calendar-side {
  min-width: 0;
}

.poll-calendar-side {
  position: sticky;
  top: 0;
}

.poll-date-workspace {
  display: grid;
  gap: 14px;
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #e6e9ef;
}

.poll-calendar-side .poll-date-workspace {
  gap: 12px;
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

.poll-date-workspace-header {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto;
  align-items: center;
  gap: 18px;
  padding: 16px 18px;
  border: 1px solid #dcd2fa;
  border-radius: 14px;
  background: radial-gradient(circle at 8% 25%, rgba(139, 92, 246, 0.13), transparent 32%), linear-gradient(120deg, #faf7ff, #fff 62%);
}

.poll-calendar-side .poll-date-workspace-header {
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  padding: 14px;
}

.selected-date-card {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.selected-date-icon {
  display: grid;
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  place-items: center;
  color: #fff;
  background: linear-gradient(145deg, #7c3aed, #8b5cf6);
  box-shadow: 0 8px 18px rgba(124, 58, 237, 0.2);
}

.selected-date-icon svg {
  width: 21px;
  height: 21px;
}

.selected-date-card > div {
  min-width: 0;
}

.selected-date-card > div > span,
.selected-date-card > div > strong,
.selected-date-card > div > small {
  display: block;
}

.selected-date-card > div > span {
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
}

.selected-date-card strong {
  margin-top: 2px;
  color: #2d2340;
  font-size: 14px;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.selected-date-card small {
  margin-top: 3px;
  color: #8c8498;
  font-size: 8px;
}

.selected-date-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(72px, 1fr));
  gap: 7px;
}

.selected-date-metrics > div {
  min-width: 72px;
  padding: 8px 10px;
  border: 1px solid rgba(224, 218, 241, 0.9);
  border-radius: 10px;
  text-align: center;
  background: rgba(255, 255, 255, 0.86);
}

.selected-date-metrics span,
.selected-date-metrics strong {
  display: block;
}

.selected-date-metrics span {
  color: #8a8198;
  font-size: 8px;
  font-weight: 800;
}

.selected-date-metrics strong {
  margin-top: 2px;
  color: #6d28d9;
  font-size: 12px;
  font-weight: 900;
}

.availability-composer {
  display: grid;
  grid-template-columns: minmax(190px, 0.65fr) minmax(0, 1.35fr);
  align-items: center;
  gap: 16px;
  padding: 15px 16px;
  border: 1px solid #e2e5eb;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 7px 17px rgba(52, 64, 84, 0.04);
}

.poll-calendar-side .availability-composer {
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  padding: 14px;
}

.availability-composer-heading,
.poll-response-card-header > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.availability-composer-heading .all-day-toggle.compact {
  min-height: 28px;
  margin-left: auto;
  padding: 0 8px;
  border-radius: 99px;
  font-size: 8px;
}

.availability-composer-heading .all-day-toggle.compact .styled-checkbox-box {
  width: 15px;
  height: 15px;
  border-radius: 5px;
}

.availability-composer-heading strong,
.availability-composer-heading span,
.poll-response-card-header strong,
.poll-response-card-header span {
  display: block;
}

.availability-composer-heading strong,
.poll-response-card-header strong {
  color: #352847;
  font-size: 11px;
  font-weight: 900;
}

.availability-composer-heading div > span,
.poll-response-card-header div > div > span {
  margin-top: 3px;
  color: #91899c;
  font-size: 8px;
  line-height: 1.4;
}

.composer-step {
  display: grid !important;
  flex: 0 0 auto;
  width: 25px;
  height: 25px;
  border-radius: 8px;
  place-items: center;
  color: #fff;
  font-size: 9px !important;
  font-weight: 900;
  background: #7c3aed;
}

.composer-step.muted {
  color: #5b34b4;
  background: #e8e2fa;
}

.availability-composer-controls {
  display: flex;
  min-width: 0;
  align-items: end;
  justify-content: flex-end;
  gap: 8px;
}

.poll-calendar-side .availability-composer-controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 12px minmax(0, 1fr);
  width: 100%;
}

.poll-calendar-side .availability-composer-controls .availability-add-button {
  grid-column: 1/-1;
}

.poll-calendar-side .availability-composer-controls .availability-add-button {
  width: 100%;
}

.availability-composer-controls .all-day-toggle {
  flex: 0 0 auto;
}

.availability-composer-controls .time-range-field {
  min-width: 112px;
  flex: 1 1 125px;
}

.availability-composer-controls .time-range-separator {
  flex: 0 0 auto;
}

.availability-add-button {
  min-width: 118px;
  flex: 0 0 auto;
  padding: 0 13px;
}

.availability-composer-locked {
  padding: 11px 12px;
  border: 1px dashed #d8dce5;
  border-radius: 9px;
  color: #7b8493;
  font-size: 9px;
  font-weight: 800;
  background: #fafbfc;
}

.poll-date-response-grid {
  display: grid;
  grid-template-columns: minmax(270px, 0.82fr) minmax(360px, 1.18fr);
  align-items: start;
  gap: 12px;
}

.poll-response-card {
  min-width: 0;
  padding: 15px;
  border: 1px solid #e2e5eb;
  border-radius: 13px;
  background: #fff;
}

.my-response-card {
  border-color: #ddd3f7;
  background: #fcfaff;
}

.poll-calendar-side .my-response-card {
  padding: 14px;
}

.poll-response-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.poll-response-card-header > div > div {
  min-width: 0;
}

.poll-response-card-header em {
  flex: 0 0 auto;
  padding: 4px 8px;
  border-radius: 99px;
  color: #6d28d9;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #f0ebff;
}

.poll-response-empty {
  display: flex;
  min-height: 112px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 12px;
  padding: 14px;
  border: 1px dashed #dddfe6;
  border-radius: 11px;
  text-align: center;
  background: rgba(250, 251, 252, 0.82);
}

.poll-response-empty-icon {
  display: grid !important;
  width: 28px;
  height: 28px;
  margin-bottom: 7px;
  border-radius: 9px;
  place-items: center;
  color: #7c3aed;
  font-size: 17px !important;
  font-weight: 500 !important;
  background: #eee8ff;
}

.poll-response-empty-icon.members svg {
  width: 15px;
  height: 15px;
}

.poll-response-empty strong,
.poll-response-empty > span:last-child {
  display: block;
}

.poll-response-empty strong {
  color: #5c6470;
  font-size: 10px;
  font-weight: 900;
}

.poll-response-empty > span:last-child {
  margin-top: 3px;
  color: #9aa1ac;
  font-size: 8px;
}

.my-response-card .my-availability-list,
.poll-date-member-card .calendar-slot-list {
  gap: 7px;
  margin-top: 12px;
}

.poll-calendar-side .my-availability-list {
  overflow-y: auto;
  max-height: 280px;
  padding-right: 2px;
}

.my-availability-date-group {
  overflow: hidden;
  border: 1px solid #e6e0f4;
  border-radius: 11px;
  background: #fff;
}

.my-availability-date-group.current-date {
  border-color: #bca8ed;
  box-shadow: inset 3px 0 0 #7c3aed;
}

.my-availability-date-header {
  display: flex;
  min-height: 38px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 9px;
  border-bottom: 1px solid #eee9f7;
  background: #faf8ff;
}

.my-availability-date-header > div {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}

.my-availability-date-header strong {
  overflow: hidden;
  color: #3f3850;
  font-size: 10px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.weekday-badge,
.current-date-badge {
  flex: 0 0 auto;
  border-radius: 99px;
  font-size: 8px;
  font-weight: 900;
}

.weekday-badge {
  padding: 3px 6px;
  color: #6d28d9;
  background: #eee8ff;
}

.current-date-badge {
  padding: 3px 7px;
  color: #fff;
  background: #7c3aed;
}

.my-availability-time-list {
  display: grid;
}

.my-response-card .my-availability-item {
  grid-template-columns: 34px minmax(0, 1fr) 30px;
  min-height: 48px;
  gap: 9px;
  padding: 7px 8px;
  border: 0;
  border-radius: 0;
}

.my-response-card .my-availability-item + .my-availability-item {
  border-top: 1px solid #f0edf5;
}

.availability-time-icon {
  display: grid;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  place-items: center;
  color: #fff;
}

.availability-time-icon svg {
  width: 16px;
  height: 16px;
}

.availability-time-icon.violet {
  background: #7c3aed;
}

.availability-time-icon.rose {
  background: #e11d48;
}

.availability-time-icon.blue {
  background: #2563eb;
}

.availability-time-icon.emerald {
  background: #059669;
}

.availability-time-icon.amber {
  background: #d97706;
}

.availability-time-icon.cyan {
  background: #0891b2;
}

.availability-time-icon.pink {
  background: #db2777;
}

.availability-time-icon.indigo {
  background: #4f46e5;
}

.availability-time-icon.lime {
  background: #65a30d;
}

.availability-time-icon.orange {
  background: #ea580c;
}

.availability-time-icon.sky {
  background: #0284c7;
}

.availability-time-icon.fuchsia {
  background: #c026d3;
}

.my-response-card .my-availability-item > div strong {
  font-size: 11px;
}

.my-response-card .my-availability-item > div span {
  font-size: 8px;
}

.my-response-card .my-availability-item button {
  width: 30px;
  height: 30px;
}

.poll-date-member-card .calendar-slot-item {
  grid-template-columns: minmax(90px, 0.6fr) minmax(120px, 1fr) auto;
  min-height: 52px;
  gap: 10px;
  padding: 8px 9px;
  border-radius: 10px;
  transition: border-color 140ms ease, background 140ms ease;
}

.poll-date-member-wide {
  margin-top: 14px;
}

.poll-date-member-wide .calendar-slot-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.poll-date-member-card .calendar-slot-item.selected {
  border-color: #b9a5ed;
  background: #faf8ff;
}

.poll-date-member-card .calendar-slot-copy strong {
  color: #2f3744;
  font-size: 11px;
  font-weight: 900;
}

.poll-date-member-card .calendar-slot-copy span {
  display: block;
  margin-top: 2px;
  color: #8e96a2;
  font-size: 8px;
}

.poll-date-member-card .calendar-slot-voters {
  flex-wrap: wrap;
  row-gap: 4px;
}

.slot-selection-button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 10px;
  border: 1px solid #d6cafa;
  border-radius: 8px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #f8f5ff;
  white-space: nowrap;
}

.slot-selection-button:hover {
  border-color: #a78bfa;
  background: #f1ecff;
}

.slot-selection-button.selected {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
}

.slot-selection-button svg {
  width: 12px;
  height: 12px;
}

@media (max-width: 1100px) {
  .poll-calendar-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .poll-calendar-side {
    position: static;
  }
  .poll-calendar-side .poll-date-workspace-header {
    grid-template-columns: minmax(260px, 1fr) auto;
  }
  .poll-calendar-side .availability-composer {
    grid-template-columns: minmax(190px, 0.65fr) minmax(0, 1.35fr);
  }
  .poll-calendar-side .availability-composer-controls {
    display: flex;
    width: auto;
  }
  .poll-calendar-side .availability-composer-controls .availability-add-button {
    grid-column: auto;
  }
  .poll-calendar-side .availability-composer-controls .availability-add-button {
    width: auto;
  }
  .poll-calendar-side .my-availability-list {
    max-height: none;
  }
}
@media (max-width: 780px) {
  .poll-date-workspace-header,
  .availability-composer,
  .poll-date-response-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .selected-date-metrics {
    width: 100%;
  }
  .availability-composer-controls {
    justify-content: flex-start;
  }
  .poll-date-member-wide .calendar-slot-list {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 560px) {
  .poll-date-workspace-header,
  .availability-composer,
  .poll-response-card {
    padding: 12px;
  }
  .poll-date-workspace-header {
    gap: 12px;
  }
  .selected-date-metrics {
    gap: 4px;
  }
  .selected-date-metrics > div {
    min-width: 0;
    padding: 7px 4px;
  }
  .availability-composer-controls {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 12px minmax(0, 1fr);
    width: 100%;
  }
  .availability-composer-controls .availability-add-button {
    grid-column: 1/-1;
  }
  .availability-composer-controls .availability-add-button {
    width: 100%;
  }
  .poll-date-member-card .calendar-slot-item {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .poll-date-member-card .calendar-slot-voters {
    grid-column: 1/-1;
    grid-row: auto;
  }
  .poll-date-member-card .slot-selection-button,
  .poll-date-member-card .schedule-result-button {
    grid-column: 1/-1;
    justify-content: center;
  }
}
.itinerary-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 15px;
  margin: 18px 0 12px;
}

.itinerary-heading strong,
.itinerary-heading span {
  display: block;
}

.itinerary-heading strong {
  color: #344054;
  font-size: 12px;
  font-weight: 900;
}

.itinerary-heading span {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 8px;
}

.itinerary-edit-button {
  flex: 0 0 auto;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #cfc3f2;
  border-radius: 8px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #faf8ff;
}

.itinerary-empty {
  display: flex;
  min-height: 170px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px dashed #dfe3ea;
  border-radius: 11px;
  text-align: center;
  background: #fcfcfd;
}

.itinerary-empty-icon {
  display: grid;
  width: 42px;
  height: 42px;
  margin-bottom: 9px;
  place-items: center;
  border-radius: 12px;
  color: #8b5cf6;
  background: #f0ebff;
}

.itinerary-empty-icon svg {
  width: 21px;
  height: 21px;
}

.itinerary-empty strong {
  color: #475467;
  font-size: 10px;
  font-weight: 900;
}

.itinerary-empty > span {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 8px;
}

.itinerary-timeline {
  display: grid;
  gap: 0;
}

.timeline-stop {
  position: relative;
  display: grid;
  grid-template-columns: 28px 62px minmax(0, 1fr);
  gap: 10px;
  min-height: 64px;
}

.timeline-stop:not(:last-child)::before {
  position: absolute;
  top: 27px;
  bottom: -2px;
  left: 13px;
  width: 2px;
  background: #ddd5f7;
  content: "";
}

.timeline-marker {
  position: relative;
  z-index: 1;
}

.timeline-marker span {
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 3px solid #eee9ff;
  border-radius: 999px;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
  background: #7c3aed;
}

.timeline-time {
  padding-top: 6px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
}

.timeline-time > span {
  display: block;
}

.itinerary-status-badge {
  display: inline-flex;
  width: fit-content;
  min-height: 20px;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  padding: 3px 7px;
  border: 1px solid #f2d49a;
  border-radius: 999px;
  color: #9a6700;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  line-height: 1;
  background: #fff8e8;
}

.itinerary-status-badge.confirmed {
  border-color: #a9e4cf;
  color: #047857;
  background: #ecfdf5;
}

.timeline-copy {
  padding: 3px 0 14px;
}

.timeline-copy strong {
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.timeline-copy p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 9px;
}

.timeline-copy em {
  display: inline-block;
  margin-top: 7px;
  padding: 4px 7px;
  border-radius: 6px;
  color: #047857;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
  background: #e9f8f2;
}

.itinerary-mode .schedule-detail-body {
  padding: 22px 26px 24px;
  background: #f8f9fc;
}

.route-planner {
  width: 100%;
}

.route-planner-overview {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 14px 15px;
  border: 1px solid #ded7f8;
  border-radius: 13px;
  background: radial-gradient(circle at 100% 0, rgba(139, 92, 246, 0.12), transparent 36%), #fff;
}

.route-planner-overview-icon {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border-radius: 12px;
  color: #6d28d9;
  background: #f0ebff;
}

.route-planner-overview-icon svg {
  width: 22px;
  height: 22px;
}

.route-planner-overview > div:nth-child(2) strong,
.route-planner-overview > div:nth-child(2) span {
  display: block;
}

.route-planner-overview > div:nth-child(2) strong {
  color: #344054;
  font-size: 11px;
  font-weight: 900;
}

.route-planner-overview > div:nth-child(2) span {
  margin-top: 4px;
  color: #7b8494;
  font-size: 8px;
  line-height: 1.5;
}

.route-planner-count {
  min-width: 68px;
  padding: 8px 10px;
  border: 1px solid #e4def8;
  border-radius: 10px;
  text-align: center;
  background: rgba(255, 255, 255, 0.84);
}

.route-planner-count strong,
.route-planner-count span {
  display: block;
}

.route-planner-count strong {
  color: #6d28d9;
  font-size: 17px;
  font-weight: 900;
  line-height: 1;
}

.route-planner-count span {
  margin-top: 3px;
  color: #8b83a0;
  font-size: 7px;
  font-weight: 800;
}

.route-planner-list {
  margin-top: 17px;
}

.route-plan-row {
  position: relative;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  column-gap: 11px;
}

.route-plan-rail {
  position: relative;
  display: flex;
  justify-content: center;
}

.route-plan-rail::after {
  position: absolute;
  top: 34px;
  bottom: -11px;
  left: 17px;
  width: 2px;
  border-radius: 99px;
  background: #d8cff7;
  content: "";
}

.route-plan-row.last .route-plan-rail::after {
  display: none;
}

.route-plan-rail span {
  position: relative;
  z-index: 1;
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 4px solid #eeeaff;
  border-radius: 999px;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  background: #7c3aed;
  box-shadow: 0 5px 12px rgba(124, 58, 237, 0.18);
}

.route-plan-card {
  overflow: hidden;
  border: 1px solid #e1e4eb;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 7px 18px rgba(41, 35, 59, 0.04);
}

.route-plan-card-head {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 9px 7px 13px;
  border-bottom: 1px solid #edf0f4;
  background: #fcfcfe;
}

.route-plan-card-head > div:first-child {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.route-plan-card-head strong {
  color: #4c3b72;
  font-size: 9px;
  font-weight: 900;
}

.route-plan-card-head span {
  padding: 3px 6px;
  border-radius: 99px;
  color: #6d28d9;
  font-size: 7px;
  font-weight: 800;
  background: #f0ebff;
}

.route-plan-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 4px;
}

.route-plan-actions button {
  display: grid;
  width: 27px;
  height: 27px;
  padding: 0;
  border: 1px solid #e2e5eb;
  border-radius: 7px;
  place-items: center;
  color: #667085;
  background: #fff;
}

.route-plan-actions button:hover:not(:disabled) {
  border-color: #c9baf3;
  color: #6d28d9;
  background: #f8f5ff;
}

.route-plan-actions button:disabled {
  cursor: default;
  opacity: 0.3;
}

.route-plan-actions button.route-plan-remove {
  color: #d92d20;
}

.route-plan-actions button.route-plan-remove:hover {
  border-color: #fecaca;
  color: #b42318;
  background: #fff5f5;
}

.route-plan-actions svg {
  width: 13px;
  height: 13px;
}

.route-plan-fields {
  display: grid;
  grid-template-columns: 126px minmax(0, 1fr);
  gap: 10px;
  padding: 12px 13px 13px;
}

.route-plan-fields label {
  display: block;
  min-width: 0;
}

.route-plan-fields label > span,
.route-transfer label > span {
  display: block;
  margin-bottom: 5px;
  color: #667085;
  font-size: 8px;
  font-weight: 900;
}

.route-plan-fields input,
.route-transfer input {
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #dfe3ea;
  border-radius: 8px;
  outline: none;
  color: #344054;
  font-size: 10px;
  background: #fff;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.route-plan-fields input:focus,
.route-transfer input:focus {
  border-color: #9f7aea;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.route-plan-fields input::placeholder,
.route-transfer input::placeholder {
  color: #b0b6c1;
}

.route-plan-activity {
  grid-column: 1/-1;
}

.route-transfer {
  display: grid;
  grid-column: 2;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  margin: 8px 0;
  padding: 8px 11px;
  border: 1px dashed #d8dce5;
  border-radius: 10px;
  background: #f4f6f9;
}

.route-transfer > svg {
  width: 20px;
  height: 20px;
  justify-self: center;
  color: #7c3aed;
}

.route-transfer label {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
}

.route-transfer label > span {
  margin: 0;
}

.route-transfer input {
  height: 34px;
  background: #fff;
}

.route-plan-add {
  display: flex;
  width: calc(100% - 47px);
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin: 10px 0 0 47px;
  border: 1px dashed #bda9ef;
  border-radius: 11px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f7f3ff;
}

.route-plan-add:hover {
  border-color: #8b5cf6;
  background: #f1eaff;
}

.route-plan-add svg {
  width: 15px;
  height: 15px;
}

.route-planner-empty {
  margin: 16px 0 0 47px;
  padding: 18px;
  border: 1px dashed #d7dbe4;
  border-radius: 11px;
  text-align: center;
  background: #fff;
}

.route-planner-empty strong,
.route-planner-empty span {
  display: block;
}

.route-planner-empty strong {
  color: #475467;
  font-size: 10px;
  font-weight: 900;
}

.route-planner-empty span {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 8px;
}

.route-planner-footer-note {
  margin-right: auto;
  color: #8a92a1;
  font-size: 8px;
}

@media (max-width: 980px) {
  .detail-hero {
    grid-template-columns: 160px minmax(0, 1fr);
  }
  .detail-actions {
    grid-column: 1/-1;
    width: 100%;
  }
  .poll-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .poll-filters {
    flex-wrap: wrap;
  }
  .poll-filter-title {
    width: 100%;
    flex-basis: 100%;
    padding: 0 0 10px;
    border-right: 0;
    border-bottom: 1px solid #e1e4ea;
  }
  .poll-select-filter {
    flex: 1 1 210px;
  }
}
@media (max-width: 780px) {
  .settings-form {
    grid-template-columns: minmax(0, 1fr);
  }
  .settings-form .image-field {
    width: min(100%, 240px);
  }
  .management-card {
    grid-template-columns: minmax(0, 1fr);
  }
  .management-action {
    align-items: stretch;
    flex-direction: column;
  }
  .management-action-buttons {
    align-items: stretch;
  }
  .management-action-buttons button {
    flex: 1;
  }
  .select-field select {
    width: 100%;
    min-width: 0;
  }
  .detail-tabs button {
    flex: 1;
  }
  .schedule-heading {
    align-items: stretch;
    flex-direction: column;
  }
  .schedule-tools,
  .view-toggle {
    width: 100%;
  }
  .schedule-tools {
    flex-wrap: wrap;
  }
  .schedule-mine-filter {
    width: 100%;
    justify-content: center;
  }
  .view-toggle button {
    flex: 1;
    justify-content: center;
  }
  .schedule-item {
    grid-template-columns: minmax(0, 1fr) 18px;
  }
  .schedule-item .date-block {
    grid-column: 1/-1;
  }
  .schedule-participant-preview {
    max-width: none;
    flex-wrap: wrap;
  }
  .schedule-participant-people {
    min-width: calc(100% - 52px);
  }
  .poll-filters {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .poll-filter-title,
  .poll-select-filter,
  .poll-filter-actions {
    width: 100%;
    flex-basis: auto;
  }
  .poll-filter-actions .poll-mine-toggle {
    flex: 1;
  }
  .calendar-day {
    padding: 4px;
  }
  .calendar-event {
    padding: 3px;
  }
  .member-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .members-panel .panel-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .member-panel-actions {
    width: 100%;
    justify-content: space-between;
  }
  .member-option-adder {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .member-option-adder > div {
    grid-column: 1/-1;
  }
  .route-plan-fields {
    grid-template-columns: 105px minmax(0, 1fr);
  }
}
@media (max-width: 560px) {
  .settings-section {
    padding: 16px;
  }
  .delete-meeting-box {
    grid-template-columns: minmax(0, 1fr);
  }
  .settings-footer .cancel-button,
  .settings-footer .primary-button {
    flex: 1;
  }
  .schedule-detail-header {
    flex-direction: column;
  }
  .schedule-detail-header-actions {
    width: 100%;
  }
  .schedule-detail-action-button {
    flex: 1;
  }
  .schedule-utility-button {
    flex: 1 1 140px;
  }
  .schedule-detail-header-actions .close-button {
    flex: 0 0 34px;
  }
  .schedule-permission-notice {
    align-items: flex-start;
    flex-direction: column;
  }
  .detail-actions,
  .poll-kind-selector,
  .range-fields,
  .schedule-option-add,
  .place-option-add,
  .place-option-fields,
  .schedule-mode-selector,
  .schedule-summary {
    grid-template-columns: minmax(0, 1fr);
  }
  .place-option-fields .full {
    grid-column: auto;
  }
  .place-address-row,
  .schedule-participant-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-actions {
    display: grid;
  }
  .range-separator {
    display: none;
  }
  .multi-select-note {
    display: none;
  }
  .place-option-media {
    align-items: center;
    flex-wrap: wrap;
  }
  .place-option-media .option-add-button {
    width: 100%;
  }
  .member-option-adder {
    grid-template-columns: minmax(0, 1fr);
  }
  .member-option-adder > div {
    grid-column: auto;
  }
  .poll-calendar-grid {
    gap: 2px;
  }
  .poll-calendar-grid button {
    min-height: 60px;
    padding: 2px;
  }
  .vote-modal .modal-header,
  .vote-modal .modal-footer {
    padding-right: 17px;
    padding-left: 17px;
  }
  .vote-modal .modal-footer {
    flex-wrap: wrap;
  }
  .vote-modal .vote-body {
    padding: 18px 17px;
  }
  .vote-modal .poll-vote-calendar {
    padding: 10px;
  }
  .vote-modal .poll-calendar-grid {
    gap: 2px;
  }
  .vote-modal .poll-calendar-grid button {
    min-height: 64px;
    padding: 2px;
    font-size: 10px;
  }
  .vote-modal .poll-calendar-grid button small,
  .vote-modal .poll-calendar-grid button .my-time-summary,
  .vote-modal .poll-calendar-grid button .poll-day-voter-summary {
    font-size: 6px;
  }
  .vote-modal .poll-day-voter {
    width: 10px;
    height: 10px;
  }
  .poll-calendar-selection > div:first-child {
    flex-basis: 100%;
  }
  .time-range-field {
    flex: 1 1 90px;
  }
  .poll-calendar-selection .option-add-button {
    flex: 1 1 100%;
  }
  .calendar-slot-item {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .calendar-slot-voters {
    grid-column: 1/-1;
    grid-row: 2;
  }
  .calendar-slot-item > .schedule-result-button {
    grid-column: 1/-1;
    justify-content: center;
  }
  .vote-option.has-image {
    grid-template-columns: 48px 21px minmax(0, 1fr) 42px;
    gap: 7px;
  }
  .vote-option-image {
    width: 48px;
    height: 44px;
  }
  .calendar-week-events .calendar-event {
    margin: 0 4px;
  }
  .timeline-stop {
    grid-template-columns: 28px minmax(0, 1fr);
  }
  .timeline-time {
    grid-column: 2;
  }
  .timeline-copy {
    grid-column: 2;
    margin-top: -32px;
    padding-left: 62px;
  }
  .itinerary-mode .schedule-detail-body {
    padding: 16px 14px 19px;
  }
  .route-planner-overview {
    grid-template-columns: 38px minmax(0, 1fr);
    padding: 12px;
  }
  .route-planner-overview-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
  }
  .route-planner-count {
    display: flex;
    grid-column: 1/-1;
    min-width: 0;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 7px;
  }
  .route-planner-count strong,
  .route-planner-count span {
    display: inline;
    margin: 0;
  }
  .route-plan-row {
    grid-template-columns: 30px minmax(0, 1fr);
    column-gap: 8px;
  }
  .route-plan-rail span {
    width: 30px;
    height: 30px;
  }
  .route-plan-rail::after {
    top: 30px;
    left: 14px;
  }
  .route-plan-card-head {
    align-items: flex-start;
  }
  .route-plan-card-head > div:first-child {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
  .route-plan-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .route-plan-activity {
    grid-column: auto;
  }
  .route-transfer {
    grid-column: 2;
    grid-template-columns: 22px minmax(0, 1fr);
    gap: 6px;
    padding: 8px;
  }
  .route-transfer label {
    grid-template-columns: minmax(0, 1fr);
    gap: 5px;
  }
  .route-plan-add {
    width: calc(100% - 38px);
    margin-left: 38px;
  }
  .route-planner-empty {
    margin-left: 38px;
  }
  .route-planner-footer-note {
    display: none;
  }
}
.detail-overview {
  overflow: hidden;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto 12px;
  border: 1px solid rgba(219, 224, 235, 0.95);
  border-radius: 17px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 16px 38px rgba(34, 25, 60, 0.06);
}

.detail-overview .detail-hero {
  width: 100%;
  max-width: none;
  min-height: 162px;
  margin: 0;
  padding: 21px;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.detail-overview .detail-cover {
  height: 136px;
}

.member-preview {
  display: flex;
  align-items: center;
  margin-left: 2px;
  padding-left: 4px;
}

.member-preview-avatar {
  display: grid;
  overflow: hidden;
  width: 24px;
  height: 24px;
  margin-left: -5px;
  place-items: center;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #fff;
  font-size: 8px;
  font-weight: 900;
  background: #7c3aed;
}

.member-preview-avatar.avatar-1 {
  background: #2563eb;
}

.member-preview-avatar.avatar-2 {
  background: #db2777;
}

.member-preview-avatar.avatar-3 {
  background: #059669;
}

.member-preview em {
  display: grid;
  min-width: 24px;
  height: 24px;
  margin-left: -3px;
  padding: 0 5px;
  place-items: center;
  border: 2px solid #fff;
  border-radius: 999px;
  color: #667085;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  background: #f0f2f5;
}

.detail-overview .detail-tabs {
  position: relative;
  gap: 16px;
  min-height: 56px;
  margin: 0;
  padding: 0 20px;
  border: 0;
  border-top: 1px solid #e8eaf0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.detail-overview .detail-tabs button {
  position: relative;
  min-width: 112px;
  min-height: 55px;
  gap: 8px;
  padding: 0 10px;
  border-radius: 0;
  color: #667085;
  font-size: 12px;
  background: transparent;
}

.detail-overview .detail-tabs button::after {
  position: absolute;
  right: 0;
  bottom: -1px;
  left: 0;
  height: 2px;
  content: "";
  background: transparent;
}

.detail-overview .detail-tabs button.active {
  color: #6d28d9;
  background: transparent;
}

.detail-overview .detail-tabs button.active::after {
  background: #7c3aed;
}

.detail-overview .detail-tabs button > svg {
  width: 18px;
  height: 18px;
}

.detail-overview .detail-tabs em {
  min-width: 21px;
  height: 21px;
  padding: 0 6px;
  font-size: 8px;
  background: #f1edff;
}

.detail-content {
  margin-top: 0;
}

.poll-filter-panel {
  margin-bottom: 12px;
  padding: 19px 22px 21px;
  border: 1px solid rgba(219, 224, 235, 0.95);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 12px 30px rgba(34, 25, 60, 0.045);
}

.poll-filter-header,
.poll-filter-header > div {
  display: flex;
  align-items: center;
}

.poll-filter-header {
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 17px;
}

.poll-filter-header > div {
  gap: 8px;
}

.poll-filter-header > div svg {
  width: 18px;
  height: 18px;
  color: #7c3aed;
}

.poll-filter-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: -0.025em;
}

.poll-filter-header .poll-filter-reset {
  width: auto;
  height: 31px;
  padding: 0 5px;
  border: 0;
  color: #667085;
  background: transparent;
}

.poll-filter-header .poll-filter-reset:hover:not(:disabled) {
  color: #6d28d9;
  background: #f5f1ff;
}

.poll-filter-header .poll-filter-reset:disabled {
  cursor: default;
  opacity: 0.42;
}

.poll-filter-groups {
  display: grid;
  grid-template-columns: minmax(230px, 1.05fr) minmax(275px, 1.2fr) minmax(270px, 1.15fr) 168px;
  align-items: end;
}

.schedule-filter-groups {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.poll-filter-group {
  min-width: 0;
  padding: 0 22px;
  border-left: 1px solid #e6e8ee;
}

.poll-filter-group:first-child {
  padding-left: 0;
  border-left: 0;
}

.poll-filter-group > strong,
.poll-sort-filter > strong {
  display: block;
  margin-bottom: 10px;
  color: #475467;
  font-size: 10px;
  font-weight: 900;
}

.poll-filter-group > div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.poll-filter-group button {
  display: inline-flex;
  height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px;
  border: 1px solid #dfe3eb;
  border-radius: 999px;
  color: #667085;
  font-size: 10px;
  font-weight: 850;
  background: #fff;
  white-space: nowrap;
  transition: border-color 140ms ease, color 140ms ease, background 140ms ease, box-shadow 140ms ease;
}

.poll-filter-group button svg {
  width: 15px;
  height: 15px;
}

.poll-filter-group button:hover,
.poll-filter-group button.active {
  border-color: #8b5cf6;
  color: #6d28d9;
  background: #faf8ff;
}

.poll-filter-group button.active {
  box-shadow: inset 0 0 0 1px rgba(124, 58, 237, 0.25);
}

.poll-filter-group button.status-ongoing {
  color: #027a48;
}

.poll-filter-group button.status-ongoing.active {
  border-color: #86d5ad;
  color: #027a48;
  background: #ecfdf3;
  box-shadow: inset 0 0 0 1px rgba(18, 183, 106, 0.12);
}

.poll-filter-group button.status-closing {
  color: #c2410c;
}

.poll-filter-group button.status-closing.active {
  border-color: #fdba74;
  color: #c2410c;
  background: #fff7ed;
  box-shadow: inset 0 0 0 1px rgba(234, 88, 12, 0.09);
}

.poll-sort-filter {
  display: block;
  padding-left: 22px;
  border-left: 1px solid #e6e8ee;
}

.poll-sort-filter > span {
  position: relative;
  display: flex;
  height: 39px;
  align-items: center;
  gap: 7px;
  padding: 0 33px 0 12px;
  border: 1px solid #dfe3eb;
  border-radius: 10px;
  color: #7c3aed;
  background: #fff;
}

.poll-sort-filter svg {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
}

.poll-sort-filter select {
  width: 100%;
  height: 100%;
  appearance: none;
  padding: 0;
  border: 0;
  outline: 0;
  color: #344054;
  font-size: 10px;
  font-weight: 850;
  background: transparent;
  cursor: pointer;
}

.poll-sort-filter .sort-chevron {
  position: absolute;
  right: 11px;
  width: 13px;
  height: 13px;
  color: #7c3aed;
  pointer-events: none;
}

.poll-panel {
  min-height: 0;
  padding: 20px 22px 22px;
}

.poll-heading {
  min-height: 43px;
  margin-bottom: 13px;
}

.poll-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.poll-title-row .count-pill {
  padding: 5px 10px;
}

.poll-view-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
}

.poll-view-toggle button {
  display: grid;
  width: 39px;
  height: 39px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: 10px;
  color: #667085;
  background: #f5f6f8;
}

.poll-view-toggle button.active {
  color: #7c3aed;
  background: #f0eaff;
}

.poll-view-toggle svg {
  width: 19px;
  height: 19px;
}

.poll-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.poll-list .poll-card {
  display: grid;
  grid-template-columns: 72px minmax(250px, 1.2fr) 175px minmax(235px, 0.9fr) 18px;
  min-height: 112px;
  gap: 17px;
  padding: 16px 20px;
  border: 1px solid #dacffa;
  border-left-width: 1px;
  border-radius: 13px;
  background: linear-gradient(90deg, rgba(250, 247, 255, 0.9), #fff 46%);
}

.poll-list .poll-card.place {
  border-color: #cce9df;
  background: linear-gradient(90deg, rgba(244, 252, 249, 0.95), #fff 46%);
}

.poll-list .poll-card.poll-stopped {
  border-color: #f4c7c3;
}

.poll-list .poll-card:hover {
  transform: translateY(-2px);
  border-color: #a78bfa;
  box-shadow: 0 11px 24px rgba(71, 44, 118, 0.09);
}

.poll-list .poll-card.place:hover {
  border-color: #6bc6a5;
}

.poll-list .poll-card-icon {
  width: 62px;
  height: 62px;
  border-radius: 14px;
}

.poll-list .poll-card-icon svg {
  width: 28px;
  height: 28px;
}

.poll-list .poll-card-copy {
  align-self: center;
}

.poll-list .poll-card-labels {
  flex-wrap: wrap;
}

.poll-list .poll-kind-badge,
.poll-list .participation-badge {
  padding: 4px 8px;
  font-size: 8px;
}

.poll-list .poll-card-status {
  min-width: 0;
  padding: 4px 8px;
  border-color: #d0d5dd;
  border-radius: 999px;
  color: #475467;
  background: #f2f4f7;
}

.poll-list .poll-card-status.active {
  border-color: #a6f4c5;
  color: #027a48;
  background: #ecfdf3;
}

.poll-list .poll-card-status.active i {
  background: #12b76a;
}

.poll-list .poll-card-status.ended i {
  background: #98a2b3;
}

.poll-list .poll-card-copy > strong {
  margin-top: 6px;
  color: #172033;
  font-size: 14px;
}

.poll-list .poll-card-copy > p {
  margin-top: 5px;
  color: #667085;
  font-size: 10px;
}

.poll-list .poll-card-status-description {
  margin-top: 6px;
  color: #7b8494;
  font-size: 9px;
}

.poll-list .poll-card-status-description.urgent {
  color: #ef4444;
}

.poll-response-people,
.poll-progress {
  align-self: center;
}

.poll-response-people > small {
  display: block;
  margin-bottom: 8px;
  color: #667085;
  font-size: 9px;
  font-weight: 850;
}

.poll-avatar-stack {
  display: flex;
  align-items: center;
  min-height: 28px;
}

.poll-avatar,
.poll-avatar-stack em {
  display: grid;
  overflow: hidden;
  width: 28px;
  height: 28px;
  margin-left: -5px;
  place-items: center;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #fff;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  background: #7c3aed;
}

.poll-avatar:first-child {
  margin-left: 0;
}

.poll-avatar.rose {
  background: #e11d48;
}

.poll-avatar.blue {
  background: #2563eb;
}

.poll-avatar.emerald {
  background: #059669;
}

.poll-avatar.amber {
  background: #d97706;
}

.poll-avatar.cyan {
  background: #0891b2;
}

.poll-avatar.pink {
  background: #db2777;
}

.poll-avatar.indigo {
  background: #4f46e5;
}

.poll-avatar.lime {
  background: #65a30d;
}

.poll-avatar.orange {
  background: #ea580c;
}

.poll-avatar.sky {
  background: #0284c7;
}

.poll-avatar.fuchsia {
  background: #c026d3;
}

.poll-avatar-stack em {
  width: auto;
  min-width: 28px;
  padding: 0 6px;
  color: #667085;
  background: #f0f2f5;
}

.poll-response-people > .departed-member-badge {
  display: inline-flex;
  margin-top: 5px;
  margin-bottom: 0;
}

.poll-no-response {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  color: #98a2b3;
  font-size: 9px;
}

.poll-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 9px 12px;
}

.poll-progress > strong {
  grid-column: 1/-1;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.poll-progress > strong em {
  color: #6d28d9;
  font-size: 17px;
  font-style: normal;
  font-weight: 950;
}

.poll-card.place .poll-progress > strong em,
.poll-card.place .poll-progress > small {
  color: #059669;
}

.poll-progress-track {
  overflow: hidden;
  height: 7px;
  align-self: center;
  border-radius: 999px;
  background: #eee9f9;
}

.poll-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #7c3aed, #8b5cf6);
}

.poll-card.place .poll-progress-track {
  background: #e4f1ec;
}

.poll-card.place .poll-progress-track span {
  background: #16a36a;
}

.poll-progress > small {
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
}

.poll-list .poll-arrow {
  align-self: center;
  width: 18px;
  height: 18px;
  color: #7b8494;
}

.poll-list.grid-view {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.poll-list.grid-view .poll-card {
  position: relative;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 13px;
  padding-right: 44px;
}

.poll-list.grid-view .poll-card-icon {
  width: 52px;
  height: 52px;
}

.poll-list.grid-view .poll-response-people,
.poll-list.grid-view .poll-progress {
  grid-column: 2/-1;
}

.poll-list.grid-view .poll-response-people {
  display: none;
}

.poll-list.grid-view .poll-arrow {
  position: absolute;
  top: 16px;
  right: 16px;
  align-self: auto;
}

.poll-create-banner {
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr) auto;
  min-height: 78px;
  align-items: center;
  gap: 16px;
  margin-top: 13px;
  padding: 10px 23px 10px 15px;
  border-radius: 13px;
  background: radial-gradient(circle at 13% 25%, rgba(124, 58, 237, 0.12), transparent 23%), linear-gradient(100deg, #faf6ff, #fff 48%, #faf7ff);
}

.poll-create-art {
  display: grid;
  height: 58px;
  place-items: center;
  border-radius: 16px;
  font-size: 35px;
  transform: rotate(-8deg);
}

.poll-create-banner strong {
  display: block;
  color: #172033;
  font-size: 13px;
  font-weight: 900;
}

.poll-create-banner p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 10px;
}

.poll-create-banner button {
  min-width: 110px;
  height: 39px;
  padding: 0 17px;
  border: 1px solid #a78bfa;
  border-radius: 10px;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  background: #fff;
}

.poll-create-banner button:hover {
  border-color: #7c3aed;
  background: #f7f3ff;
}

@media (max-width: 1180px) {
  .poll-filter-groups {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px 0;
  }
  .poll-sort-filter {
    grid-column: 1/-1;
    padding: 16px 0 0;
    border-top: 1px solid #e6e8ee;
    border-left: 0;
  }
  .poll-sort-filter > span {
    max-width: 210px;
  }
  .poll-list .poll-card {
    grid-template-columns: 64px minmax(230px, 1fr) minmax(210px, 0.85fr) 18px;
  }
  .poll-response-people {
    display: none;
  }
}
@media (max-width: 860px) {
  .detail-overview .detail-hero {
    grid-template-columns: 140px minmax(0, 1fr);
  }
  .detail-overview .detail-actions {
    grid-column: 1/-1;
  }
  .detail-overview .detail-tabs {
    gap: 0;
  }
  .detail-overview .detail-tabs button {
    min-width: 0;
    flex: 1;
  }
  .poll-filter-groups {
    grid-template-columns: minmax(0, 1fr);
  }
  .poll-filter-group,
  .poll-filter-group:first-child {
    padding: 14px 0;
    border-top: 1px solid #e6e8ee;
    border-left: 0;
  }
  .poll-filter-group:first-child {
    padding-top: 0;
    border-top: 0;
  }
  .poll-sort-filter {
    grid-column: auto;
  }
  .poll-list .poll-card,
  .poll-list.grid-view {
    grid-template-columns: minmax(0, 1fr);
  }
  .poll-list .poll-card {
    grid-template-columns: 58px minmax(0, 1fr) 16px;
    gap: 13px;
  }
  .poll-list .poll-card-icon {
    width: 52px;
    height: 52px;
  }
  .poll-list .poll-progress,
  .poll-list.grid-view .poll-progress {
    grid-column: 2/-1;
  }
  .poll-list .poll-arrow {
    grid-column: 3;
    grid-row: 1;
  }
}
@media (max-width: 560px) {
  .detail-overview .detail-hero {
    grid-template-columns: minmax(0, 1fr);
  }
  .detail-overview .detail-cover {
    height: 150px;
  }
  .detail-overview .detail-tabs {
    padding: 0 6px;
  }
  .detail-overview .detail-tabs button {
    gap: 5px;
    padding: 0 4px;
    font-size: 10px;
  }
  .poll-filter-panel,
  .poll-panel {
    padding: 17px;
  }
  .poll-filter-group > div {
    flex-wrap: wrap;
  }
  .poll-list .poll-card {
    grid-template-columns: 48px minmax(0, 1fr) 14px;
    padding: 14px;
  }
  .poll-list.grid-view .poll-card {
    grid-template-columns: 48px minmax(0, 1fr);
    padding-right: 40px;
  }
  .poll-list.grid-view .poll-arrow {
    top: 14px;
    right: 14px;
  }
  .poll-list .poll-card-icon {
    width: 44px;
    height: 44px;
  }
  .poll-list .poll-progress {
    grid-column: 1/-1;
  }
  .poll-create-banner {
    grid-template-columns: 56px minmax(0, 1fr);
    padding: 13px;
  }
  .poll-create-art {
    font-size: 28px;
  }
  .poll-create-banner button {
    grid-column: 1/-1;
    width: 100%;
  }
}
.schedule-detail-modal {
  width: min(1100px, 100%);
  max-width: 1100px;
}

.modal-backdrop:has(.schedule-detail-modal.itinerary-mode) {
  padding: 16px;
}

.schedule-detail-modal.itinerary-mode {
  display: flex;
  width: min(1100px, 100%);
  height: min(1120px, 100dvh - 32px);
  max-width: 1100px;
  max-height: min(1120px, 100dvh - 32px);
  flex-direction: column;
}

.itinerary-mode .route-planner-header {
  min-height: 116px;
  align-items: center;
  padding: 25px 34px 22px;
  background: #fff;
}

.route-planner-title {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 13px;
}

.route-planner-title > svg {
  flex: 0 0 auto;
  width: 27px;
  height: 27px;
  margin-top: 2px;
  color: #7c3aed;
}

.route-planner-title h2 {
  font-size: 22px;
}

.route-planner-title p {
  margin-top: 7px;
  color: #7c8799;
  font-size: 11px;
}

.route-planner-context {
  display: block;
  margin-top: 6px;
  color: #a1a8b5;
  font-size: 9px;
  font-weight: 700;
}

.itinerary-mode .route-planner-header .close-button {
  width: 42px;
  height: 42px;
  border-color: #dfe3ea;
  border-radius: 11px;
}

.itinerary-mode .route-planner-header .close-button svg {
  width: 19px;
  height: 19px;
}

.itinerary-mode .schedule-detail-body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  padding: 20px 32px 24px;
  background: #fbfbfd;
}

.itinerary-mode .route-planner {
  min-height: 100%;
}

.route-planner-layout {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(270px, 0.9fr);
  align-items: start;
  gap: 20px;
}

.route-planner-layout.summary-collapsed {
  grid-template-columns: minmax(0, 1fr) 56px;
}

.route-planner-editor,
.route-planner-summary {
  border: 1px solid #dfe3ea;
  border-radius: 16px;
  background: #fff;
}

.route-planner-editor {
  padding: 18px;
}

.route-planner-editor-head {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.route-planner-editor-head > div {
  display: flex;
  align-items: center;
  gap: 7px;
}

.route-planner-editor-head svg {
  width: 17px;
  height: 17px;
  color: #8b5cf6;
}

.route-planner-editor-head strong {
  color: #253047;
  font-size: 13px;
  font-weight: 900;
}

.route-planner-editor-head > span {
  color: #8a94a6;
  font-size: 10px;
}

.itinerary-mode .route-planner-list {
  display: grid;
  gap: 14px;
  margin-top: 0;
}

.itinerary-mode .route-plan-card {
  overflow: hidden;
  border: 1px solid #dde2eb;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(38, 30, 68, 0.035);
}

.itinerary-mode .route-plan-card-head {
  min-height: 58px;
  padding: 12px 16px;
  border-bottom: 0;
  background: #fff;
}

.itinerary-mode .route-plan-card-title {
  display: flex;
  align-items: center;
  gap: 11px;
}

.itinerary-mode .route-plan-card-head .route-plan-number {
  display: grid;
  width: 31px;
  height: 31px;
  padding: 0;
  place-items: center;
  border-radius: 999px;
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
  box-shadow: 0 5px 11px rgba(124, 58, 237, 0.22);
}

.itinerary-mode .route-plan-card-head strong {
  color: #253047;
  font-size: 13px;
}

.itinerary-mode .route-plan-actions {
  gap: 7px;
}

.itinerary-mode .route-plan-actions button {
  width: 34px;
  height: 34px;
  border-color: #dfe3ea;
  border-radius: 9px;
}

.itinerary-mode .route-plan-actions svg {
  width: 15px;
  height: 15px;
}

.itinerary-mode .route-plan-fields {
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 13px 16px;
  padding: 7px 19px 18px;
}

.itinerary-mode .route-plan-fields label,
.itinerary-mode .route-plan-time {
  min-width: 0;
}

.itinerary-mode .route-plan-fields label > span,
.itinerary-mode .route-plan-field-heading > label {
  display: block;
  margin-bottom: 7px;
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.itinerary-mode .route-field-control {
  position: relative;
  display: flex;
  align-items: center;
}

.itinerary-mode .route-field-control > svg {
  position: absolute;
  z-index: 1;
  left: 13px;
  width: 17px;
  height: 17px;
  color: #667085;
  pointer-events: none;
}

.itinerary-mode .route-plan-fields input,
.itinerary-mode .route-transfer input,
.itinerary-mode .route-transfer select,
.itinerary-mode .route-plan-fields textarea {
  width: 100%;
  border: 1px solid #d8dee8;
  border-radius: 10px;
  outline: none;
  color: #27364d;
  font-size: 12px;
  background: #fff;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.itinerary-mode .route-plan-fields input,
.itinerary-mode .route-transfer input,
.itinerary-mode .route-transfer select {
  height: 45px;
}

.itinerary-mode .route-field-control > input,
.itinerary-mode .route-field-control > select {
  padding: 0 38px 0 41px;
}

.itinerary-mode .route-field-control > select {
  padding-right: 28px;
}

.itinerary-mode .route-plan-fields input:focus,
.itinerary-mode .route-transfer input:focus,
.itinerary-mode .route-transfer select:focus,
.itinerary-mode .route-plan-fields textarea:focus {
  border-color: #9f7aea;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.itinerary-mode .route-plan-fields input::placeholder,
.itinerary-mode .route-transfer input::placeholder,
.itinerary-mode .route-plan-fields textarea::placeholder {
  color: #a6aebb;
}

.route-field-clear {
  position: absolute;
  z-index: 2;
  right: 9px;
  display: grid;
  width: 27px;
  height: 27px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #98a2b3;
  background: transparent;
}

.route-field-clear:hover {
  color: #6d28d9;
  background: #f4f0ff;
}

.route-field-clear svg {
  width: 13px;
  height: 13px;
}

.route-plan-field-heading {
  display: flex;
  min-height: 19px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.route-time-remove {
  flex: 0 0 auto;
  margin-top: -3px;
  padding: 3px 6px;
  border: 0;
  border-radius: 6px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f4f0ff;
}

.route-time-remove:hover {
  color: #5b21b6;
  background: #ece5ff;
}

.route-time-remove:focus-visible {
  outline: 2px solid #8b5cf6;
  outline-offset: 1px;
}

.route-confirm-radio {
  display: flex;
  height: 34px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d8dee8;
  border-radius: 9px;
  background: #fff;
}

.route-confirm-radio label {
  position: relative;
  display: grid;
  height: 100%;
  min-width: 38px;
  margin: 0;
  padding: 0 8px;
  place-items: center;
  color: #667085;
  font-size: 9px;
  font-weight: 900;
  cursor: pointer;
}

.route-confirm-radio label + label {
  border-left: 1px solid #e4e7ec;
}

.route-confirm-radio input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.route-confirm-radio span {
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  color: inherit !important;
  font-size: inherit !important;
  background: transparent !important;
}

.route-confirm-radio label:has(input:checked) {
  color: #6d28d9;
  background: #f4f0ff;
}

.route-confirm-radio label:last-child:has(input:checked) {
  color: #047857;
  background: #ecfdf5;
}

.route-confirm-radio:focus-within {
  outline: 2px solid #8b5cf6;
  outline-offset: 1px;
}

.itinerary-mode .route-plan-activity {
  grid-column: 1/-1;
}

.route-activity-control {
  position: relative;
}

.itinerary-mode .route-plan-fields textarea {
  display: block;
  min-height: 76px;
  padding: 13px 14px 27px;
  line-height: 1.5;
  resize: vertical;
}

.route-activity-control small {
  position: absolute;
  right: 13px;
  bottom: 9px;
  color: #8a94a6;
  font-size: 9px;
  font-variant-numeric: tabular-nums;
}

.itinerary-mode .route-transfer {
  display: block;
  margin: 0;
  padding: 0 19px 19px;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.itinerary-mode .route-transfer > strong {
  display: block;
  margin-bottom: 8px;
  color: #344054;
  font-size: 10px;
  font-weight: 900;
}

.route-transfer-fields {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 16px;
}

.itinerary-mode .route-transfer label {
  display: block;
}

.itinerary-mode .route-transfer label > span {
  display: flex;
  margin: 0;
}

.route-transport-duration .route-field-control::after {
  position: absolute;
  right: 12px;
  padding: 3px 7px;
  border-radius: 99px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f1edff;
  content: "이동";
  pointer-events: none;
}

.itinerary-mode .route-transport-duration input {
  padding: 0 54px 0 14px;
}

.itinerary-mode .route-plan-add {
  width: 100%;
  min-height: 49px;
  margin: 14px 0 0;
  border-color: #b9a2f4;
  border-radius: 12px;
  color: #6d28d9;
  font-size: 11px;
  background: #fbf9ff;
}

.itinerary-mode .route-plan-add:disabled {
  cursor: not-allowed;
  border-color: #dfe3ea;
  color: #98a2b3;
  background: #f8f9fb;
}

.itinerary-mode .route-plan-add svg {
  width: 16px;
  height: 16px;
}

.itinerary-mode .route-planner-empty {
  margin: 0;
  padding: 42px 20px;
  border-radius: 12px;
  background: #fcfcfd;
}

.itinerary-mode .route-planner-empty strong {
  font-size: 12px;
}

.itinerary-mode .route-planner-empty span {
  margin-top: 6px;
  font-size: 10px;
}

.route-planner-summary {
  position: sticky;
  top: 0;
  display: flex;
  min-height: min(760px, 100vh - 220px);
  flex-direction: column;
  padding: 20px 19px;
}

.route-summary-toggle {
  display: flex;
  width: 100%;
  min-height: 32px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  border: 0;
  color: inherit;
  text-align: left;
  background: transparent;
}

.route-summary-heading {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.route-summary-heading strong {
  color: #253047;
  font-size: 13px;
  font-weight: 900;
}

.route-summary-heading span {
  padding: 4px 9px;
  border-radius: 99px;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  background: #f0ebff;
}

.route-summary-toggle > svg {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  color: #7c3aed;
  transition: transform 160ms ease;
}

.route-summary-toggle > svg.expanded {
  transform: rotate(180deg);
}

.route-summary-toggle:hover > svg {
  color: #5b21b6;
}

.route-summary-content {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
}

.route-planner-summary.collapsed {
  min-height: 0;
  padding: 7px;
}

.route-planner-summary.collapsed .route-summary-toggle {
  width: 40px;
  height: 40px;
  min-height: 40px;
  justify-content: center;
  border-radius: 10px;
}

.route-planner-summary.collapsed .route-summary-toggle:hover {
  background: #f6f2ff;
}

.route-planner-summary.collapsed .route-summary-heading {
  display: none;
}

.route-summary-timeline {
  padding: 27px 4px 15px;
}

.route-summary-stop {
  position: relative;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 12px;
  min-height: 126px;
}

.route-summary-stop:not(.last)::before {
  position: absolute;
  top: 31px;
  bottom: 0;
  left: 16px;
  width: 2px;
  background: #ddd2fb;
  content: "";
}

.route-summary-marker {
  position: relative;
  z-index: 1;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: 999px;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
}

.route-summary-copy {
  min-width: 0;
  padding: 3px 0 24px;
}

.route-summary-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.route-summary-meta .itinerary-status-badge {
  flex: 0 0 auto;
  margin-top: 0;
}

.route-summary-copy time,
.route-summary-copy strong,
.route-summary-copy p {
  display: block;
}

.route-summary-copy time {
  color: #6d28d9;
  font-size: 12px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.route-summary-copy strong {
  overflow: hidden;
  margin-top: 11px;
  color: #253047;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.route-summary-copy p {
  display: -webkit-box;
  overflow: hidden;
  margin: 7px 0 0;
  color: #667085;
  font-size: 10px;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.route-summary-transfer {
  display: inline-flex;
  margin-top: 12px;
  padding: 5px 9px;
  border: 1px solid #e4def8;
  border-radius: 99px;
  color: #51476b;
  font-size: 9px;
  font-weight: 800;
  background: #f5f2fc;
}

.route-summary-empty {
  display: grid;
  min-height: 220px;
  place-items: center;
  padding: 25px;
  color: #98a2b3;
  font-size: 10px;
  line-height: 1.6;
  text-align: center;
}

.route-planner-tip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: auto;
  padding: 17px;
  border-radius: 12px;
  color: #6d28d9;
  background: linear-gradient(135deg, #faf7ff, #f7f3ff);
}

.route-planner-tip > svg {
  flex: 0 0 auto;
  width: 19px;
  height: 19px;
}

.route-planner-tip strong {
  color: #6d28d9;
  font-size: 11px;
  font-weight: 900;
}

.route-planner-tip p {
  margin: 8px 0 0;
  color: #5f687a;
  font-size: 10px;
  line-height: 1.6;
}

.itinerary-mode .modal-footer {
  flex: 0 0 auto;
  gap: 13px;
  padding: 17px 34px;
  background: #fff;
  box-shadow: 0 -8px 24px rgba(38, 30, 68, 0.045);
}

.itinerary-mode .modal-footer .cancel-button,
.itinerary-mode .modal-footer .primary-button {
  min-height: 46px;
  border-radius: 11px;
  font-size: 12px;
}

.itinerary-mode .modal-footer .cancel-button {
  min-width: 92px;
}

.itinerary-mode .modal-footer .primary-button {
  min-width: 190px;
}

.schedule-detail-modal:not(.itinerary-mode) .modal-header h2,
.schedule-modal .modal-header h2 {
  font-size: 22px;
}

.schedule-detail-modal:not(.itinerary-mode) .modal-header p,
.schedule-modal .modal-header p {
  font-size: 11px;
  line-height: 1.5;
}

.schedule-detail-modal:not(.itinerary-mode) .modal-kicker,
.schedule-modal .modal-kicker {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-detail-action-button {
  min-height: 38px;
  padding: 0 13px;
  font-size: 11px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-summary span {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-summary strong {
  margin-top: 5px;
  font-size: 12px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-summary p {
  font-size: 11px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-detail-place-link {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-permission-notice {
  font-size: 10px;
  line-height: 1.5;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-detail-participants > span {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-detail-participants em {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .schedule-detail-participants i {
  font-size: 9px;
}

.schedule-detail-modal:not(.itinerary-mode) .departed-member-badge {
  font-size: 8px;
}

.schedule-detail-modal:not(.itinerary-mode) .itinerary-heading strong {
  font-size: 13px;
}

.schedule-detail-modal:not(.itinerary-mode) .itinerary-heading span {
  font-size: 10px;
  line-height: 1.5;
}

.schedule-detail-modal:not(.itinerary-mode) .itinerary-edit-button {
  min-height: 38px;
  padding: 0 13px;
  font-size: 11px;
}

.schedule-detail-modal:not(.itinerary-mode) .itinerary-empty strong {
  font-size: 12px;
}

.schedule-detail-modal:not(.itinerary-mode) .itinerary-empty > span {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .timeline-marker span {
  font-size: 10px;
}

.schedule-detail-modal:not(.itinerary-mode) .timeline-time {
  font-size: 12px;
}

.schedule-detail-modal:not(.itinerary-mode) .timeline-copy strong {
  font-size: 13px;
}

.schedule-detail-modal:not(.itinerary-mode) .timeline-copy p {
  font-size: 10px;
  line-height: 1.5;
}

.schedule-detail-modal:not(.itinerary-mode) .timeline-copy em {
  font-size: 9px;
}

.schedule-modal .form-field > span {
  font-size: 10px;
}

.schedule-modal .form-field input,
.schedule-modal .form-field textarea {
  font-size: 12px;
}

.schedule-modal .form-field small {
  font-size: 9px;
  line-height: 1.5;
}

.schedule-modal .schedule-place-reference {
  font-size: 10px;
  line-height: 1.5;
}

.schedule-modal .schedule-place-reference a,
.schedule-modal .schedule-place-reference button {
  font-size: 10px;
}

.schedule-modal .schedule-participant-heading strong {
  font-size: 12px;
}

.schedule-modal .schedule-participant-heading span,
.schedule-modal .schedule-participant-heading button {
  font-size: 10px;
}

.schedule-modal .schedule-participant-copy strong {
  font-size: 11px;
}

.schedule-modal .schedule-participant-copy em {
  font-size: 9px;
}

@media (max-width: 940px) {
  .schedule-detail-modal.itinerary-mode {
    width: min(760px, 100%);
  }
  .route-planner-layout,
  .route-planner-layout.summary-collapsed {
    grid-template-columns: minmax(0, 1fr);
  }
  .route-planner-summary {
    position: static;
    min-height: 0;
  }
  .route-planner-summary.collapsed {
    padding: 9px 12px;
  }
  .route-planner-summary.collapsed .route-summary-toggle {
    width: 100%;
    height: 34px;
    min-height: 34px;
    justify-content: space-between;
  }
  .route-planner-summary.collapsed .route-summary-heading {
    display: flex;
  }
  .route-planner-tip {
    margin-top: 12px;
  }
}
@media (max-width: 640px) {
  .modal-backdrop:has(.schedule-detail-modal.itinerary-mode) {
    align-items: center;
    padding: 12px;
  }
  .schedule-detail-modal.itinerary-mode {
    height: calc(100dvh - 24px);
    max-height: calc(100dvh - 24px);
    border-radius: 16px;
  }
  .itinerary-mode .route-planner-header {
    min-height: 0;
    padding: 18px 16px;
  }
  .route-planner-title > svg {
    width: 23px;
    height: 23px;
  }
  .route-planner-title h2 {
    font-size: 18px;
  }
  .schedule-detail-modal:not(.itinerary-mode) .modal-header h2,
  .schedule-modal .modal-header h2 {
    font-size: 18px;
  }
  .route-planner-title p {
    max-width: 250px;
    font-size: 9px;
    line-height: 1.45;
  }
  .schedule-detail-modal:not(.itinerary-mode) .modal-header p,
  .schedule-modal .modal-header p {
    font-size: 9px;
    line-height: 1.45;
  }
  .itinerary-mode .schedule-detail-body {
    padding: 14px;
  }
  .route-planner-editor,
  .route-planner-summary {
    padding: 14px;
    border-radius: 13px;
  }
  .route-planner-summary.collapsed {
    padding: 8px 11px;
  }
  .route-planner-editor-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .itinerary-mode .route-plan-card-head {
    padding: 10px 12px;
  }
  .itinerary-mode .route-plan-card-head .route-plan-number {
    width: 29px;
    height: 29px;
  }
  .itinerary-mode .route-plan-actions {
    gap: 4px;
  }
  .itinerary-mode .route-plan-actions button {
    width: 30px;
    height: 30px;
  }
  .itinerary-mode .route-plan-fields,
  .route-transfer-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .itinerary-mode .route-plan-fields {
    padding: 7px 14px 16px;
  }
  .itinerary-mode .route-plan-activity {
    grid-column: auto;
  }
  .itinerary-mode .route-transfer {
    padding: 0 14px 16px;
  }
  .itinerary-mode .modal-footer {
    padding: 13px 16px;
  }
  .itinerary-mode .modal-footer .cancel-button {
    flex: 1;
    min-width: 0;
  }
  .itinerary-mode .modal-footer .primary-button {
    flex: 2;
    min-width: 0;
  }
}
.schedule-panel .schedule-heading h2 {
  font-size: 22px;
}

.schedule-panel .panel-kicker {
  font-size: 10px;
}

.schedule-panel .schedule-mine-filter,
.schedule-panel .view-toggle button {
  font-size: 11px;
}

.schedule-panel .schedule-mine-filter em {
  font-size: 9px;
}

.schedule-filter-panel .poll-filter-header h2 {
  font-size: 18px;
}

.schedule-filter-panel .poll-filter-reset {
  font-size: 10px;
}

.schedule-panel .panel-empty h3 {
  font-size: 13px;
}

.schedule-panel .panel-empty p,
.schedule-panel .panel-empty .text-button {
  font-size: 10px;
}

.schedule-panel .subsection-heading > div > span {
  font-size: 13px;
}

.schedule-panel .subsection-heading p {
  font-size: 10px;
}

.schedule-panel .date-block strong {
  font-size: 12px;
}

.schedule-panel .date-block small {
  font-size: 11px;
}

.schedule-panel .date-block span {
  font-size: 10px;
}

.schedule-panel .schedule-content h3 {
  font-size: 14px;
}

.schedule-panel .schedule-content > p {
  font-size: 11px;
}

.schedule-panel .schedule-participant-label {
  font-size: 9px;
}

.schedule-panel .schedule-participant-name,
.schedule-panel .schedule-no-participant,
.schedule-panel .schedule-meta span {
  font-size: 10px;
}

.schedule-panel .schedule-my-participation {
  font-size: 9px;
}

.schedule-panel .schedule-pagination button {
  font-size: 10px;
}

.schedule-panel .calendar-nav h3 {
  font-size: 15px;
}

.schedule-panel .today-button {
  font-size: 10px;
}

.schedule-panel .calendar-weekdays span,
.schedule-panel .calendar-day-number {
  font-size: 10px;
}

.schedule-panel .calendar-week-events {
  top: 40px;
  grid-auto-rows: 36px;
  gap: 4px 0;
}

.schedule-panel .calendar-week-events .calendar-event {
  height: 36px;
}

.schedule-panel .calendar-event span,
.schedule-panel .calendar-event.schedule .calendar-event-title {
  font-size: 9px;
}

.schedule-panel .calendar-event.schedule .calendar-event-time,
.schedule-panel .calendar-event.schedule .calendar-participant-name,
.schedule-panel .calendar-event.schedule .calendar-no-participant {
  font-size: 8px;
}

.schedule-panel .calendar-participant-avatar {
  width: 12px;
  height: 12px;
  font-size: 6px !important;
}

@media (max-width: 640px) {
  .schedule-panel .schedule-heading h2 {
    font-size: 18px;
  }
  .schedule-detail-modal:not(.itinerary-mode) .schedule-detail-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
  }
  .schedule-detail-modal:not(.itinerary-mode) .schedule-detail-header > div:first-child {
    min-width: 0;
  }
  .schedule-detail-modal:not(.itinerary-mode) .schedule-detail-header-actions {
    width: auto;
    justify-content: flex-end;
  }
  .schedule-detail-action-button,
  .schedule-detail-modal:not(.itinerary-mode) .schedule-detail-action-button {
    width: 34px;
    min-height: 34px;
    flex: 0 0 34px;
    padding: 0;
  }
  .schedule-detail-action-button svg {
    width: 17px;
    height: 17px;
  }
  .schedule-detail-action-button span {
    display: none;
  }
  .schedule-filter-panel .poll-filter-header h2 {
    font-size: 16px;
  }
  .schedule-panel .schedule-mine-filter,
  .schedule-panel .view-toggle button {
    font-size: 10px;
  }
}
.create-modal,
.schedule-modal,
.poll-create-modal {
  display: flex;
  max-height: calc(100dvh - 48px);
  flex-direction: column;
}

.create-modal > .modal-header,
.create-modal > .modal-footer,
.schedule-modal > .modal-header,
.schedule-modal > .modal-footer,
.poll-create-modal > .modal-header,
.poll-create-modal > .modal-footer {
  flex: 0 0 auto;
}

.create-modal > .modal-body,
.schedule-modal > .modal-body,
.poll-create-modal > .modal-body {
  overflow-y: auto;
  min-height: 0;
  max-height: none;
  flex: 1 1 auto;
}

@media (max-width: 520px) {
  .create-modal,
  .schedule-modal,
  .poll-create-modal {
    max-height: 94dvh;
  }
  .create-modal > .modal-footer,
  .schedule-modal > .modal-footer,
  .poll-create-modal > .modal-footer {
    padding-bottom: max(15px, env(safe-area-inset-bottom));
  }
  .join-modal > .modal-footer,
  .settings-modal > .modal-footer,
  .vote-modal > .modal-footer,
  .schedule-detail-modal > .modal-footer,
  .add-member-modal > .modal-footer {
    padding-bottom: max(15px, env(safe-area-inset-bottom));
  }
}
@media (max-width: 380px) {
  .meetings-page {
    padding-right: max(13px, env(safe-area-inset-right));
    padding-left: max(13px, env(safe-area-inset-left));
  }
  .page-header h1 {
    font-size: 24px;
  }
  .meetings-section,
  .poll-filter-panel,
  .poll-panel,
  .schedule-panel,
  .members-panel {
    padding-right: 13px;
    padding-left: 13px;
  }
  .modal-header,
  .modal-body,
  .modal-footer {
    padding-right: 14px;
    padding-left: 14px;
  }
  .detail-tabs {
    justify-content: flex-start;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-width: none;
  }
  .detail-tabs::-webkit-scrollbar {
    display: none;
  }
  .detail-tabs button,
  .detail-overview .detail-tabs button {
    min-width: max-content;
    flex: 0 0 auto;
    padding-right: 10px;
    padding-left: 10px;
  }
  .modal-footer {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .modal-footer .primary-button,
  .modal-footer .cancel-button {
    min-width: 0;
  }
}
.schedule-detail-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 18px;
  padding: 5px;
  border: 1px solid #e6e0f5;
  border-radius: 13px;
  background: #f8f6fc;
}

.schedule-detail-tabs button {
  min-height: 38px;
  border: 0;
  border-radius: 9px;
  color: #667085;
  font-size: 11px;
  font-weight: 900;
  background: transparent;
}

.schedule-detail-tabs button.active {
  color: #6d28d9;
  background: #fff;
  box-shadow: 0 5px 14px rgba(91, 33, 182, 0.11);
}

.schedule-detail-tabs em {
  display: inline-grid;
  min-width: 18px;
  height: 18px;
  margin-left: 5px;
  padding: 0 4px;
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 8px;
  font-style: normal;
  background: #8b5cf6;
}

.schedule-detail-body .section-hidden {
  display: none !important;
}

.post-event-locked {
  display: grid;
  min-height: 180px;
  padding: 24px;
  border: 1px dashed #d8d0ec;
  border-radius: 16px;
  place-content: center;
  text-align: center;
  background: #fbfaff;
}

.post-event-locked strong {
  color: #344054;
  font-size: 14px;
}

.post-event-locked p {
  margin: 7px 0 0;
  color: #98a2b3;
  font-size: 10px;
}

.schedule-content {
  position: relative;
}

.schedule-memory-thumb {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  overflow: hidden;
  width: 46px;
  height: 46px;
  border: 1px solid #e7e1f4;
  border-radius: 10px;
  background: #faf8ff;
}

.schedule-memory-thumb + h3,
.schedule-memory-thumb ~ p {
  padding-right: 56px;
}

.aftercare-section {
  display: grid;
  gap: 18px;
  margin-top: 22px;
  padding: 22px;
  border: 1px solid #e7e1fb;
  border-radius: 18px;
  background: linear-gradient(145deg, #fbfaff 0%, #fff 48%, #fffafd 100%);
}

.aftercare-heading,
.aftercare-subheading,
.memory-editor-head,
.memory-editor-footer,
.settlement-summary > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.aftercare-kicker {
  display: block;
  margin-bottom: 5px;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.aftercare-heading h3 {
  margin: 0;
  color: #1d2939;
  font-size: 18px;
  font-weight: 900;
}

.aftercare-heading p,
.aftercare-subheading span,
.memory-editor-head span {
  display: block;
  margin: 5px 0 0;
  color: #8a94a6;
  font-size: 10px;
  line-height: 1.5;
}

.aftercare-status {
  padding: 6px 9px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f0eaff;
  white-space: nowrap;
}

.aftercare-loading,
.aftercare-viewer-notice,
.aftercare-empty {
  display: grid;
  min-height: 82px;
  align-content: center;
  justify-items: center;
  gap: 7px;
  padding: 16px;
  border: 1px dashed #dcd6ef;
  border-radius: 13px;
  color: #8a94a6;
  font-size: 10px;
  text-align: center;
  background: rgba(255, 255, 255, 0.74);
}

.aftercare-viewer-notice strong {
  color: #475467;
  font-size: 12px;
}

.aftercare-viewer-notice p,
.aftercare-loading p {
  margin: 0;
}

.memory-editor,
.memory-feed,
.expense-section {
  display: grid;
  gap: 14px;
  padding: 17px;
  border: 1px solid #ece9f5;
  border-radius: 14px;
  background: #fff;
}

.memory-editor-head strong,
.aftercare-subheading strong {
  color: #2d3442;
  font-size: 13px;
  font-weight: 900;
}

.memory-delete-button {
  padding: 5px 8px;
  border: 1px solid #fecdd3;
  border-radius: 7px;
  color: #be123c;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
}

.memory-photo-editor {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;
  padding: 7px;
  border: 1px dashed transparent;
  border-radius: 12px;
  transition: border-color 160ms ease, background-color 160ms ease;
}

.memory-photo-editor.drag-active {
  border-color: #8b5cf6;
  background: #f5f1ff;
}

.memory-file-input {
  display: none;
}

.memory-drop-hint {
  grid-column: 1/-1;
  color: #98a2b3;
  font-size: 9px;
  text-align: center;
}

.memory-photo-draft,
.memory-photo-add {
  position: relative;
  overflow: hidden;
  aspect-ratio: 4/3;
  border-radius: 10px;
}

.memory-photo-draft img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f3f8;
}

.memory-photo-draft button {
  position: absolute;
  top: 6px;
  right: 6px;
  display: grid;
  width: 23px;
  height: 23px;
  border: 0;
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 15px;
  background: rgba(17, 24, 39, 0.72);
}

.memory-photo-add {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 5px;
  border: 1px dashed #c4b5fd;
  color: #7c3aed;
  font-size: 9px;
  font-weight: 800;
  background: #faf8ff;
}

.memory-photo-add svg {
  width: 22px;
  height: 22px;
}

.memory-review-field,
.expense-entry label {
  display: grid;
  gap: 6px;
  color: #475467;
  font-size: 9px;
  font-weight: 800;
}

.memory-review-field {
  position: relative;
}

.memory-review-field textarea {
  min-height: 88px;
  padding: 11px 12px 24px;
  border: 1px solid #dfe3eb;
  border-radius: 10px;
  outline: none;
  color: #344054;
  font: inherit;
  font-size: 11px;
  line-height: 1.6;
  resize: vertical;
}

.memory-review-field textarea:focus,
.expense-entry input:focus,
.expense-entry select:focus {
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
}

.memory-review-field small {
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: #98a2b3;
  font-size: 8px;
}

.memory-editor-footer {
  align-items: center;
}

.memory-visibility {
  display: flex;
  gap: 6px;
}

.memory-visibility label {
  cursor: pointer;
}

.memory-visibility input {
  position: absolute;
  opacity: 0;
}

.memory-visibility span {
  display: block;
  padding: 7px 10px;
  border: 1px solid #e1e5eb;
  border-radius: 8px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
}

.memory-visibility input:checked + span {
  border-color: #a78bfa;
  color: #6d28d9;
  background: #f5f1ff;
}

.memory-save-button,
.expense-entry > button {
  min-height: 36px;
  padding: 0 13px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  background: #7c3aed;
}

.aftercare-subheading {
  align-items: center;
}

.aftercare-subheading em {
  color: #6d28d9;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
}

.memory-feed {
  background: #fcfbff;
}

.memory-card {
  padding: 14px;
  border: 1px solid #ece9f5;
  border-radius: 12px;
  background: #fff;
}

.memory-card.mine {
  border-color: #d8ccfa;
}

.memory-card > header {
  display: flex;
  align-items: center;
  gap: 9px;
}

.memory-card > header > div {
  min-width: 0;
  flex: 1 1 auto;
}

.memory-author-avatar,
.expense-payer-avatar,
.report-person-avatar {
  display: grid;
  overflow: hidden;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  border-radius: 999px;
  place-items: center;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  background: #ede9fe;
}

.memory-author-avatar img,
.expense-payer-avatar img,
.report-person-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.memory-card header strong,
.memory-card header small {
  display: block;
}

.memory-card header strong {
  color: #344054;
  font-size: 10px;
}

.memory-card header small {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 8px;
}

.memory-card > p {
  margin: 11px 0 0;
  color: #475467;
  font-size: 11px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.memory-photo-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  margin-top: 11px;
}

.memory-photo-grid.single {
  grid-template-columns: minmax(0, 1fr);
}

.memory-photo-view {
  overflow: hidden;
  min-width: 0;
  padding: 0;
  border: 1px solid #ece8f3;
  border-radius: 9px;
  background: #f7f5fa;
  cursor: zoom-in;
}

.memory-photo-grid img {
  width: 100%;
  max-height: 260px;
  aspect-ratio: 4/3;
  object-fit: contain;
}

.image-lightbox {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: grid;
  padding: 56px;
  place-items: center;
  background: rgba(10, 12, 20, 0.88);
  backdrop-filter: blur(8px);
}

.image-lightbox img {
  max-width: min(1180px, 100%);
  max-height: calc(100dvh - 112px);
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.38);
}

.image-lightbox-close {
  position: absolute;
  top: 20px;
  right: 24px;
  display: grid;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  place-items: center;
  color: #fff;
  font-size: 24px;
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 640px) {
  .schedule-detail-tabs {
    display: flex;
    overflow-x: auto;
  }
  .schedule-detail-tabs button {
    min-width: 88px;
    flex: 1 0 auto;
  }
  .image-lightbox {
    padding: 48px 14px 22px;
  }
}
.expense-entry {
  display: grid;
  grid-template-columns: minmax(140px, 1.6fr) minmax(110px, 0.8fr) minmax(120px, 0.9fr) auto;
  align-items: end;
  gap: 9px;
}

.expense-entry > button {
  grid-column: 4;
  grid-row: 1;
}

.expense-participant-picker {
  display: grid;
  grid-column: 1/-1;
  gap: 7px;
  padding-top: 3px;
}

.expense-participant-picker > span {
  color: #475467;
  font-size: 9px;
  font-weight: 800;
}

.expense-participant-picker > span em {
  margin-left: 5px;
  color: #7c3aed;
  font-style: normal;
}

.expense-participant-picker > div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.expense-participant-picker button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 6px;
  padding: 0 11px 0 6px;
  border: 1px solid #e1e5eb;
  border-radius: 999px;
  color: #667085;
  font-size: 9px;
  background: #fff;
}

.expense-participant-picker button > i {
  display: grid;
  width: 18px;
  height: 18px;
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  place-items: center;
  color: transparent;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #fff;
}

.expense-participant-picker button.selected {
  border-color: #7c3aed;
  color: #5b21b6;
  background: #ede9fe;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.12);
}

.expense-participant-picker button.selected > i {
  border-color: #7c3aed;
  color: #fff;
  background: #7c3aed;
}

.expense-entry input,
.expense-entry select {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #dfe3eb;
  border-radius: 9px;
  outline: none;
  color: #344054;
  font-size: 10px;
  background: #fff;
}

.expense-amount-input {
  position: relative;
}

.expense-amount-input input {
  padding-right: 28px;
}

.expense-amount-input em {
  position: absolute;
  top: 50%;
  right: 10px;
  color: #98a2b3;
  font-size: 9px;
  font-style: normal;
  transform: translateY(-50%);
}

.expense-list {
  overflow: hidden;
  border: 1px solid #e7eaf0;
  border-radius: 11px;
}

.expense-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 9px;
  padding: 10px 12px;
  border-bottom: 1px solid #edf0f4;
}

.expense-row:last-child {
  border-bottom: 0;
}

.expense-row strong,
.expense-row small {
  display: block;
}

.expense-row strong {
  color: #344054;
  font-size: 12px;
}

.expense-row small {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 10px;
  line-height: 1.45;
}

.expense-row > em {
  color: #1d2939;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.expense-row > button {
  display: grid;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #be123c;
  background: #fff1f3;
}

.settlement-payment-panel {
  display: grid;
  gap: 11px;
  padding: 15px;
  border: 1px solid #ded6fb;
  border-radius: 12px;
  background: #fbfaff;
}

.settlement-payment-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.settlement-payment-panel > header strong,
.settlement-payment-panel > header span {
  display: block;
}

.settlement-payment-panel > header strong {
  color: #4c1d95;
  font-size: 13px;
}

.settlement-payment-panel > header span {
  margin-top: 3px;
  color: #7c7193;
  font-size: 10px;
  line-height: 1.45;
}

.settlement-payment-panel > header em {
  flex: 0 0 auto;
  padding: 4px 8px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
  background: #ede9fe;
}

.settlement-payment-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.settlement-payment-list article {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 10px;
  border: 1px solid #ebe7f5;
  border-radius: 9px;
  background: #fff;
}

.settlement-payment-list article > div {
  min-width: 0;
}

.settlement-payment-list strong {
  color: #344054;
  font-size: 11px;
}

.settlement-payment-list p {
  margin: 4px 0 0;
  color: #6d28d9;
  font-size: 10px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.settlement-payment-list button {
  flex: 0 0 auto;
  padding: 4px 7px;
  border: 1px solid #fecdd3;
  border-radius: 6px;
  color: #be123c;
  font-size: 9px;
  font-weight: 800;
  background: #fff;
}

.settlement-payment-empty {
  padding: 10px;
  border-radius: 8px;
  color: #98a2b3;
  font-size: 10px;
  text-align: center;
  background: rgba(255, 255, 255, 0.72);
}

.settlement-payment-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 8px;
}

.settlement-payment-editor label {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.settlement-payment-editor label > span {
  color: #475467;
  font-size: 9px;
  font-weight: 800;
}

.settlement-payment-editor textarea {
  width: 100%;
  min-height: 78px;
  padding: 9px 10px;
  border: 1px solid #d8d1ed;
  border-radius: 9px;
  outline: none;
  color: #344054;
  font: inherit;
  font-size: 10px;
  line-height: 1.5;
  background: #fff;
  resize: vertical;
}

.settlement-payment-editor textarea:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.settlement-payment-editor label > small {
  justify-self: end;
  color: #98a2b3;
  font-size: 8px;
}

.settlement-payment-editor > button {
  min-width: 84px;
  min-height: 38px;
  padding: 0 13px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  background: #7c3aed;
}

.settlement-payment-editor > button:disabled,
.settlement-payment-list button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.settlement-summary {
  display: grid;
  gap: 12px;
  padding: 15px;
  border-radius: 12px;
  background: #f5f2ff;
}

.settlement-summary > header > div span,
.settlement-summary > header > div strong {
  display: block;
}

.settlement-summary > header span {
  color: #7c3aed;
  font-size: 11px;
  font-weight: 800;
}

.settlement-summary > header strong {
  margin-top: 3px;
  color: #4c1d95;
  font-size: 18px;
}

.settlement-summary > header p {
  max-width: 310px;
  margin: 0;
  color: #7c7193;
  font-size: 10px;
  line-height: 1.5;
  text-align: right;
}

.settlement-balances {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.settlement-balances > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 2px 8px;
  padding: 9px;
  border-radius: 9px;
  background: #fff;
}

.settlement-balances strong {
  color: #344054;
  font-size: 11px;
}

.settlement-balances span {
  grid-column: 1;
  color: #98a2b3;
  font-size: 10px;
}

.settlement-balances em {
  grid-row: 1/3;
  grid-column: 2;
  align-self: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
}

.settlement-balances em.receive {
  color: #047857;
}

.settlement-balances em.pay {
  color: #dc2626;
}

.settlement-transfers {
  display: grid;
  gap: 7px;
}

.settlement-transfers > strong {
  color: #4c1d95;
  font-size: 12px;
}

.settlement-transfers > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 10px;
  border-radius: 8px;
  color: #667085;
  font-size: 11px;
  background: #fff;
}

.settlement-transfers > div > div {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.settlement-transfers > div small {
  color: #6d28d9;
  font-size: 10px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.settlement-transfers p {
  margin: 0;
  color: #047857;
  font-size: 10px;
}

.settlement-transfers em {
  color: #6d28d9;
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.report-panel {
  display: grid;
  gap: 22px;
}

.report-heading {
  align-items: center;
}

.report-heading p {
  margin: 5px 0 0;
  color: #98a2b3;
  font-size: 10px;
}

.report-controls,
.report-period-toggle,
.report-navigator {
  display: flex;
  align-items: center;
  gap: 6px;
}

.report-controls {
  gap: 10px;
}

.report-period-toggle,
.report-navigator {
  padding: 3px;
  border: 1px solid #e2e5eb;
  border-radius: 9px;
  background: #f8f9fb;
}

.report-period-toggle button,
.report-navigator button {
  min-height: 30px;
  padding: 0 10px;
  border: 0;
  border-radius: 7px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
  background: transparent;
}

.report-period-toggle button.active {
  color: #6d28d9;
  background: #fff;
  box-shadow: 0 1px 4px rgba(36, 24, 69, 0.1);
}

.report-navigator strong {
  min-width: 82px;
  color: #344054;
  font-size: 10px;
  text-align: center;
}

.report-navigator button {
  padding: 0 7px;
  font-size: 17px;
}

.report-loading,
.report-empty {
  display: grid;
  min-height: 220px;
  align-content: center;
  justify-items: center;
  gap: 8px;
  color: #98a2b3;
  font-size: 10px;
  text-align: center;
}

.report-empty strong {
  color: #475467;
  font-size: 14px;
}

.report-empty p {
  margin: 0;
}

.report-summary-card {
  position: relative;
  display: grid;
  overflow: hidden;
  min-height: 96px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  padding: 17px 20px;
  border: 1px solid #ded5ff;
  border-radius: 18px;
  background: radial-gradient(circle at 88% -25%, rgba(255, 255, 255, 0.75) 0 18%, transparent 19%), linear-gradient(120deg, #f3efff 0%, #eee9ff 48%, #e8f0ff 100%);
}

.report-summary-card::after {
  position: absolute;
  right: 17%;
  bottom: -42px;
  width: 110px;
  height: 110px;
  border: 24px solid rgba(139, 92, 246, 0.08);
  border-radius: 999px;
  content: "";
}

.report-summary-card.empty {
  border-color: #e7eaf0;
  background: linear-gradient(120deg, #f8f9fb, #f5f3ff);
}

.report-summary-icon {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid rgba(124, 58, 237, 0.14);
  border-radius: 16px;
  font-size: 23px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 10px 25px rgba(91, 54, 167, 0.1);
}

.report-summary-copy {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.report-summary-copy span,
.report-summary-copy strong {
  display: block;
}

.report-summary-copy span {
  color: #7c3aed;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.04em;
}

.report-summary-copy strong {
  max-width: 900px;
  margin-top: 7px;
  color: #30254a;
  font-size: 16px;
  line-height: 1.55;
}

.report-summary-card > em {
  position: relative;
  z-index: 1;
  padding: 7px 10px;
  border: 1px solid rgba(124, 58, 237, 0.13);
  border-radius: 999px;
  color: #6d28d9;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.72);
}

.report-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 11px;
}

.report-stat-card {
  position: relative;
  overflow: hidden;
  min-height: 126px;
  padding: 18px;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  background: #fff;
}

.report-stat-card::after {
  position: absolute;
  top: -18px;
  right: -14px;
  width: 68px;
  height: 68px;
  border-radius: 999px;
  content: "";
  opacity: 0.55;
  background: #ede9fe;
}

.report-stat-card.blue::after {
  background: #dbeafe;
}

.report-stat-card.amber::after {
  background: #fef3c7;
}

.report-stat-card.emerald::after {
  background: #d1fae5;
}

.report-stat-card > span,
.report-stat-card > strong,
.report-stat-card > p,
.report-stat-scope {
  position: relative;
  z-index: 1;
  display: block;
}

.report-stat-scope {
  width: fit-content;
  margin-bottom: 8px;
  padding: 3px 6px;
  border-radius: 999px;
  color: #2563eb;
  font-size: 6px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: 0.1em;
  background: #eff6ff;
}

.report-stat-scope.group {
  color: #6d28d9;
  background: #f5f3ff;
}

.report-stat-card > span {
  color: #667085;
  font-size: 9px;
  font-weight: 800;
}

.report-stat-card > strong {
  margin-top: 7px;
  color: #1d2939;
  font-size: 22px;
  font-weight: 900;
}

.report-stat-card > strong small {
  margin-left: 2px;
  font-size: 11px;
}

.report-stat-card > p {
  margin: 5px 0 0;
  color: #98a2b3;
  font-size: 8px;
}

.report-content-section {
  padding: 20px;
  border: 1px solid #e7eaf0;
  border-radius: 17px;
  background: #fff;
}

.report-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.report-section-heading span,
.report-section-heading h3,
.report-section-heading p {
  display: block;
}

.report-section-heading > div:first-child > span {
  color: #7c3aed;
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.report-section-heading h3 {
  margin: 4px 0 0;
  color: #273142;
  font-size: 14px;
}

.report-section-heading p {
  margin-top: 3px;
  color: #98a2b3;
  font-size: 8px;
}

.report-section-heading > em {
  padding: 6px 9px;
  border-radius: 999px;
  color: #7c3aed;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  background: #f4f0ff;
}

.report-top-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 17px;
}

.report-top-card {
  min-width: 0;
  padding: 15px;
  border: 1px solid #eceef3;
  border-radius: 14px;
  background: #fbfbfd;
}

.report-top-card.people {
  background: #faf8ff;
}

.report-top-card.places {
  background: #fffaf5;
}

.report-top-card.activities {
  background: #f5fbff;
}

.report-top-card > header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.report-top-icon {
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 10px;
  font-size: 16px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(25, 33, 50, 0.06);
}

.report-top-card header strong,
.report-top-card header small {
  display: block;
}

.report-top-card header strong {
  color: #344054;
  font-size: 10px;
}

.report-top-card header small {
  margin-top: 3px;
  color: #98a2b3;
  font-size: 7px;
}

.report-ranking-list {
  display: grid;
  gap: 6px;
  margin-top: 13px;
}

.report-ranking-row {
  display: grid;
  min-width: 0;
  grid-template-columns: 18px 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  padding: 7px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.86);
}

.report-ranking-row.simple {
  grid-template-columns: 18px 30px minmax(0, 1fr) auto;
}

.report-ranking-row > em {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border-radius: 6px;
  color: #7c3aed;
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  background: #f1eaff;
}

.report-ranking-row:first-child > em {
  color: #92400e;
  background: #fef3c7;
}

.report-ranking-row > strong {
  overflow: hidden;
  color: #344054;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-ranking-row > small {
  color: #7c3aed;
  font-size: 8px;
  font-weight: 900;
  white-space: nowrap;
}

.report-rank-symbol {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 9px;
  color: #c5cad3;
  font-size: 12px;
  background: #fff;
}

.report-top-empty {
  display: grid;
  min-height: 118px;
  align-content: center;
  justify-items: center;
  gap: 7px;
  color: #98a2b3;
  text-align: center;
}

.report-top-empty span {
  font-size: 22px;
  opacity: 0.65;
}

.report-top-empty p {
  margin: 0;
  font-size: 8px;
}

.report-heatmap-legend,
.report-memory-counts {
  display: flex;
  align-items: center;
  gap: 5px;
}

.report-heatmap-legend span {
  color: #98a2b3;
  font-size: 7px;
}

.report-heatmap-legend i {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: #ede9fe;
}

.report-heatmap-legend i.level-2 {
  background: #c4b5fd;
}

.report-heatmap-legend i.level-3 {
  background: #7c3aed;
}

.report-heatmap-weekdays {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 7px;
  margin-top: 17px;
}

.report-heatmap-weekdays span {
  color: #98a2b3;
  font-size: 7px;
  font-weight: 800;
  text-align: center;
}

.report-heatmap-grid {
  display: grid;
  gap: 7px;
}

.report-heatmap-grid.month {
  grid-template-columns: repeat(7, minmax(0, 1fr));
  margin-top: 7px;
}

.report-heatmap-grid.year {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin-top: 17px;
}

.report-heatmap-cell {
  position: relative;
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 8px 9px;
  border: 1px solid #eeeef3;
  border-radius: 10px;
  color: #7b8494;
  background: #f8f9fb;
}

.report-heatmap-cell.level-1 {
  border-color: #ddd6fe;
  color: #6d28d9;
  background: #ede9fe;
}

.report-heatmap-cell.level-2 {
  border-color: #c4b5fd;
  color: #4c1d95;
  background: #c4b5fd;
}

.report-heatmap-cell.level-3 {
  border-color: #7c3aed;
  color: #fff;
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
  box-shadow: 0 6px 14px rgba(109, 40, 217, 0.16);
}

.report-heatmap-cell > strong {
  font-size: 9px;
}

.report-heatmap-cell > span {
  font-size: 7px;
  font-weight: 900;
}

.report-heatmap-cell > i {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 6px;
  height: 6px;
  border: 1px solid rgba(255, 255, 255, 0.95);
  border-radius: 999px;
  background: #fbbf24;
  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.16);
}

.report-memory-counts {
  gap: 7px;
}

.report-memory-counts > span {
  padding: 6px 9px;
  border: 1px solid #e8e4f5;
  border-radius: 999px;
  color: #667085;
  font-size: 7px;
  white-space: nowrap;
  background: #faf9ff;
}

.report-memory-counts strong {
  color: #6d28d9;
  font-size: 9px;
}

.report-memory-gallery {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;
  margin-top: 17px;
}

.report-memory-photo {
  position: relative;
  overflow: hidden;
  min-width: 0;
  height: 128px;
  padding: 0;
  border: 0;
  border-radius: 11px;
  background: #f2f0f8;
}

.report-memory-photo > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 180ms ease;
}

.report-memory-photo:hover > img {
  transform: scale(1.035);
}

.report-memory-photo-meta {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  padding: 22px 10px 9px;
  color: #fff;
  background: linear-gradient(transparent, rgba(19, 14, 33, 0.78));
}

.report-memory-author-avatar {
  display: grid;
  overflow: hidden;
  width: 22px;
  height: 22px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 999px;
  font-size: 7px;
  background: #8b5cf6;
}

.report-memory-author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.report-memory-author-avatar em {
  color: #fff;
  font-style: normal;
  font-weight: 900;
}

.report-memory-photo-meta > strong {
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-memory-photo-meta > small {
  color: rgba(255, 255, 255, 0.78);
  font-size: 7px;
}

.report-memory-empty {
  display: grid;
  min-height: 205px;
  align-content: center;
  justify-items: center;
  gap: 7px;
  margin-top: 17px;
  border: 1px dashed #ddd8eb;
  border-radius: 14px;
  color: #98a2b3;
  text-align: center;
  background: #fbfaff;
}

.report-memory-empty.compact {
  min-height: 145px;
}

.report-memory-empty > div {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  border-radius: 14px;
  font-size: 21px;
  background: #f1edff;
}

.report-memory-empty strong {
  color: #475467;
  font-size: 11px;
}

.report-memory-empty p {
  max-width: 430px;
  margin: 0;
  font-size: 8px;
  line-height: 1.5;
}

@media (max-width: 900px) {
  .report-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .report-heatmap-grid.year {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .expense-entry {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expense-entry > button {
    grid-column: 1/-1;
    grid-row: auto;
  }
}
@media (max-width: 640px) {
  .aftercare-section {
    padding: 15px;
  }
  .memory-photo-editor {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .memory-editor-footer,
  .report-heading,
  .report-controls,
  .report-section-heading {
    align-items: stretch;
    flex-direction: column;
  }
  .memory-save-button {
    width: 100%;
  }
  .expense-entry,
  .settlement-balances,
  .settlement-payment-list,
  .report-stat-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .settlement-payment-editor {
    grid-template-columns: minmax(0, 1fr);
  }
  .settlement-payment-editor > button {
    width: 100%;
  }
  .settlement-summary > header {
    align-items: flex-start;
    flex-direction: column;
  }
  .settlement-summary > header p {
    text-align: left;
  }
  .report-period-toggle button,
  .report-navigator strong {
    flex: 1 1 0;
  }
  .report-summary-card {
    grid-template-columns: auto minmax(0, 1fr);
    padding: 16px;
  }
  .report-summary-card > em {
    display: none;
  }
  .report-summary-copy strong {
    font-size: 13px;
  }
  .report-top-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .report-content-section {
    padding: 16px;
  }
  .report-heatmap-legend,
  .report-memory-counts {
    align-self: flex-start;
  }
  .report-heatmap-grid.year {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .report-heatmap-cell {
    min-height: 42px;
    padding: 5px;
  }
  .report-heatmap-cell > span {
    display: none;
  }
  .report-memory-gallery {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .report-memory-photo {
    height: 104px;
  }
}
.aftercare-heading-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.aftercare-share-button {
  display: inline-flex;
  min-height: 31px;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid #ded6fb;
  border-radius: 9px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #fff;
}

.aftercare-share-button:hover {
  border-color: #c4b5fd;
  background: #faf8ff;
}

.aftercare-share-button svg {
  width: 14px;
  height: 14px;
}

.aftercare-section.expense-mode {
  gap: 20px;
  border-color: #e4e7ec;
  background: #fbfcff;
}

.expense-management.expense-section {
  gap: 18px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.expense-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.expense-stat-card {
  display: grid;
  min-width: 0;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  padding: 15px;
  border: 1px solid #e4e7ec;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(31, 35, 48, 0.025);
}

.expense-stat-icon {
  display: grid;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  align-items: center;
  justify-items: center;
  place-items: center;
}

.expense-stat-icon svg {
  display: block;
  width: 19px;
  height: 19px;
}

.expense-stat-card.total .expense-stat-icon {
  color: #7c3aed;
  background: #f1eaff;
}

.expense-stat-card.paid .expense-stat-icon {
  color: #059669;
  background: #eafaf3;
}

.expense-stat-card.pending .expense-stat-icon {
  color: #ef476f;
  background: #fff0f3;
}

.expense-stat-card > div > span,
.expense-stat-card strong,
.expense-stat-card small {
  display: block;
}

.expense-stat-card > div > span {
  color: #7c8799;
  font-size: 9px;
  font-weight: 800;
}

.expense-stat-card strong {
  margin-top: 4px;
  color: #172033;
  font-size: 17px;
  font-weight: 900;
  letter-spacing: -0.025em;
}

.expense-stat-card small {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 8px;
}

.expense-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1.8fr) minmax(235px, 0.72fr);
  align-items: start;
  gap: 14px;
}

.expense-management-main,
.expense-schedule-card {
  border: 1px solid #e2e6ed;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 9px 24px rgba(31, 35, 48, 0.025);
}

.expense-management-main {
  overflow: hidden;
}

.expense-management-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0 16px;
  border-bottom: 1px solid #e7eaf0;
}

.expense-management-tabs button {
  position: relative;
  min-height: 48px;
  padding: 0 8px;
  border: 0;
  color: #8a94a6;
  font-size: 10px;
  font-weight: 900;
  background: transparent;
}

.expense-management-tabs button::after {
  position: absolute;
  right: 12px;
  bottom: -1px;
  left: 12px;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: transparent;
  content: "";
}

.expense-management-tabs button.active {
  color: #6d28d9;
}

.expense-management-tabs button.active::after {
  background: #7c3aed;
}

.expense-management-panel {
  display: grid;
  gap: 15px;
  padding: 17px;
}

.expense-panel-heading strong,
.expense-panel-heading span {
  display: block;
}

.expense-panel-heading strong,
.expense-list-heading strong {
  color: #27324a;
  font-size: 12px;
  font-weight: 900;
}

.expense-panel-heading span {
  margin-top: 4px;
  color: #8a94a6;
  font-size: 9px;
  line-height: 1.5;
}

.expense-list-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 2px;
}

.expense-list-heading span {
  color: #8b5cf6;
  font-size: 9px;
  font-weight: 900;
}

.expense-management .expense-entry {
  padding: 13px;
  border: 1px solid #ece8f5;
  border-radius: 11px;
  background: #fcfbff;
}

.expense-management .expense-row {
  min-height: 57px;
  padding: 11px 13px;
}

.expense-management .expense-payer-avatar {
  width: 32px;
  height: 32px;
}

.expense-management .settlement-summary {
  gap: 14px;
  padding: 0;
  background: transparent;
}

.expense-management .settlement-summary > header {
  padding: 14px;
  border: 1px solid #ded6fb;
  border-radius: 11px;
  background: linear-gradient(135deg, #f8f5ff, #fdfcff);
}

.expense-management .settlement-balances {
  gap: 8px;
}

.expense-management .settlement-balances > div {
  display: grid;
  min-width: 0;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  padding: 10px;
  border: 1px solid #eceef2;
  background: #fff;
}

.settlement-person-avatar {
  display: grid;
  overflow: hidden;
  width: 31px;
  height: 31px;
  border-radius: 999px;
  place-items: center;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #ede9fe;
}

.settlement-person-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.expense-management .settlement-balances > div > div {
  min-width: 0;
}

.expense-management .settlement-balances > div > div strong,
.expense-management .settlement-balances > div > div span {
  display: block;
}

.expense-management .settlement-balances > div > div span {
  margin-top: 3px;
}

.expense-management .settlement-balances em {
  grid-row: auto;
  grid-column: auto;
  text-align: right;
  white-space: nowrap;
}

.expense-management .settlement-transfers {
  padding: 13px;
  border: 1px solid #eceef2;
  border-radius: 11px;
  background: #fbfcfe;
}

.expense-management .settlement-payment-panel {
  padding: 0;
  border: 0;
  background: transparent;
}

.expense-schedule-card {
  position: sticky;
  top: 0;
  padding: 17px;
}

.expense-schedule-card > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 13px;
  border-bottom: 1px solid #edf0f4;
}

.expense-schedule-card > header strong {
  color: #27324a;
  font-size: 12px;
  font-weight: 900;
}

.expense-schedule-card > header span {
  color: #8b5cf6;
  font-size: 8px;
  font-weight: 900;
}

.expense-schedule-card dl {
  display: grid;
  gap: 12px;
  margin: 15px 0 0;
}

.expense-schedule-card dl > div {
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
}

.expense-schedule-card dt,
.expense-schedule-card dd {
  margin: 0;
  font-size: 9px;
  line-height: 1.45;
}

.expense-schedule-card dt {
  color: #8a94a6;
  font-weight: 700;
}

.expense-schedule-card dd {
  color: #344054;
  font-weight: 900;
  text-align: right;
  overflow-wrap: anywhere;
}

.expense-schedule-card dd.total {
  color: #172033;
  font-size: 12px;
}

.expense-schedule-datetime {
  display: grid;
  min-width: 0;
  justify-items: end;
  gap: 3px;
}

.expense-schedule-datetime .date {
  white-space: nowrap;
}

.expense-schedule-datetime .time {
  color: #667085;
  font-size: 8px;
  line-height: 1.3;
  white-space: nowrap;
}

.expense-share-tip {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 17px;
  padding: 13px;
  border-radius: 11px;
  color: #7c3aed;
  background: linear-gradient(135deg, #f8f4ff, #fbf8ff);
}

.expense-share-tip > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.expense-share-tip > div {
  min-width: 0;
}

.expense-share-tip strong {
  display: block;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  line-height: 16px;
}

.expense-share-tip p {
  margin: 5px 0 0;
  color: #7c7193;
  font-size: 8px;
  line-height: 1.6;
}

@media (max-width: 900px) {
  .expense-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .expense-schedule-card {
    position: static;
  }
  .expense-schedule-card dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .expense-summary-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .expense-stat-card {
    min-height: 78px;
  }
}
@media (max-width: 640px) {
  .aftercare-heading-actions {
    align-items: flex-end;
    flex-direction: column-reverse;
  }
  .aftercare-share-button {
    width: 31px;
    justify-content: center;
    padding: 0;
  }
  .aftercare-share-button span {
    display: none;
  }
  .expense-management-tabs {
    padding: 0 7px;
  }
  .expense-management-tabs button {
    min-height: 44px;
    font-size: 9px;
  }
  .expense-management-panel {
    padding: 13px;
  }
  .expense-schedule-card dl {
    grid-template-columns: minmax(0, 1fr);
  }
  .expense-management .settlement-balances {
    grid-template-columns: minmax(0, 1fr);
  }
}
.settlement-payment-list .payment-info-card {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  min-width: 0;
  gap: 13px;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 7px 18px rgba(33, 23, 60, 0.035);
}

.settlement-payment-list .payment-info-card.mine {
  border-color: #cfc1fa;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.055);
}

.payment-info-actions {
  position: static;
  display: flex;
  grid-column: 2;
  grid-row: 1;
  align-items: center;
  align-self: start;
  justify-self: end;
  gap: 3px;
}

.payment-info-actions button {
  position: static;
  display: inline-flex;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
  background: transparent;
}

.payment-info-actions .payment-info-edit {
  width: auto;
  gap: 3px;
  padding: 0 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
}

.settlement-payment-list .payment-info-edit:hover:not(:disabled) {
  background: #f4f0ff;
}

.settlement-payment-list .payment-info-delete:hover:not(:disabled) {
  color: #be123c;
  background: #fff1f3;
}

.payment-info-actions svg {
  width: 15px;
  height: 15px;
}

.payment-info-card-heading {
  display: flex;
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  align-items: center;
  gap: 9px;
  padding-right: 0;
}

.payment-info-avatar {
  display: grid;
  overflow: hidden;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  border-radius: 999px;
  place-items: center;
  color: #6d28d9;
  font-size: 10px;
  font-weight: 900;
  background: #eee9ff;
}

.payment-info-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.payment-info-card-heading > div {
  min-width: 0;
}

.payment-info-card-heading strong,
.payment-info-card-heading > div > span {
  display: block;
}

.payment-info-card-heading strong {
  color: #253047;
  font-size: 11px;
  font-weight: 900;
}

.payment-info-card-heading > div > span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 8px;
}

.payment-account-summary {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  grid-column: 1/-1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
  padding-top: 11px;
  border-top: 1px solid #ece8f4;
}

.payment-account-primary {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.payment-bank-chip {
  display: inline-flex;
  min-height: 27px;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 900;
  background: #f0ebff;
}

.payment-account-number {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.payment-account-number small {
  color: #98a2b3;
  font-size: 8px;
  font-weight: 800;
}

.payment-account-number strong {
  min-width: 0;
  color: #344054;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  font-weight: 900;
  overflow-wrap: anywhere;
}

.settlement-payment-list .payment-account-copy {
  display: inline-flex;
  min-height: 28px;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  border: 1px solid #ddd6fe;
  border-radius: 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #fff;
}

.settlement-payment-list .payment-account-copy:hover:not(:disabled) {
  border-color: #bba8f8;
  background: #f7f3ff;
}

.payment-account-copy svg {
  width: 12px;
  height: 12px;
}

.settlement-payment-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: stretch;
  gap: 14px;
  margin-top: 4px;
  padding: 15px;
  border: 1px solid #ded6fb;
  border-radius: 12px;
  background: linear-gradient(145deg, #faf8ff, #fdfcff);
}

.settlement-payment-editor > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.settlement-payment-editor > header strong,
.settlement-payment-editor > header div > span {
  display: block;
}

.settlement-payment-editor > header strong {
  color: #3b2a68;
  font-size: 11px;
  font-weight: 900;
}

.settlement-payment-editor > header div > span {
  margin-top: 4px;
  color: #7c7193;
  font-size: 8px;
  line-height: 1.5;
}

.payment-editor-status {
  flex: 0 0 auto;
  padding: 4px 7px;
  border-radius: 999px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 900;
  background: #eee9ff;
}

.payment-editor-fields {
  display: grid;
  grid-template-columns: minmax(155px, 0.42fr) minmax(230px, 1fr);
  align-items: start;
  gap: 10px;
}

.settlement-payment-editor .payment-editor-fields > label {
  display: grid;
  min-width: 0;
  gap: 6px;
}

.settlement-payment-editor .payment-editor-fields > label > span {
  color: #475467;
  font-size: 9px;
  font-weight: 900;
}

.payment-bank-combobox,
.payment-bank-control {
  min-width: 0;
}

.payment-bank-control {
  position: relative;
}

.payment-bank-control input,
.settlement-payment-editor .payment-editor-fields > label > input {
  width: 100%;
  height: 40px;
  padding: 0 11px;
  border: 1px solid #d8dce5;
  border-radius: 9px;
  outline: none;
  color: #253047;
  font: inherit;
  font-size: 10px;
  font-weight: 700;
  background: #fff;
}

.payment-bank-control input {
  padding-right: 33px;
}

.payment-bank-control input:focus,
.settlement-payment-editor .payment-editor-fields > label > input:focus {
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.09);
}

.payment-bank-toggle {
  position: absolute;
  top: 50%;
  right: 5px;
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  place-items: center;
  color: #98a2b3;
  background: transparent;
  transform: translateY(-50%);
}

.payment-bank-toggle:hover:not(:disabled) {
  color: #6d28d9;
  background: #f4f0ff;
}

.payment-bank-toggle svg {
  width: 14px;
  height: 14px;
  transition: transform 150ms ease;
}

.payment-bank-combobox.open .payment-bank-toggle svg {
  transform: rotate(180deg);
}

.payment-bank-control input:disabled,
.settlement-payment-editor .payment-editor-fields > label > input:disabled {
  cursor: not-allowed;
  color: #98a2b3;
  background: #f2f3f6;
}

.payment-bank-options {
  display: grid;
  overflow-y: auto;
  max-height: 174px;
  margin-top: 5px;
  padding: 5px;
  border: 1px solid #ddd6ee;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 26px rgba(31, 24, 52, 0.1);
}

.payment-bank-options button {
  display: flex;
  min-height: 33px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 9px;
  border: 0;
  border-radius: 7px;
  color: #475467;
  font-size: 9px;
  font-weight: 800;
  text-align: left;
  background: transparent;
}

.payment-bank-options button:hover,
.payment-bank-options button.selected {
  color: #6d28d9;
  background: #f4f0ff;
}

.payment-bank-options button svg {
  width: 13px;
  height: 13px;
}

.payment-bank-options p {
  margin: 0;
  padding: 13px 8px;
  color: #98a2b3;
  font-size: 9px;
  text-align: center;
}

.payment-editor-footer {
  display: flex;
  min-height: 38px;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.payment-editor-footer p {
  min-width: 0;
  flex: 1 1 auto;
  margin: 0;
  color: #8a94a6;
  font-size: 8px;
  line-height: 1.45;
}

.payment-editor-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 7px;
}

.settlement-payment-editor .payment-editor-actions > button {
  min-width: 118px;
  min-height: 38px;
  padding: 0 13px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  font-size: 9px;
  font-weight: 900;
  background: #7c3aed;
}

.settlement-payment-editor .payment-editor-actions > button.secondary {
  min-width: 62px;
  border: 1px solid #ddd6fe;
  color: #6d28d9;
  background: #fff;
}

.settlement-payment-editor .payment-editor-actions > button:disabled {
  cursor: not-allowed;
  color: #98a2b3;
  background: #e8e9ee;
  opacity: 1;
}

.payment-copy-toast {
  position: fixed;
  right: 50%;
  bottom: max(24px, env(safe-area-inset-bottom));
  z-index: 1600;
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 8px;
  padding: 0 15px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 11px;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  background: rgba(29, 41, 57, 0.94);
  box-shadow: 0 14px 34px rgba(16, 24, 40, 0.24);
  backdrop-filter: blur(8px);
  transform: translateX(50%);
}

.payment-copy-toast svg {
  width: 17px;
  height: 17px;
  color: #c4b5fd;
}

@media (max-width: 640px) {
  .payment-editor-fields {
    grid-template-columns: minmax(0, 1fr);
  }
  .payment-editor-footer {
    align-items: stretch;
    flex-direction: column;
  }
  .payment-editor-actions,
  .settlement-payment-editor .payment-editor-actions > button {
    width: 100%;
  }
  .payment-account-primary {
    gap: 8px;
  }
}`],
})
export class PageMembersComponent implements OnInit, OnDestroy {
    public loading: boolean = false;
    public saving: boolean = false;
    public meetings: any[] = [];
    public detail: any = null;
    public detailRoute: boolean = false;
    public mySearch: string = '';

    public showCreateModal: boolean = false;
    public showJoinModal: boolean = false;
    public showScheduleModal: boolean = false;
    public showCreatePollModal: boolean = false;
    public showPollModal: boolean = false;
    public showScheduleDetailModal: boolean = false;
    public showSettingsModal: boolean = false;
    public showAddMemberModal: boolean = false;

    public createData: any = this.emptyMeeting();
    public settingsData: any = this.emptyMeeting();
    public addMemberData: any = this.emptyMember();
    public successorId: string = '';
    public deleteConfirmation: string = '';
    public joinSearch: string = '';
    public joinResults: any[] = [];
    public selectedJoin: any = null;
    public joinPassword: string = '';
    public searching: boolean = false;
    public scheduleData: any = this.emptySchedule();
    public scheduleSource: any = null;
    public editingScheduleId: string = '';
    public scheduleRecurrenceOpen: boolean = true;
    public scheduleReminderOpen: boolean = true;
    public scheduleParticipantIds: string[] = [];
    public placeAddressLoading: boolean = false;
    public placeAddressMessage: string = '';
    public draggedSchedule: any = null;
    public calendarDragAnchorKey: string = '';
    public calendarDropDateKey: string = '';
    public calendarScheduleMovingId: string = '';
    public readonly recurrenceOptions: any[] = [
        { value: 'none', label: '반복 안 함' },
        { value: 'daily', label: '매일' },
        { value: 'weekly', label: '매주' },
        { value: 'monthly', label: '매월' },
        { value: 'custom', label: '사용자 지정' }
    ];
    public readonly recurrenceWeekdays: any[] = [
        { value: 0, label: '월' }, { value: 1, label: '화' },
        { value: 2, label: '수' }, { value: 3, label: '목' },
        { value: 4, label: '금' }, { value: 5, label: '토' },
        { value: 6, label: '일' }
    ];
    public readonly reminderOptions: any[] = [
        { value: '10', label: '10분 전' },
        { value: '30', label: '30분 전' },
        { value: '60', label: '1시간 전' },
        { value: '1440', label: '1일 전' },
        { value: 'custom', label: '사용자 지정' }
    ];

    public detailTab: string = 'schedule';
    public scheduleView: string = 'calendar';
    public schedulePage: number = 1;
    public readonly schedulePageSize: number = 5;
    public scheduleMonthFilter: string = 'all';
    public scheduleStatusFilter: string = 'all';
    public scheduleParticipationFilter: string = 'all';
    public calendarMineOnly: boolean = false;
    public calendarDate: Date = new Date();
    public weekdayHeaders: string[] = ['일', '월', '화', '수', '목', '금', '토'];
    public pollKindFilter: string = 'all';
    public pollStatusFilter: string = 'all';
    public pollParticipationFilter: string = 'all';
    public pollSort: string = 'latest';
    public pollView: string = 'list';

    public pollData: any = this.emptyPoll();
    public pollOptionDraft: any = this.emptyPollOptionDraft();
    public pollFormError: string = '';
    public selectedPoll: any = null;
    public selectedPollOptions: string[] = [];
    public pollVoteError: string = '';
    public pollVoteNotice: string = '';
    public pollOptionAddDraft: any = this.emptyPollOptionAddDraft();
    public pollCalendarDate: Date = new Date();

    public selectedSchedule: any = null;
    public itineraryEditing: boolean = false;
    public itineraryDraft: any[] = [];
    public scheduleDetailTab: 'schedule' | 'itinerary' | 'memory' | 'expense' = 'schedule';
    public expenseDetailTab: 'expenses' | 'settlement' | 'payment' = 'expenses';
    public lightboxImage: string = '';
    public lightboxAlt: string = '';
    public memoryDropActive: boolean = false;
    public routeSummaryExpanded: boolean = true;
    public readonly itineraryMaxStops: number = 30;
    public aftercareLoading: boolean = false;
    public scheduleAftercare: any = null;
    public memoryDraft: any = this.emptyMemory();
    public expenseDraft: any = this.emptyExpense();
    public paymentInfoDraft: any = this.emptyPaymentInfo();
    public paymentInfoEditing: boolean = false;
    public paymentInfoEditingId: string = '';
    public paymentInfoEditingEntryId: string = '';
    public paymentBankSearch: string = '';
    public paymentBankDropdownOpen: boolean = false;
    public paymentToastMessage: string = '';
    public readonly paymentBankOptions: string[] = [
        'KB국민은행', '신한은행', '우리은행', '하나은행', 'NH농협은행',
        'IBK기업은행', 'SC제일은행', '한국씨티은행', 'Sh수협은행',
        '카카오뱅크', '토스뱅크', '케이뱅크', '부산은행', 'iM뱅크',
        '광주은행', '전북은행', '제주은행', '새마을금고', '신협',
        '우체국', '저축은행', '산림조합'
    ];
    public readonly paymentAccountPatterns: { [key: string]: number[] } = {
        'KB국민은행': [6, 2, 6],
        '신한은행': [3, 3, 6],
        '우리은행': [4, 3, 6],
        '하나은행': [3, 6, 5],
        'NH농협은행': [3, 4, 4, 2],
        'IBK기업은행': [3, 6, 2, 3],
        'SC제일은행': [3, 2, 6],
        '한국씨티은행': [3, 5, 3],
        'Sh수협은행': [4, 4, 4],
        '카카오뱅크': [4, 2, 7],
        '토스뱅크': [4, 4, 4],
        '케이뱅크': [3, 3, 6],
        '부산은행': [3, 4, 4, 2],
        'iM뱅크': [3, 2, 6],
        '광주은행': [3, 3, 6],
        '전북은행': [3, 4, 4, 2],
        '제주은행': [3, 3, 6],
        '우체국': [6, 2, 6]
    };
    public reportLoading: boolean = false;
    public reportPeriod: 'month' | 'year' = 'month';
    public reportAnchor: Date = new Date();
    public reportData: any = null;

    private searchTimer: any = null;
    private routerSub: any = null;
    private paymentBankCloseTimer: any = null;
    private paymentToastTimer: any = null;
    private suppressCalendarClickUntil: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {
        this.detailRoute = !!(WizRoute.segment.id || '');
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) await this.syncMeetingRoute();
        });

        const meetingId = WizRoute.segment.id || '';
        if (meetingId) {
            await this.openMeeting({ id: meetingId }, true, false);
            return;
        }

        await this.load();
        await this.openRequestedAction();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.searchTimer) clearTimeout(this.searchTimer);
        if (this.paymentBankCloseTimer) clearTimeout(this.paymentBankCloseTimer);
        if (this.paymentToastTimer) clearTimeout(this.paymentToastTimer);
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('list', { text: this.mySearch });
        this.meetings = code === 200 ? (data || []) : [];
        this.loading = false;
        await this.service.render();
    }

    public searchMyMeetings() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(async () => await this.load(), 250);
    }

    public openCreate() {
        this.createData = this.emptyMeeting();
        this.showCreateModal = true;
        this.service.render();
    }

    public closeCreate() {
        if (this.saving) return;
        this.showCreateModal = false;
        this.service.render();
    }

    public async chooseImage() {
        const image = await this.service.file.read({
            type: 'image',
            accept: 'image/*',
            width: 480,
            quality: 0.78
        });
        if (!image) return;
        if (image.length > 2 * 1024 * 1024) {
            await this.service.modal.error('이미지 용량이 너무 큽니다. 다른 이미지를 선택해주세요.');
            return;
        }
        this.createData.image = image;
        await this.service.render();
    }

    public async createMeeting() {
        if (!this.createData.name.trim()) {
            await this.service.modal.error('모임명을 입력해주세요.');
            return;
        }
        if (this.createData.password.length < 4) {
            await this.service.modal.error('비밀번호는 4자 이상 입력해주세요.');
            return;
        }

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('create', this.createData);
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(data, '모임을 만들지 못했습니다.'));
            await this.service.render();
            return;
        }

        this.showCreateModal = false;
        await this.load();
        await this.service.modal.success('모임이 만들어졌습니다.');
        await this.openMeeting(data);
    }

    public openJoin() {
        this.joinSearch = '';
        this.joinResults = [];
        this.selectedJoin = null;
        this.joinPassword = '';
        this.showJoinModal = true;
        this.service.render();
    }

    public closeJoin() {
        if (this.saving) return;
        this.showJoinModal = false;
        this.service.render();
    }

    public searchToJoin() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(async () => await this.findMeetings(), 280);
    }

    public async findMeetings() {
        const keyword = this.joinSearch.trim();
        if (!keyword) {
            this.joinResults = [];
            this.searching = false;
            await this.service.render();
            return;
        }

        this.searching = true;
        await this.service.render();
        const { code, data } = await wiz.call('search', { text: keyword });
        this.joinResults = code === 200 ? (data || []) : [];
        this.searching = false;
        await this.service.render();
    }

    public selectToJoin(meeting: any) {
        if (meeting.is_member) {
            this.showJoinModal = false;
            this.openMeeting(meeting);
            return;
        }
        this.selectedJoin = meeting;
        this.joinPassword = '';
        this.service.render();
    }

    public backToSearch() {
        this.selectedJoin = null;
        this.joinPassword = '';
        this.service.render();
    }

    public async joinMeeting() {
        if (!this.joinPassword) {
            await this.service.modal.error('모임 비밀번호를 입력해주세요.');
            return;
        }

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('join', {
            id: this.selectedJoin.id,
            password: this.joinPassword
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(data, '모임에 가입하지 못했습니다.'));
            await this.service.render();
            return;
        }

        this.showJoinModal = false;
        await this.load();
        await this.service.modal.success('모임에 가입했습니다.');
        await this.openMeeting(data);
    }

    public async openMeeting(meeting: any, resetView: boolean = true, syncUrl: boolean = true) {
        const meetingId = meeting?.id || '';
        if (!meetingId) return;
        const target = `/meetings/${encodeURIComponent(meetingId)}`;
        if (syncUrl && location.pathname !== target) {
            await this.router.navigateByUrl(target);
            return;
        }
        this.loading = true;
        if (resetView) this.detail = null;
        await this.service.render();
        const { code, data } = await wiz.call('detail', { id: meetingId });
        this.loading = false;

        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(data, '모임 정보를 불러오지 못했습니다.'));
            if (location.pathname !== '/meetings') await this.router.navigateByUrl('/meetings');
            await this.service.render();
            return;
        }

        this.detail = data;
        if (resetView) {
            this.detailTab = 'schedule';
            this.scheduleView = 'calendar';
            this.schedulePage = 1;
            this.scheduleMonthFilter = 'all';
            this.scheduleStatusFilter = 'all';
            this.scheduleParticipationFilter = 'all';
            this.calendarMineOnly = false;
            this.calendarDate = new Date();
            this.pollKindFilter = 'all';
            this.pollStatusFilter = 'all';
            this.pollParticipationFilter = 'all';
            this.pollSort = 'latest';
            this.pollView = 'list';
            this.reportPeriod = 'month';
            this.reportAnchor = this.defaultReportAnchor(
                data?.schedules || []
            );
            this.reportData = null;
            this.scrollPageTop();
        } else {
            this.schedulePage = Math.min(
                this.schedulePage,
                this.schedulePageCount()
            );
        }
        await this.service.render();

        const requestedPollId = new URLSearchParams(location.search).get('poll');
        const requestedPoll = requestedPollId
            ? (this.detail.polls || []).find((poll: any) => poll.id === requestedPollId)
            : null;
        if (requestedPoll) {
            this.detailTab = 'poll';
            this.openPoll(requestedPoll);
            return;
        }

        const requestedScheduleId = new URLSearchParams(location.search).get('schedule');
        const requestedSchedule = requestedScheduleId
            ? (this.detail.schedules || []).find(
                (schedule: any) => schedule.id === requestedScheduleId
            )
            : null;
        if (requestedSchedule) {
            this.detailTab = 'schedule';
            this.openScheduleDetail(requestedSchedule);
        }
    }

    public async closeDetail() {
        await this.router.navigateByUrl('/meetings');
    }

    public openSettings() {
        if (this.detail?.meeting?.my_role !== 'owner') return;
        this.settingsData = {
            name: this.detail.meeting.name || '',
            password: '',
            description: this.detail.meeting.description || '',
            image: this.detail.meeting.image || ''
        };
        this.successorId = '';
        this.deleteConfirmation = '';
        this.showSettingsModal = true;
        this.service.render();
    }

    public closeSettings() {
        if (this.saving) return;
        this.showSettingsModal = false;
        this.successorId = '';
        this.deleteConfirmation = '';
        this.service.render();
    }

    public async chooseSettingsImage() {
        const image = await this.service.file.read({
            type: 'image',
            accept: 'image/*',
            width: 480,
            quality: 0.78
        });
        if (!image) return;
        if (image.length > 2 * 1024 * 1024) {
            await this.service.modal.error(
                '이미지 용량이 너무 큽니다. 다른 이미지를 선택해주세요.'
            );
            return;
        }
        this.settingsData.image = image;
        await this.service.render();
    }

    public async saveMeetingSettings() {
        if (this.saving || this.detail?.meeting?.my_role !== 'owner') return;
        if (!this.settingsData.name.trim()) {
            await this.service.modal.error('모임명을 입력해주세요.');
            return;
        }
        if (
            this.settingsData.password
            && this.settingsData.password.length < 4
        ) {
            await this.service.modal.error(
                '새 비밀번호는 4자 이상 입력해주세요.'
            );
            return;
        }

        const meeting = this.detail.meeting;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('update_meeting', {
            id: meeting.id,
            ...this.settingsData
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '모임 설정을 저장하지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        this.showSettingsModal = false;
        await this.load();
        await this.openMeeting(data, false);
        await this.service.modal.success('모임 설정을 저장했습니다.');
    }

    public async leaveMeeting() {
        if (
            this.saving
            || !this.detail?.meeting
            || this.detail.meeting.my_role === 'owner'
        ) return;
        const confirmed = await this.service.modal.warning(
            '모임에서 탈퇴해도 기존 투표와 일정 참여 기록은 유지되며, 참여 중인 모임 목록에서만 제외됩니다.',
            '취소',
            '모임 탈퇴'
        );
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('leave_meeting', {
            id: this.detail.meeting.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '모임에서 탈퇴하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        await this.finishMeetingExit('모임에서 탈퇴했습니다.');
    }

    public successorCandidates() {
        const ownerId = this.detail?.meeting?.owner_id || '';
        return (this.detail?.members || []).filter(
            (member: any) => member.user_id && member.user_id !== ownerId
        );
    }

    public async transferOwnershipAndLeave() {
        if (
            this.saving
            || this.detail?.meeting?.my_role !== 'owner'
            || !this.successorId
        ) return;
        const successor = this.successorCandidates().find(
            (member: any) => member.user_id === this.successorId
        );
        if (!successor) {
            await this.service.modal.error(
                '모임장을 넘겨받을 멤버를 선택해주세요.'
            );
            return;
        }
        const confirmed = await this.service.modal.warning(
            `${successor.user_name}님에게 모임장을 넘기고 탈퇴합니다. 기존 활동 기록은 그대로 유지됩니다.`,
            '취소',
            '위임 후 탈퇴'
        );
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('transfer_and_leave', {
            id: this.detail.meeting.id,
            successor_id: this.successorId
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '모임장을 넘기지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        await this.finishMeetingExit(
            `${successor.user_name}님에게 모임장을 넘기고 탈퇴했습니다.`
        );
    }

    public async transferOwnership() {
        if (
            this.saving
            || this.detail?.meeting?.my_role !== 'owner'
            || !this.successorId
        ) return;
        const successor = this.successorCandidates().find(
            (member: any) => member.user_id === this.successorId
        );
        if (!successor) {
            await this.service.modal.error(
                '모임장을 넘겨받을 멤버를 선택해주세요.'
            );
            return;
        }
        const confirmed = await this.service.modal.warning(
            `${successor.user_name}님에게 모임장을 넘깁니다. 나는 일반 멤버로 계속 참여합니다.`,
            '취소',
            '모임장 위임'
        );
        if (!confirmed) return;

        const meeting = this.detail.meeting;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('transfer_ownership', {
            id: meeting.id,
            successor_id: this.successorId
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '모임장을 넘기지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        this.showSettingsModal = false;
        this.successorId = '';
        await this.load();
        await this.openMeeting(data, false);
        await this.service.modal.success(
            `${successor.user_name}님이 새 모임장이 되었습니다.`
        );
    }

    public async removeMember(member: any) {
        if (
            this.saving
            || this.detail?.meeting?.my_role !== 'owner'
            || !member?.user_id
            || member.role === 'owner'
        ) return;
        const confirmed = await this.service.modal.warning(
            `${member.user_name}님을 모임에서 내보냅니다. 기존 기록은 유지되고 참여 중인 모임 목록에서 제외됩니다.`,
            '취소',
            '멤버 내보내기'
        );
        if (!confirmed) return;

        const meeting = this.detail.meeting;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('remove_member', {
            id: meeting.id,
            member_id: member.user_id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '멤버를 내보내지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        await this.load();
        await this.openMeeting(meeting, false);
        this.detailTab = 'members';
        await this.service.modal.success(
            `${member.user_name}님을 모임에서 내보냈습니다.`
        );
        await this.service.render();
    }

    public openAddMember() {
        if (this.detail?.meeting?.my_role !== 'owner') return;
        this.addMemberData = this.emptyMember();
        this.showAddMemberModal = true;
        this.service.render();
    }

    public closeAddMember() {
        if (this.saving) return;
        this.showAddMemberModal = false;
        this.addMemberData = this.emptyMember();
        this.service.render();
    }

    public async addMember() {
        if (
            this.saving
            || this.detail?.meeting?.my_role !== 'owner'
        ) return;

        const username = (this.addMemberData.username || '')
            .trim()
            .toLowerCase();
        const name = (this.addMemberData.name || '').trim();
        if (!username || !name) {
            await this.service.modal.error(
                '추가할 사용자의 아이디와 이름을 모두 입력해주세요.'
            );
            return;
        }

        const meeting = this.detail.meeting;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_member', {
            id: meeting.id,
            username,
            name
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '멤버를 추가하지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        this.showAddMemberModal = false;
        this.addMemberData = this.emptyMember();
        await this.load();
        await this.openMeeting(meeting, false);
        this.detailTab = 'members';
        await this.service.modal.success(
            `${data.user_name || name}님을 새 멤버로 추가했습니다.`
        );
        await this.service.render();
    }

    public async deleteMeeting() {
        const meeting = this.detail?.meeting;
        if (
            this.saving
            || meeting?.my_role !== 'owner'
            || this.deleteConfirmation !== meeting.name
        ) return;
        const confirmed = await this.service.modal.warning(
            '모임의 일정, 투표, 멤버 정보가 모두 삭제되며 복구할 수 없습니다.',
            '취소',
            '모임 삭제'
        );
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_meeting', {
            id: meeting.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '모임을 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        await this.finishMeetingExit('모임을 삭제했습니다.');
    }

    public openSchedule(date: Date | null = null) {
        this.scheduleSource = null;
        this.editingScheduleId = '';
        this.scheduleRecurrenceOpen = true;
        this.scheduleReminderOpen = true;
        const schedule = this.emptySchedule();
        if (date && !isNaN(date.getTime())) {
            const defaultStart = new Date(schedule.schedule_at);
            const defaultEnd = new Date(schedule.schedule_end_at);
            const duration = defaultEnd.getTime() - defaultStart.getTime();
            const selectedStart = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                defaultStart.getHours(),
                defaultStart.getMinutes()
            );
            const selectedEnd = new Date(
                selectedStart.getTime() + duration
            );
            schedule.schedule_at = this.localDateTimeValue(selectedStart);
            schedule.schedule_end_at = this.localDateTimeValue(selectedEnd);
            schedule.all_day_start = this.dateKey(selectedStart);
            schedule.all_day_end = this.dateKey(selectedEnd);
            schedule.recurrence_weekdays = [
                this.mondayWeekday(selectedStart)
            ];
        }
        this.scheduleData = schedule;
        this.scheduleParticipantIds = this.defaultScheduleParticipantIds();
        this.placeAddressMessage = '';
        this.showScheduleModal = true;
        this.service.render();
    }

    public async openScheduleFromPlacePoll(option: any) {
        if (!this.isTopVotedPlaceOption(option)) return;
        this.editingScheduleId = '';
        this.scheduleRecurrenceOpen = true;
        this.scheduleReminderOpen = true;
        this.scheduleSource = {
            kind: 'place',
            poll_id: this.selectedPoll.id,
            poll_title: this.selectedPoll.title,
            option_id: option.id,
            option
        };
        this.scheduleData = {
            ...this.emptySchedule(),
            title: `${option.label} 일정`,
            place: option.label || '',
            place_address: option.address || '',
            place_link: option.link || ''
        };
        this.scheduleParticipantIds = this.defaultScheduleParticipantIds();
        this.placeAddressMessage = '';
        this.showPollModal = false;
        this.showScheduleModal = true;
        await this.service.render();
        if (!option.address && option.link) {
            await this.loadSchedulePlaceAddress();
        }
    }

    public openScheduleFromSchedulePoll(option: any) {
        if (!this.isTopVotedScheduleOption(option)) return;
        const start = this.scheduleInputValue(option.option_at);
        let end = this.scheduleInputValue(option.option_end_at);
        if (!end) {
            const startDate = new Date(
                String(option.option_at || '').replace(' ', 'T')
            );
            if (!isNaN(startDate.getTime())) {
                startDate.setHours(startDate.getHours() + 2);
                end = this.localDateTimeValue(startDate);
            }
        }
        if (!end) end = start;

        const memberIds = new Set(
            (this.detail?.members || []).map(
                (member: any) => member.user_id
            )
        );
        const voters = (option.voter_ids || []).filter(
            (userId: string) => memberIds.has(userId)
        );
        const title = `${this.selectedPoll.title} 확정 일정`.slice(0, 120);
        this.editingScheduleId = '';
        this.scheduleRecurrenceOpen = true;
        this.scheduleReminderOpen = true;
        this.scheduleSource = {
            kind: 'schedule',
            poll_id: this.selectedPoll.id,
            poll_title: this.selectedPoll.title,
            option_id: option.id,
            option
        };
        this.scheduleData = {
            ...this.emptySchedule(),
            title,
            schedule_at: start,
            schedule_end_at: end,
            all_day: !!option.all_day,
            all_day_start: this.valueDateKey(start),
            all_day_end: this.valueDateKey(end || start),
            description: this.selectedPoll.description || ''
        };
        const sourceDate = this.parseDisplayDate(start);
        if (sourceDate) {
            this.scheduleData.recurrence_weekdays = [
                this.mondayWeekday(sourceDate)
            ];
        }
        this.scheduleParticipantIds = voters.length > 0
            ? voters
            : this.defaultScheduleParticipantIds();
        this.placeAddressMessage = '';
        this.showPollModal = false;
        this.showScheduleModal = true;
        this.service.render();
    }

    public openScheduleEdit() {
        if (!this.canEditSchedule(this.selectedSchedule) || this.saving) return;
        const schedule = this.selectedSchedule;
        this.scheduleSource = null;
        this.editingScheduleId = schedule.id;
        this.scheduleRecurrenceOpen = true;
        this.scheduleReminderOpen = true;
        const rule = schedule.recurrence_rule || { frequency: 'none' };
        const reminders = Array.isArray(schedule.reminders)
            ? schedule.reminders : [];
        this.scheduleData = {
            title: schedule.title || '',
            schedule_at: this.scheduleInputValue(schedule.schedule_at),
            schedule_end_at: this.scheduleInputValue(
                schedule.schedule_end_at || schedule.schedule_at
            ),
            all_day: !!schedule.all_day,
            all_day_start: this.valueDateKey(schedule.schedule_at),
            all_day_end: this.valueDateKey(
                schedule.schedule_end_at || schedule.schedule_at
            ),
            place: schedule.place || '',
            place_address: schedule.place_address || '',
            place_link: schedule.place_link || '',
            description: schedule.description || '',
            recurrence_id: schedule.recurrence_id || '',
            recurrence_frequency: rule.frequency || 'none',
            recurrence_interval: Number(rule.interval || 1),
            recurrence_weekdays: [...(rule.weekdays || [])],
            recurrence_end_type: rule.end_type || 'count',
            recurrence_end_date: rule.end_date || '',
            recurrence_count: Number(rule.count || 10),
            edit_scope: 'this',
            reminder_enabled: reminders.length > 0,
            reminders: reminders.length
                ? reminders.map((item: any) => this.reminderDraft(item.minutes))
                : [this.reminderDraft(30)]
        };
        const currentMemberIds = new Set(
            (this.detail?.members || []).map(
                (member: any) => member.user_id
            )
        );
        this.scheduleParticipantIds = (schedule.participants || [])
            .map((participant: any) => participant.user_id)
            .filter(
                (userId: string) => !!userId && currentMemberIds.has(userId)
            );
        this.placeAddressMessage = '';
        this.showScheduleDetailModal = false;
        this.itineraryEditing = false;
        this.showScheduleModal = true;
        this.service.render();
    }

    public closeSchedule() {
        if (this.saving) return;
        const returnToScheduleDetail = (
            !!this.editingScheduleId
            && !!this.selectedSchedule
        );
        this.showScheduleModal = false;
        this.scheduleSource = null;
        this.editingScheduleId = '';
        this.scheduleParticipantIds = [];
        this.placeAddressMessage = '';
        if (returnToScheduleDetail) {
            this.itineraryEditing = false;
            this.itineraryDraft = this.copyStops(
                this.selectedSchedule.itinerary || []
            );
            this.showScheduleDetailModal = true;
        }
        this.service.render();
    }

    public async saveSchedule() {
        const scheduleData = this.schedulePayloadData();
        if (
            !scheduleData.title.trim()
            || !scheduleData.schedule_at
            || !scheduleData.schedule_end_at
        ) {
            await this.service.modal.error(
                this.scheduleData.all_day
                    ? '일정명과 시작·종료 날짜를 입력해주세요.'
                    : '일정명과 시작·종료 일시를 입력해주세요.'
            );
            return;
        }
        if (scheduleData.schedule_end_at < scheduleData.schedule_at) {
            await this.service.modal.error(
                this.scheduleData.all_day
                    ? '종료 날짜는 시작 날짜보다 빠를 수 없습니다.'
                    : '종료 일시는 시작 일시보다 빠를 수 없습니다.'
            );
            return;
        }
        if (
            this.isPlaceScheduleSource()
            && !this.scheduleData.place_address.trim()
        ) {
            await this.service.modal.error('정확한 주소를 입력해주세요.');
            return;
        }
        if (this.scheduleParticipantIds.length === 0) {
            await this.service.modal.error('참여 인원을 한 명 이상 선택해주세요.');
            return;
        }
        if (this.scheduleData.recurrence_frequency === 'custom'
            && !(this.scheduleData.recurrence_weekdays || []).length) {
            await this.service.modal.error('반복할 요일을 하나 이상 선택해주세요.');
            return;
        }

        this.saving = true;
        await this.service.render();
        const meeting = this.detail.meeting;
        const editingScheduleId = this.editingScheduleId;
        const action = editingScheduleId ? 'update_schedule' : 'create_schedule';
        const participant_ids = JSON.stringify(this.scheduleParticipantIds);
        const payload = editingScheduleId
            ? {
                id: meeting.id,
                schedule_id: editingScheduleId,
                participant_ids,
                ...scheduleData
            }
            : this.scheduleSource
            ? {
                id: meeting.id,
                poll_id: this.scheduleSource.poll_id,
                option_id: this.scheduleSource.option_id,
                participant_ids,
                ...scheduleData
            }
            : {
                id: meeting.id,
                participant_ids,
                ...scheduleData
            };
        let response = await wiz.call(action, payload);
        if (response.code === 409) {
            this.saving = false;
            await this.service.render();
            const confirmed = await this.service.modal.error(
                this.scheduleConflictMessage(response.data),
                true,
                '그래도 저장'
            );
            if (!confirmed) return;
            this.saving = true;
            await this.service.render();
            response = await wiz.call(action, { ...payload, force_save: true });
        }
        const { code, data } = response;
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(
                data,
                editingScheduleId
                    ? '일정을 수정하지 못했습니다.'
                    : '일정을 추가하지 못했습니다.'
            ));
            await this.service.render();
            return;
        }

        this.showScheduleModal = false;
        this.scheduleSource = null;
        this.editingScheduleId = '';
        this.scheduleParticipantIds = [];
        this.selectedPoll = null;
        await this.openMeeting(meeting, false);
        if (editingScheduleId) {
            const refreshedSchedule = (this.detail?.schedules || []).find(
                (schedule: any) => schedule.id === data.id
            ) || data;
            this.openScheduleDetail(refreshedSchedule);
        } else {
            this.detailTab = 'schedule';
            this.scheduleView = 'calendar';
            this.schedulePage = 1;
            await this.service.render();
        }
        await this.service.modal.success(
            editingScheduleId
                ? '모임 일정이 수정되었습니다.'
                : '모임 일정이 추가되었습니다.'
        );
    }

    public async toggleScheduleRecurrenceWeekday(value: number) {
        const weekdays = [...(this.scheduleData.recurrence_weekdays || [])];
        const index = weekdays.indexOf(value);
        if (index >= 0) weekdays.splice(index, 1);
        else weekdays.push(value);
        this.scheduleData.recurrence_weekdays = weekdays.sort();
        await this.service.render();
    }

    public async toggleScheduleRecurrenceSection() {
        this.scheduleRecurrenceOpen = !this.scheduleRecurrenceOpen;
        await this.service.render();
    }

    public async toggleScheduleReminderSection() {
        this.scheduleReminderOpen = !this.scheduleReminderOpen;
        await this.service.render();
    }

    public async setScheduleRecurrenceFrequency(value: string) {
        this.scheduleData.recurrence_frequency = value;
        await this.service.render();
    }

    public async setScheduleReminderPreset(index: number, value: string) {
        const reminder = (this.scheduleData.reminders || [])[index];
        if (!reminder) return;
        this.scheduleData.reminder_enabled = true;
        reminder.preset = value;
        if (value !== 'custom') reminder.custom_minutes = Number(value);
        await this.service.render();
    }

    public async disableScheduleReminder() {
        this.scheduleData.reminder_enabled = false;
        this.scheduleData.reminders = [this.reminderDraft(30)];
        await this.service.render();
    }

    public scheduleRecurrenceWeekdaySelected(value: number) {
        return (this.scheduleData.recurrence_weekdays || []).includes(value);
    }

    public async addScheduleReminder() {
        if (!this.scheduleData.reminder_enabled
            || (this.scheduleData.reminders || []).length >= 5) return;
        const used = new Set(
            (this.scheduleData.reminders || []).map(
                (item: any) => item.preset === 'custom'
                    ? Number(item.custom_minutes) : Number(item.preset)
            )
        );
        const nextMinutes = [10, 30, 60, 1440, 120].find(
            (minutes: number) => !used.has(minutes)
        ) || 120;
        this.scheduleData.reminders.push(this.reminderDraft(nextMinutes));
        await this.service.render();
    }

    public async removeScheduleReminder(index: number) {
        if (index <= 0) return;
        this.scheduleData.reminders.splice(index, 1);
        await this.service.render();
    }

    public openCreatePoll() {
        this.pollData = this.emptyPoll();
        this.pollOptionDraft = this.emptyPollOptionDraft();
        this.pollFormError = '';
        this.showCreatePollModal = true;
        this.service.render();
    }

    public closeCreatePoll() {
        if (this.saving) return;
        this.showCreatePollModal = false;
        this.service.render();
    }

    public setPollKind(kind: string) {
        if (this.pollData.kind === kind) return;
        this.pollData.kind = kind;
        this.pollData.multiple_choice = true;
        this.pollData.options = [];
        this.pollOptionDraft = this.emptyPollOptionDraft();
        this.pollFormError = '';
        this.service.render();
    }

    public setPollScheduleMode(mode: string) {
        if (!['options', 'calendar'].includes(mode)) return;
        this.pollData.selection_mode = mode;
        this.pollData.allow_option_additions = mode === 'calendar';
        if (mode === 'calendar') this.pollData.options = [];
        this.pollFormError = '';
        this.service.render();
    }

    public setPlaceMultipleChoice(multiple: boolean) {
        this.pollData.multiple_choice = multiple;
        this.pollFormError = '';
        this.service.render();
    }

    public async choosePollOptionImage() {
        const image = await this.service.file.read({
            type: 'image',
            accept: 'image/*',
            width: 720,
            quality: 0.78
        });
        if (!image) return;
        if (image.length > 2 * 1024 * 1024) {
            this.showPollFormError('사진 용량이 너무 큽니다. 다른 사진을 선택해주세요.');
            return;
        }
        this.pollOptionDraft.image = image;
        await this.service.render();
    }

    public async addPollOption() {
        this.pollFormError = '';
        if (this.pollData.kind === 'schedule') {
            const date = this.pollOptionDraft.date;
            const time = this.pollOptionDraft.time;
            if (!this.pollData.range_start || !this.pollData.range_end) {
                this.showPollFormError('먼저 투표 기간을 선택해주세요.');
                return;
            }
            if (!date || !time) {
                this.showPollFormError('가능한 날짜와 시간을 선택해주세요.');
                return;
            }
            if (date < this.pollData.range_start || date > this.pollData.range_end) {
                this.showPollFormError('설정한 투표 기간 안의 날짜를 선택해주세요.');
                return;
            }
            const value = `${date}T${time}`;
            if (this.pollData.options.some((option: any) => option.value === value)) {
                this.showPollFormError('이미 추가한 날짜와 시간입니다.');
                return;
            }
            this.pollData.options.push({ value });
            this.pollOptionDraft.date = '';
        } else {
            const label = this.pollOptionDraft.label.trim();
            const address = this.pollOptionDraft.address.trim();
            const link = this.normalizePlaceLink(this.pollOptionDraft.link);
            if (!label) {
                this.showPollFormError('후보 장소를 입력해주세요.');
                return;
            }
            if (!address) {
                this.showPollFormError('정확한 주소를 입력해주세요.');
                return;
            }
            if (this.pollOptionDraft.link.trim() && !link) {
                this.showPollFormError('장소 링크 주소를 다시 확인해주세요.');
                return;
            }
            if (this.pollData.options.some((option: any) => option.label.toLowerCase() === label.toLowerCase())) {
                this.showPollFormError('이미 추가한 장소입니다.');
                return;
            }
            this.pollData.options.push({
                label,
                address,
                link,
                image: this.pollOptionDraft.image || ''
            });
            this.pollOptionDraft = this.emptyPollOptionDraft();
        }
        await this.service.render();
    }

    public removePollOption(index: number) {
        this.pollData.options.splice(index, 1);
        this.service.render();
    }

    public onPollRangeChange() {
        if (!this.pollData.range_start || !this.pollData.range_end) return;
        if (this.pollData.range_end < this.pollData.range_start) {
            this.pollData.range_end = this.pollData.range_start;
        }
        this.pollData.options = this.pollData.options.filter((option: any) => {
            const date = String(option.value || '').slice(0, 10);
            return date >= this.pollData.range_start && date <= this.pollData.range_end;
        });
        this.pollFormError = '';
        this.service.render();
    }

    public async createPoll() {
        this.pollFormError = '';
        if (!this.pollData.title.trim()) {
            this.showPollFormError('투표 제목을 입력해주세요.');
            return;
        }
        if (!this.pollData.closes_at) {
            this.showPollFormError('투표 마감 일시를 선택해주세요.');
            return;
        }
        if (this.pollData.closes_at <= this.minimumPollCloseAt()) {
            this.showPollFormError('투표 마감은 현재 시각 이후로 선택해주세요.');
            return;
        }
        if (this.pollData.kind === 'schedule' && (!this.pollData.range_start || !this.pollData.range_end)) {
            this.showPollFormError('투표 기간을 선택해주세요.');
            return;
        }
        const needsOptions = this.pollData.kind === 'place'
            || this.pollData.selection_mode === 'options';
        if (needsOptions && this.pollData.options.length < 2) {
            this.showPollFormError(
                this.pollData.kind === 'schedule'
                    ? '일정 후보를 2개 이상 추가해주세요.'
                    : '장소 후보를 2개 이상 추가해주세요.'
            );
            return;
        }

        this.saving = true;
        await this.service.render();
        const meeting = this.detail.meeting;
        let response: any = null;
        try {
            response = await wiz.call('create_poll', {
                id: meeting.id,
                kind: this.pollData.kind,
                selection_mode: this.pollData.selection_mode,
                allow_option_additions: this.pollData.allow_option_additions,
                multiple_choice: this.pollData.multiple_choice,
                title: this.pollData.title,
                description: this.pollData.description,
                range_start: this.pollData.range_start,
                range_end: this.pollData.range_end,
                closes_at: this.pollCloseIsoValue(),
                options: JSON.stringify(this.pollData.options)
            });
        } catch (error) {
            this.showPollFormError('투표 생성 요청에 실패했습니다. 잠시 후 다시 시도해주세요.');
        }
        this.saving = false;

        if (!response || response.code !== 200) {
            if (response) {
                this.showPollFormError(this.errorMessage(response.data, '투표를 만들지 못했습니다.'));
            }
            await this.service.render();
            return;
        }

        this.showCreatePollModal = false;
        await this.openMeeting(meeting, false);
        await this.service.modal.success('새 투표가 등록되었습니다.');
        this.openPoll(response.data);
    }

    public openPoll(poll: any) {
        this.detailTab = 'poll';
        this.selectedPoll = poll;
        this.selectedPollOptions = (poll.options || [])
            .filter((option: any) => option.my_selected)
            .map((option: any) => option.id);
        const firstDate = String(poll.range_start || '').slice(0, 10);
        const firstCalendarDate = this.parseDateKey(firstDate) || new Date();
        this.pollCalendarDate = new Date(
            firstCalendarDate.getFullYear(),
            firstCalendarDate.getMonth(),
            1
        );
        this.pollOptionAddDraft = {
            ...this.emptyPollOptionAddDraft(),
            date: firstDate
        };
        this.pollVoteError = '';
        this.pollVoteNotice = '';
        this.showPollModal = true;
        this.service.render();
    }

    public closePoll() {
        if (this.saving) return;
        this.showPollModal = false;
        this.selectedPoll = null;
        this.pollVoteError = '';
        this.pollVoteNotice = '';
        this.service.render();
    }

    public canAddSchedulePollOption() {
        return this.selectedPoll?.kind === 'schedule'
            && !!this.selectedPoll?.can_add_options;
    }

    public canCreateScheduleFromPlacePoll() {
        return this.canInspectPlacePollResults()
            && !this.pollHasFinalizedSchedule()
            && this.topPlaceVoteCount() > 0;
    }

    public canInspectPlacePollResults() {
        return this.selectedPoll?.kind === 'place'
            && this.selectedPoll?.effective_status === 'ended'
            && !this.selectedPoll?.is_open;
    }

    public topPlaceVoteCount() {
        if (!this.canInspectPlacePollResults()) return 0;
        return Math.max(
            0,
            ...(this.selectedPoll?.options || []).map(
                (option: any) => Number(option.vote_count || 0)
            )
        );
    }

    public topPlaceOptionCount() {
        const topVoteCount = this.topPlaceVoteCount();
        if (topVoteCount <= 0) return 0;
        return (this.selectedPoll?.options || []).filter(
            (option: any) => Number(option.vote_count || 0) === topVoteCount
        ).length;
    }

    public isTopVotedPlaceOption(option: any) {
        const topVoteCount = this.topPlaceVoteCount();
        return this.canCreateScheduleFromPlacePoll()
            && topVoteCount > 0
            && Number(option?.vote_count || 0) === topVoteCount;
    }

    public canInspectSchedulePollResults() {
        return this.selectedPoll?.kind === 'schedule'
            && this.selectedPoll?.effective_status === 'ended'
            && !this.selectedPoll?.is_open;
    }

    public topScheduleVoteCount() {
        if (!this.canInspectSchedulePollResults()) return 0;
        return Math.max(
            0,
            ...(this.selectedPoll?.options || []).map(
                (option: any) => Number(option.vote_count || 0)
            )
        );
    }

    public topScheduleOptionCount() {
        const topVoteCount = this.topScheduleVoteCount();
        if (topVoteCount <= 0) return 0;
        return (this.selectedPoll?.options || []).filter(
            (option: any) => Number(option.vote_count || 0) === topVoteCount
        ).length;
    }

    public isTopVotedScheduleOption(option: any) {
        const topVoteCount = this.topScheduleVoteCount();
        return this.canInspectSchedulePollResults()
            && !this.pollHasFinalizedSchedule()
            && topVoteCount > 0
            && Number(option?.vote_count || 0) === topVoteCount;
    }

    public pollHasFinalizedSchedule() {
        return !!this.selectedPoll?.finalized_schedule_id;
    }

    public openFinalizedPollSchedule() {
        const scheduleId = this.selectedPoll?.finalized_schedule_id || '';
        const schedule = (this.detail?.schedules || []).find(
            (item: any) => item.id === scheduleId
        );
        if (!schedule) return;
        this.showPollModal = false;
        this.selectedPoll = null;
        this.openScheduleDetail(schedule);
    }

    public isPlaceScheduleSource() {
        return this.scheduleSource?.kind === 'place';
    }

    public isSchedulePollSource() {
        return this.scheduleSource?.kind === 'schedule';
    }

    public onScheduleAllDayChange() {
        if (this.scheduleData.all_day) {
            this.scheduleData.all_day_start = this.valueDateKey(
                this.scheduleData.schedule_at
            ) || this.dateKey(new Date());
            this.scheduleData.all_day_end = this.valueDateKey(
                this.scheduleData.schedule_end_at
            ) || this.scheduleData.all_day_start;
        } else {
            const startTime = this.formatTime(
                this.scheduleData.schedule_at
            ) || '09:00';
            const endTime = this.formatTime(
                this.scheduleData.schedule_end_at
            ) || '11:00';
            this.scheduleData.schedule_at = (
                `${this.scheduleData.all_day_start}T${startTime}`
            );
            this.scheduleData.schedule_end_at = (
                `${this.scheduleData.all_day_end}T${endTime}`
            );
        }
        this.service.render();
    }

    public scheduleParticipantSelected(userId: string) {
        return this.scheduleParticipantIds.includes(userId);
    }

    public toggleScheduleParticipant(userId: string) {
        const index = this.scheduleParticipantIds.indexOf(userId);
        if (index >= 0) {
            this.scheduleParticipantIds.splice(index, 1);
        } else {
            this.scheduleParticipantIds.push(userId);
        }
        this.service.render();
    }

    public allScheduleParticipantsSelected() {
        const memberIds = this.defaultScheduleParticipantIds();
        return memberIds.length > 0
            && memberIds.every((userId: string) =>
                this.scheduleParticipantIds.includes(userId)
            );
    }

    public toggleAllScheduleParticipants() {
        this.scheduleParticipantIds = this.allScheduleParticipantsSelected()
            ? []
            : this.defaultScheduleParticipantIds();
        this.service.render();
    }

    public async loadPollOptionAddress() {
        const link = this.normalizePlaceLink(this.pollOptionDraft.link);
        if (!link) {
            this.showPollFormError('주소를 불러올 장소 링크를 먼저 입력해주세요.');
            return;
        }
        this.placeAddressLoading = true;
        this.pollFormError = '';
        await this.service.render();
        let response: any = null;
        try {
            response = await wiz.call('extract_place_address', { link });
        } catch (error) {
            response = null;
        }
        this.placeAddressLoading = false;
        if (!response || response.code !== 200 || !response.data?.address) {
            this.showPollFormError(
                response
                    ? this.errorMessage(response.data, '링크에서 주소를 불러오지 못했습니다.')
                    : '링크에서 주소를 불러오지 못했습니다.'
            );
            return;
        }
        this.pollOptionDraft.address = response.data.address;
        this.pollOptionDraft.link = link;
        await this.service.render();
    }

    public async loadSchedulePlaceAddress() {
        const option = this.scheduleSource?.option;
        const link = this.normalizePlaceLink(
            this.scheduleData.place_link || option?.link || ''
        );
        if (!link || this.placeAddressLoading) {
            this.placeAddressMessage = '올바른 장소 링크를 먼저 입력해주세요.';
            await this.service.render();
            return;
        }
        this.scheduleData.place_link = link;
        this.placeAddressLoading = true;
        this.placeAddressMessage = '장소 링크에서 정확한 주소를 불러오는 중입니다.';
        await this.service.render();
        let response: any = null;
        try {
            response = await wiz.call('extract_place_address', {
                link
            });
        } catch (error) {
            response = null;
        }
        this.placeAddressLoading = false;
        if (response?.code === 200 && response.data?.address) {
            this.scheduleData.place_address = response.data.address;
            this.placeAddressMessage = '장소 링크에서 정확한 주소를 불러왔습니다.';
        } else {
            this.placeAddressMessage = response
                ? this.errorMessage(
                    response.data,
                    '주소를 불러오지 못했습니다. 직접 입력해주세요.'
                )
                : '주소를 불러오지 못했습니다. 직접 입력해주세요.';
        }
        await this.service.render();
    }

    public visiblePollOptions() {
        const options = this.selectedPoll?.options || [];
        if (this.selectedPoll?.selection_mode !== 'calendar') return options;
        const date = this.pollOptionAddDraft.date;
        return options.filter((option: any) => this.valueDateKey(option.option_at) === date);
    }

    public calendarResultOptions() {
        return this.visiblePollOptions().filter(
            (option: any) => Number(option.vote_count || 0) > 0
        );
    }

    public pollCalendarTitle() {
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: 'long'
        }).format(this.pollCalendarDate);
    }

    public pollCalendarDays() {
        if (!this.selectedPoll) return [];
        const year = this.pollCalendarDate.getFullYear();
        const month = this.pollCalendarDate.getMonth();
        const first = new Date(year, month, 1);
        const gridStart = new Date(year, month, 1 - first.getDay());
        const start = String(this.selectedPoll.range_start || '').slice(0, 10);
        const end = String(this.selectedPoll.range_end || '').slice(0, 10);
        const options = this.selectedPoll.options || [];
        const days: any[] = [];

        for (let index = 0; index < 42; index++) {
            const date = new Date(
                gridStart.getFullYear(),
                gridStart.getMonth(),
                gridStart.getDate() + index
            );
            const key = this.dateKey(date);
            const dayOptions = options.filter(
                (option: any) => this.valueDateKey(option.option_at) === key
            );
            const resultOptions = dayOptions.filter(
                (option: any) => Number(option.vote_count || 0) > 0
            );
            const dayVoters = new Set<string>();
            const voterMap = new Map<string, any>();
            resultOptions.forEach((option: any) => {
                const voters = option.voter_ids || option.voters || [];
                voters.forEach((voter: string) => dayVoters.add(voter));
                (option.voter_details || []).forEach((voter: any) => {
                    if (voter.id && !voterMap.has(voter.id)) voterMap.set(voter.id, voter);
                });
            });
            const myOptions = dayOptions.filter(
                (option: any) => this.pollOptionSelected(option.id)
            );
            const dayVoterDetails = Array.from(voterMap.values());
            days.push({
                key,
                day: date.getDate(),
                inMonth: date.getMonth() === month,
                inRange: key >= start && key <= end,
                selected: key === this.pollOptionAddDraft.date,
                optionCount: resultOptions.length,
                selectedCount: myOptions.length,
                myTimeSummary: myOptions.map(
                    (option: any) => this.pollOptionShortTime(option)
                ).join(' · '),
                voters: dayVoterDetails,
                hasDepartedVoters: dayVoterDetails.some(
                    (voter: any) => voter.is_current_member === false
                ),
                voterSummary: dayVoterDetails.length > 1
                    ? `${dayVoterDetails[0].name} 외 ${dayVoterDetails.length - 1}명`
                    : (dayVoterDetails[0]?.name || ''),
                voterCount: dayVoters.size,
                voteCount: resultOptions.reduce(
                    (sum: number, option: any) => sum + Number(option.vote_count || 0), 0
                ),
                topVoteCount: resultOptions.reduce(
                    (top: number, option: any) => Math.max(top, Number(option.vote_count || 0)), 0
                )
            });
        }
        return days;
    }

    public pollSelectedDateStats() {
        const options = this.calendarResultOptions();
        const voters = new Set<string>();
        const voterMap = new Map<string, any>();
        options.forEach((option: any) => {
            const optionVoters = option.voter_ids || option.voters || [];
            optionVoters.forEach((voter: string) => voters.add(voter));
            (option.voter_details || []).forEach((voter: any) => {
                if (voter.id && !voterMap.has(voter.id)) voterMap.set(voter.id, voter);
            });
        });
        return {
            optionCount: options.length,
            voterCount: voters.size,
            voterDetails: Array.from(voterMap.values()),
            voterNames: Array.from(voterMap.values()).map((voter: any) => voter.name),
            voteCount: options.reduce(
                (sum: number, option: any) => sum + Number(option.vote_count || 0), 0
            ),
            topVoteCount: options.reduce(
                (top: number, option: any) => Math.max(top, Number(option.vote_count || 0)), 0
            )
        };
    }

    public changePollCalendarMonth(offset: number) {
        if (!this.canChangePollCalendarMonth(offset)) return;
        this.pollCalendarDate = new Date(
            this.pollCalendarDate.getFullYear(),
            this.pollCalendarDate.getMonth() + offset,
            1
        );
        this.service.render();
    }

    public canChangePollCalendarMonth(offset: number) {
        if (!this.selectedPoll) return false;
        const candidate = new Date(
            this.pollCalendarDate.getFullYear(),
            this.pollCalendarDate.getMonth() + offset,
            1
        );
        const start = this.parseDateKey(String(this.selectedPoll.range_start || '').slice(0, 10));
        const end = this.parseDateKey(String(this.selectedPoll.range_end || '').slice(0, 10));
        if (!start || !end) return false;
        const startMonth = new Date(start.getFullYear(), start.getMonth(), 1);
        const endMonth = new Date(end.getFullYear(), end.getMonth(), 1);
        return candidate >= startMonth && candidate <= endMonth;
    }

    public selectPollCalendarDay(day: any) {
        if (!day.inRange) return;
        this.pollOptionAddDraft.date = day.key;
        this.pollVoteError = '';
        this.pollVoteNotice = '';
        this.service.render();
    }

    public onPollAllDayChange() {
        if (!this.pollOptionAddDraft.all_day) {
            if (!this.pollOptionAddDraft.start_time) this.pollOptionAddDraft.start_time = '19:00';
            if (!this.pollOptionAddDraft.end_time) this.pollOptionAddDraft.end_time = '21:00';
        }
        this.pollVoteError = '';
        this.service.render();
    }

    public async addVoteScheduleOption() {
        this.pollVoteError = '';
        this.pollVoteNotice = '';
        const date = this.pollOptionAddDraft.date;
        const calendarMode = this.selectedPoll.selection_mode === 'calendar';
        const allDay = calendarMode && !!this.pollOptionAddDraft.all_day;
        const startTime = allDay ? '00:00' : this.pollOptionAddDraft.start_time;
        const endTime = allDay ? '23:59' : (calendarMode ? this.pollOptionAddDraft.end_time : '');
        if (!date || !startTime) {
            this.pollVoteError = '추가할 날짜와 시작 시간을 선택해주세요.';
            await this.service.render();
            return;
        }
        if (calendarMode && !allDay && !endTime) {
            this.pollVoteError = '가능한 종료 시간을 선택해주세요.';
            await this.service.render();
            return;
        }
        if (endTime && endTime <= startTime) {
            this.pollVoteError = '종료 시간은 시작 시간보다 늦어야 합니다.';
            await this.service.render();
            return;
        }
        const optionKey = `${date}|${startTime}|${endTime}|${allDay ? '1' : '0'}`;
        const existing = (this.selectedPoll.options || []).find(
            (option: any) => this.optionIdentityKey(option) === optionKey
        );
        if (existing) {
            if (!this.pollOptionSelected(existing.id)) this.selectedPollOptions.push(existing.id);
            this.pollVoteNotice = '이미 등록된 시간이라 내 가능 시간에 선택했습니다. 아래 투표 완료를 눌러 저장해주세요.';
            await this.service.render();
            return;
        }

        this.saving = true;
        await this.service.render();
        let response: any = null;
        try {
            response = await wiz.call('add_poll_option', {
                id: this.detail.meeting.id,
                poll_id: this.selectedPoll.id,
                date,
                start_time: startTime,
                end_time: endTime,
                all_day: allDay
            });
        } catch (error) {
            this.pollVoteError = '일정 후보를 추가하지 못했습니다. 잠시 후 다시 시도해주세요.';
        }
        this.saving = false;

        if (!response || response.code !== 200) {
            if (response) {
                this.pollVoteError = this.errorMessage(response.data, '일정 후보를 추가하지 못했습니다.');
            }
            await this.service.render();
            return;
        }

        this.selectedPoll = response.data;
        const added = (response.data.options || []).find(
            (option: any) => this.optionIdentityKey(option) === optionKey
        );
        if (added && !this.pollOptionSelected(added.id)) this.selectedPollOptions.push(added.id);
        const index = this.detail.polls.findIndex((poll: any) => poll.id === response.data.id);
        if (index >= 0) this.detail.polls[index] = response.data;
        this.pollVoteNotice = '가능 시간을 추가했습니다. 아래 투표 완료를 눌러 저장해주세요.';
        await this.service.render();
    }

    public selectedPollOptionRows() {
        const selected = new Set(this.selectedPollOptions);
        return (this.selectedPoll?.options || [])
            .filter((option: any) => selected.has(option.id))
            .sort((left: any, right: any) => String(left.option_at || '').localeCompare(String(right.option_at || '')));
    }

    public selectedPollOptionGroups() {
        const groups = new Map<string, any>();
        this.selectedPollOptionRows().forEach((option: any) => {
            const dateKey = this.valueDateKey(option.option_at);
            if (!groups.has(dateKey)) {
                const [year, month, day] = dateKey.split('-').map(Number);
                const date = new Date(year, month - 1, day);
                groups.set(dateKey, {
                    id: dateKey,
                    dateKey,
                    dateLabel: `${year}년 ${month}월 ${day}일`,
                    weekdayLabel: `${this.weekdayHeaders[date.getDay()]}요일`,
                    options: []
                });
            }
            groups.get(dateKey).options.push(option);
        });
        return Array.from(groups.values());
    }

    public pollOptionTimeRange(option: any) {
        if (option?.all_day) return '종일';
        const start = this.formatTime(option?.option_at);
        const end = this.formatTime(option?.option_end_at);
        if (!start) return '시간 미정';
        return end && end !== start ? `${start} – ${end}` : start;
    }

    public async removeSelectedAvailability(option: any) {
        if (!this.selectedPoll?.is_open || this.saving) return;
        if (!option.can_delete) {
            this.selectedPollOptions = this.selectedPollOptions.filter(
                (optionId: string) => optionId !== option.id
            );
            this.pollVoteNotice = '내 가능 시간에서 제외했습니다. 투표 완료를 눌러 반영해주세요.';
            this.pollVoteError = '';
            await this.service.render();
            return;
        }

        this.saving = true;
        await this.service.render();
        let response: any = null;
        try {
            response = await wiz.call('delete_poll_option', {
                id: this.detail.meeting.id,
                poll_id: this.selectedPoll.id,
                option_id: option.id
            });
        } catch (error) {
            this.pollVoteError = '가능 시간을 삭제하지 못했습니다. 잠시 후 다시 시도해주세요.';
        }
        this.saving = false;
        if (!response || response.code !== 200) {
            if (response) {
                this.pollVoteError = this.errorMessage(response.data, '가능 시간을 삭제하지 못했습니다.');
            }
            await this.service.render();
            return;
        }
        this.selectedPollOptions = this.selectedPollOptions.filter(
            (optionId: string) => optionId !== option.id
        );
        this.selectedPoll = response.data;
        const index = this.detail.polls.findIndex((poll: any) => poll.id === response.data.id);
        if (index >= 0) this.detail.polls[index] = response.data;
        this.pollVoteNotice = '추가한 가능 시간을 삭제했습니다.';
        this.pollVoteError = '';
        await this.service.render();
    }

    public togglePollOption(optionId: string) {
        if (!this.selectedPoll?.is_open) return;
        const index = this.selectedPollOptions.indexOf(optionId);
        if (this.selectedPoll.kind === 'place' && !this.selectedPoll.multiple_choice) {
            this.selectedPollOptions = index >= 0 ? [] : [optionId];
        } else if (index >= 0) {
            this.selectedPollOptions.splice(index, 1);
        } else {
            this.selectedPollOptions.push(optionId);
        }
        this.pollVoteError = '';
        this.service.render();
    }

    public pollOptionSelected(optionId: string) {
        return this.selectedPollOptions.includes(optionId);
    }

    public pollSubmitLabel(poll: any) {
        if (this.hasParticipatedInPoll(poll)) return '투표 수정';
        return poll?.selection_mode === 'calendar' ? '투표 완료' : '선택 완료';
    }

    public async saveVote() {
        if (!this.selectedPoll?.is_open) {
            this.pollVoteError = '이미 종료된 투표입니다.';
            await this.service.render();
            return;
        }
        const hadSavedResponse = (this.selectedPoll.options || []).some(
            (option: any) => option.my_selected
        );
        if (this.selectedPollOptions.length === 0 && !hadSavedResponse) {
            this.pollVoteError = '가능한 항목을 하나 이상 선택해주세요.';
            await this.service.render();
            return;
        }
        this.saving = true;
        await this.service.render();
        const meeting = this.detail.meeting;
        const pollId = this.selectedPoll.id;
        const { code, data } = await wiz.call('vote_poll', {
            id: meeting.id,
            poll_id: pollId,
            option_ids: JSON.stringify(this.selectedPollOptions)
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(data, '투표를 저장하지 못했습니다.'));
            await this.service.render();
            return;
        }

        this.selectedPoll = data;
        const index = this.detail.polls.findIndex((poll: any) => poll.id === pollId);
        if (index >= 0) this.detail.polls[index] = data;
        await this.service.modal.success(
            this.selectedPollOptions.length > 0
                ? (
                    hadSavedResponse
                        ? '내 투표를 수정했습니다.'
                        : '선택한 항목에 투표했습니다.'
                )
                : '내 투표 응답을 취소했습니다.'
        );
        await this.service.render();
    }

    public async cancelVote() {
        if (
            !this.selectedPoll?.is_open
            || !this.hasParticipatedInPoll(this.selectedPoll)
            || this.saving
        ) return;
        const confirmed = await this.service.modal.warning(
            '현재 선택한 모든 항목에서 내 응답이 제거됩니다. 마감 전에는 다시 투표할 수 있습니다.',
            '유지하기',
            '투표 취소'
        );
        if (!confirmed) return;

        this.saving = true;
        this.pollVoteError = '';
        await this.service.render();
        const meeting = this.detail.meeting;
        const pollId = this.selectedPoll.id;
        const { code, data } = await wiz.call('vote_poll', {
            id: meeting.id,
            poll_id: pollId,
            option_ids: JSON.stringify([])
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '투표를 취소하지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        this.selectedPollOptions = [];
        this.selectedPoll = data;
        const index = this.detail.polls.findIndex((poll: any) => poll.id === pollId);
        if (index >= 0) this.detail.polls[index] = data;
        await this.service.modal.success(
            '내 투표를 취소했습니다. 마감 전에는 다시 투표할 수 있습니다.'
        );
        await this.service.render();
    }

    public async deleteSelectedPoll() {
        if (!this.selectedPoll?.can_delete || this.saving) return;
        const confirmed = await this.service.modal.warning(
            '아직 참여자가 없는 투표입니다. 삭제하면 복구할 수 없습니다.',
            '취소',
            '투표 삭제'
        );
        if (!confirmed) return;
        const meeting = this.detail.meeting;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_poll', {
            id: meeting.id,
            poll_id: this.selectedPoll.id
        });
        this.saving = false;
        if (code !== 200) {
            this.pollVoteError = this.errorMessage(data, '투표를 삭제하지 못했습니다.');
            await this.service.render();
            return;
        }
        this.showPollModal = false;
        this.selectedPoll = null;
        await this.openMeeting(meeting, false);
        await this.service.modal.success('투표를 삭제했습니다.');
    }

    public async stopSelectedPoll() {
        if (!this.selectedPoll?.can_stop || this.saving) return;
        const confirmed = await this.service.modal.warning(
            '현재 결과를 유지한 채 투표를 중단합니다. 다시 시작할 수 없습니다.',
            '취소',
            '투표 중단'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('stop_poll', {
            id: this.detail.meeting.id,
            poll_id: this.selectedPoll.id
        });
        this.saving = false;
        if (code !== 200) {
            this.pollVoteError = this.errorMessage(data, '투표를 중단하지 못했습니다.');
            await this.service.render();
            return;
        }
        this.selectedPoll = data;
        const index = this.detail.polls.findIndex((poll: any) => poll.id === data.id);
        if (index >= 0) this.detail.polls[index] = data;
        await this.service.modal.success('투표를 중단했습니다.');
        await this.service.render();
    }

    public async closeSelectedPoll() {
        if (!this.selectedPoll?.can_force_close || this.saving) return;
        const noDeadline = this.selectedPoll.force_close_reason === 'no_deadline';
        const confirmed = await this.service.modal.warning(
            noDeadline
                ? '마감 일시가 없는 투표를 현재 결과로 종료합니다. 종료 후에는 다시 시작할 수 없습니다.'
                : '모든 멤버가 투표를 완료했습니다. 현재 결과로 종료하며, 종료 후에는 다시 시작할 수 없습니다.',
            '취소',
            '투표 종료'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('close_poll', {
            id: this.detail.meeting.id,
            poll_id: this.selectedPoll.id
        });
        this.saving = false;
        if (code !== 200) {
            this.pollVoteError = this.errorMessage(data, '투표를 종료하지 못했습니다.');
            await this.service.render();
            return;
        }
        this.selectedPoll = data;
        const index = this.detail.polls.findIndex((poll: any) => poll.id === data.id);
        if (index >= 0) this.detail.polls[index] = data;
        await this.service.modal.success('투표를 종료했습니다.');
        await this.service.render();
    }

    public openScheduleDetail(schedule: any) {
        this.detailTab = 'schedule';
        this.scheduleDetailTab = 'schedule';
        this.expenseDetailTab = 'expenses';
        this.selectedSchedule = schedule;
        this.itineraryEditing = false;
        this.itineraryDraft = this.copyStops(schedule.itinerary || []);
        this.scheduleAftercare = null;
        this.memoryDraft = this.emptyMemory();
        this.expenseDraft = this.emptyExpense();
        this.paymentInfoDraft = this.emptyPaymentInfo();
        this.paymentInfoEditing = false;
        this.paymentInfoEditingId = '';
        this.paymentInfoEditingEntryId = '';
        this.paymentBankSearch = '';
        this.paymentBankDropdownOpen = false;
        this.showScheduleDetailModal = true;
        this.service.render();
        if (schedule?.is_past) void this.loadScheduleAftercare();
    }

    public async loadScheduleAftercare() {
        if (
            !this.selectedSchedule?.id
            || !this.detail?.meeting?.id
            || !this.selectedSchedule?.is_past
        ) return;
        const scheduleId = this.selectedSchedule.id;
        this.aftercareLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('schedule_aftercare', {
            id: this.detail.meeting.id,
            schedule_id: scheduleId
        });
        if (this.selectedSchedule?.id !== scheduleId) return;
        this.aftercareLoading = false;
        if (code !== 200) {
            this.scheduleAftercare = null;
            await this.service.modal.error(
                this.errorMessage(data, '추억과 정산 내역을 불러오지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyScheduleAftercare(data, false);
        await this.service.render();
    }

    public async chooseMemoryPhoto() {
        if (this.memoryDraft.photos.length >= 4 || this.saving) return;
        const image = await this.service.file.read({
            type: 'image',
            accept: 'image/*',
            width: 960,
            quality: 0.78
        });
        if (!image) return;
        if (image.length > 1800000) {
            await this.service.modal.error(
                '사진 한 장은 1.3MB 이하로 올려주세요.'
            );
            return;
        }
        this.memoryDraft.photos.push(image);
        await this.service.render();
    }

    public async selectMemoryPhotos(event: any) {
        const input = event?.target as HTMLInputElement;
        const files = Array.from(input?.files || []) as File[];
        await this.addMemoryPhotos(files);
        if (input) input.value = '';
    }

    public async handleMemoryDragOver(event: DragEvent) {
        event.preventDefault();
        if (this.saving) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        this.memoryDropActive = true;
        await this.service.render();
    }

    public async handleMemoryDragLeave(event: DragEvent) {
        event.preventDefault();
        this.memoryDropActive = false;
        await this.service.render();
    }

    public async dropMemoryPhotos(event: DragEvent) {
        event.preventDefault();
        this.memoryDropActive = false;
        if (this.saving) return;
        await this.addMemoryPhotos(
            Array.from(event.dataTransfer?.files || []) as File[]
        );
    }

    public removeMemoryPhoto(index: number) {
        this.memoryDraft.photos.splice(index, 1);
        this.service.render();
    }

    public async saveScheduleMemory() {
        if (this.saving) return;
        if (!this.selectedSchedule?.id || !this.scheduleAftercare?.is_participant) {
            await this.service.modal.error(
                '이 일정의 참여자만 추억을 저장할 수 있습니다.'
            );
            return;
        }
        if (!String(this.memoryDraft.review || '').trim()
            && !this.memoryDraft.photos.length) {
            await this.service.modal.error('사진이나 후기를 하나 이상 남겨주세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_schedule_memory', {
            id: this.detail.meeting.id,
            schedule_id: this.selectedSchedule.id,
            review: this.memoryDraft.review,
            visibility: this.memoryDraft.visibility,
            photos: JSON.stringify(this.memoryDraft.photos)
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '추억을 저장하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyScheduleAftercare(data, false);
        this.memoryDraft = this.emptyMemory();
        this.syncSelectedScheduleMemoryPreview();
        await this.service.modal.success('일정의 추억을 저장했습니다.');
        await this.service.render();
    }

    public async deleteScheduleMemory(memory: any) {
        if (!memory?.is_mine || this.saving) return;
        const confirmed = await this.service.modal.warning(
            '이 추억에 올린 사진과 후기를 삭제합니다.',
            '취소',
            '추억 삭제'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_schedule_memory', {
            id: this.detail.meeting.id,
            schedule_id: this.selectedSchedule.id,
            memory_id: memory.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '추억을 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyScheduleAftercare(data, false);
        this.syncSelectedScheduleMemoryPreview();
        await this.service.modal.success('내 추억을 삭제했습니다.');
        await this.service.render();
    }

    public async addScheduleExpense() {
        if (this.saving) return;
        if (!this.selectedSchedule?.id || !this.scheduleAftercare?.is_participant) {
            await this.service.modal.error(
                '이 일정의 참여자만 지출 내역을 추가할 수 있습니다.'
            );
            return;
        }
        if (!String(this.expenseDraft.title || '').trim()) {
            await this.service.modal.error('지출 내용을 입력해주세요.');
            return;
        }
        if (Number(this.expenseDraft.amount) <= 0) {
            await this.service.modal.error('금액을 1원 이상 입력해주세요.');
            return;
        }
        if (!this.expenseDraft.payer_id) {
            await this.service.modal.error('결제한 사람을 선택해주세요.');
            return;
        }
        if (!this.expenseDraft.participant_ids.length) {
            await this.service.modal.error('나눠 낼 사람을 한 명 이상 선택해주세요.');
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_schedule_expense', {
            id: this.detail.meeting.id,
            schedule_id: this.selectedSchedule.id,
            title: this.expenseDraft.title,
            amount: this.expenseDraft.amount,
            payer_id: this.expenseDraft.payer_id,
            participant_ids: JSON.stringify(
                this.expenseDraft.participant_ids
            )
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '지출 내역을 추가하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyScheduleAftercare(data, false);
        this.expenseDraft = this.emptyExpense();
        this.setDefaultExpensePayer();
        await this.service.render();
    }

    public filteredPaymentBanks() {
        const query = String(this.paymentBankSearch || '')
            .trim()
            .toLocaleLowerCase('ko-KR');
        if (
            !query
            || query === String(this.paymentInfoDraft.bank_name || '')
                .toLocaleLowerCase('ko-KR')
        ) return this.paymentBankOptions;
        return this.paymentBankOptions.filter((bank: string) =>
            bank.toLocaleLowerCase('ko-KR').includes(query)
        );
    }

    public openPaymentBankOptions() {
        if (this.paymentBankCloseTimer) {
            clearTimeout(this.paymentBankCloseTimer);
            this.paymentBankCloseTimer = null;
        }
        this.paymentBankDropdownOpen = true;
        this.service.render();
    }

    public togglePaymentBankOptions(event?: Event) {
        if (event) event.preventDefault();
        if (this.paymentBankDropdownOpen) {
            this.closePaymentBankOptions();
            return;
        }
        this.openPaymentBankOptions();
    }

    public closePaymentBankOptions(event?: Event) {
        if (event) event.preventDefault();
        if (this.paymentBankCloseTimer) {
            clearTimeout(this.paymentBankCloseTimer);
            this.paymentBankCloseTimer = null;
        }
        this.paymentBankDropdownOpen = false;
        this.service.render();
    }

    public deferClosePaymentBankOptions() {
        if (this.paymentBankCloseTimer) {
            clearTimeout(this.paymentBankCloseTimer);
        }
        this.paymentBankCloseTimer = setTimeout(() => {
            this.paymentBankDropdownOpen = false;
            this.paymentBankCloseTimer = null;
            this.service.render();
        }, 120);
    }

    public updatePaymentBankSearch(value: string) {
        this.paymentBankSearch = String(value || '');
        const exactBank = this.paymentBankOptions.find(
            (bank: string) => bank === this.paymentBankSearch.trim()
        ) || '';
        this.paymentInfoDraft.bank_name = exactBank;
        this.paymentInfoDraft.account_number = this.formatPaymentAccountNumber(
            this.paymentInfoDraft.account_number, exactBank
        );
        this.paymentBankDropdownOpen = true;
        this.service.render();
    }

    public selectPaymentBank(bankName: string) {
        if (!this.paymentBankOptions.includes(bankName)) return;
        this.paymentInfoDraft.bank_name = bankName;
        this.paymentInfoDraft.account_number = this.formatPaymentAccountNumber(
            this.paymentInfoDraft.account_number, bankName
        );
        this.paymentBankSearch = bankName;
        this.paymentBankDropdownOpen = false;
        this.service.render();
    }

    public selectFirstFilteredPaymentBank(event: KeyboardEvent) {
        if (this.paymentBankSearch.trim() === this.paymentInfoDraft.bank_name) {
            event.preventDefault();
            this.paymentBankDropdownOpen = false;
            this.service.render();
            return;
        }
        const bankName = this.filteredPaymentBanks()[0];
        if (!this.paymentBankDropdownOpen || !bankName) return;
        event.preventDefault();
        this.selectPaymentBank(bankName);
    }

    public updatePaymentAccountNumber(value: string) {
        this.paymentInfoDraft.account_number = this.formatPaymentAccountNumber(
            value, this.paymentInfoDraft.bank_name
        );
        this.service.render();
    }

    public sanitizePaymentAccountInput(event: Event) {
        const input = event.target as HTMLInputElement;
        const formatted = this.formatPaymentAccountNumber(
            input?.value || '', this.paymentInfoDraft.bank_name
        );
        if (input && input.value !== formatted) input.value = formatted;
        this.paymentInfoDraft.account_number = formatted;
        this.service.render();
    }

    public restrictPaymentAccountKeydown(event: KeyboardEvent) {
        if (event.ctrlKey || event.metaKey) return;
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
            'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab', 'Enter'
        ];
        if (allowedKeys.includes(event.key)) return;
        if (/^[0-9]$/.test(event.key)) return;
        event.preventDefault();
    }

    public restrictPaymentAccountBeforeInput(event: InputEvent) {
        if (
            event.inputType.startsWith('delete')
            || event.inputType.startsWith('history')
        ) return;
        if (event.data !== null && !/^\d+$/.test(event.data)) {
            event.preventDefault();
        }
    }

    public restrictPaymentAccountPaste(event: ClipboardEvent) {
        const text = event.clipboardData?.getData('text') || '';
        if (!/^\d+$/.test(text)) event.preventDefault();
    }

    public restrictPaymentAccountDrop(event: DragEvent) {
        const text = event.dataTransfer?.getData('text') || '';
        if (!/^\d+$/.test(text)) event.preventDefault();
    }

    public paymentAccountDigits(value: any = null) {
        const target = value === null
            ? this.paymentInfoDraft.account_number
            : value;
        return String(target || '').replace(/\D/g, '').slice(0, 20);
    }

    public formatPaymentAccountNumber(value: any, bankName: string = '') {
        const digits = this.paymentAccountDigits(value);
        if (!digits) return '';
        const pattern = this.paymentAccountPatterns[bankName]
            || [4, 4, 4, 4, 4];
        const groups: string[] = [];
        let offset = 0;
        for (const size of pattern) {
            if (offset >= digits.length) break;
            groups.push(digits.slice(offset, offset + size));
            offset += size;
        }
        if (offset < digits.length) groups.push(digits.slice(offset));
        return groups.filter((group: string) => !!group).join('-');
    }

    public paymentInfoAccountLabel(info: any) {
        if (info?.formatted_account_number) {
            return info.formatted_account_number;
        }
        if (info?.account_number) {
            return this.formatPaymentAccountNumber(
                info.account_number, info.bank_name || ''
            );
        }
        const editValue = this.paymentInfoEditValue(info);
        if (editValue.account_number) return editValue.account_number;
        return info?.content || '기존 송금 정보를 다시 등록해주세요.';
    }

    public paymentInfoBankLabel(info: any) {
        return this.paymentInfoEditValue(info).bank_name
            || '기존 송금 정보';
    }

    public paymentInfoFormValid() {
        return this.paymentBankOptions.includes(
            this.paymentInfoDraft.bank_name
        ) && this.paymentAccountDigits().length >= 8;
    }

    private parsePaymentBundle(content: any) {
        try {
            const payload = JSON.parse(String(content || ''));
            if (payload?.v !== 1 || !Array.isArray(payload?.a)) return [];
            return payload.a
                .filter((entry: any) => Array.isArray(entry) && entry.length >= 3)
                .map((entry: any) => ({
                    id: String(entry[0] || ''),
                    bank_name: String(entry[1] || ''),
                    account_number: this.paymentAccountDigits(entry[2] || '')
                }))
                .filter((entry: any) =>
                    !!entry.id
                    && this.paymentBankOptions.includes(entry.bank_name)
                    && entry.account_number.length >= 8
                );
        } catch (error) {
            return [];
        }
    }

    private paymentEntryId() {
        return `${Date.now().toString(36)}${Math.random()
            .toString(36).slice(2, 7)}`;
    }

    private ownPaymentEntries(excludedId: string = '') {
        return (this.scheduleAftercare?.payment_infos || [])
            .filter((info: any) => info.is_mine && info.id !== excludedId)
            .map((info: any) => {
                const value = this.paymentInfoEditValue(info);
                return {
                    id: String(info.bundle_entry_id || info.id || ''),
                    bank_name: value.bank_name,
                    account_number: this.paymentAccountDigits(
                        value.account_number
                    )
                };
            })
            .filter((entry: any) =>
                !!entry.id
                && this.paymentBankOptions.includes(entry.bank_name)
                && entry.account_number.length >= 8
            );
    }

    private encodePaymentEntries(entries: any[]) {
        return JSON.stringify({
            v: 1,
            a: entries.map((entry: any) => [
                entry.id, entry.bank_name, entry.account_number
            ])
        });
    }

    public paymentInfoContent() {
        const bankName = String(this.paymentInfoDraft.bank_name || '').trim();
        const accountNumber = this.paymentAccountDigits();
        const editingInfo = this.paymentInfoEditing
            ? (this.scheduleAftercare?.payment_infos || []).find(
                (info: any) => info.id === this.paymentInfoEditingEntryId
            )
            : null;
        const entries = this.ownPaymentEntries(
            this.paymentInfoEditing ? this.paymentInfoEditingEntryId : ''
        );
        entries.push({
            id: this.paymentInfoEditing
                ? String(
                    editingInfo?.bundle_entry_id
                    || editingInfo?.id
                    || this.paymentInfoEditingEntryId
                )
                : this.paymentEntryId(),
            bank_name: bankName,
            account_number: accountNumber
        });
        return this.encodePaymentEntries(entries);
    }

    public paymentDestinationLabel(value: any) {
        const entries = this.parsePaymentBundle(value);
        if (!entries.length) return String(value || '');
        const account = entries[entries.length - 1];
        return `${account.bank_name} ${this.formatPaymentAccountNumber(
            account.account_number, account.bank_name
        )}`;
    }

    public paymentInfoChanged() {
        if (!this.paymentInfoEditing) return true;
        const saved = (this.scheduleAftercare?.payment_infos || []).find(
            (info: any) => info.id === this.paymentInfoEditingEntryId
                && info.is_mine
        );
        if (!saved) return false;
        const savedValue = this.paymentInfoEditValue(saved);
        return String(savedValue.bank_name || '')
            !== String(this.paymentInfoDraft.bank_name || '')
            || this.paymentAccountDigits(savedValue.account_number || '')
            !== this.paymentAccountDigits();
    }

    public canSavePaymentInfo() {
        return !this.saving
            && this.paymentInfoFormValid()
            && this.paymentInfoChanged();
    }

    public paymentInfoEditValue(info: any) {
        let bankName = String(info?.bank_name || '').trim();
        let accountNumber = this.paymentAccountDigits(
            info?.account_number || ''
        );
        if (!bankName || !accountNumber) {
            const content = String(info?.content || '').trim();
            const legacyBank = [...this.paymentBankOptions]
                .sort((left: string, right: string) => right.length - left.length)
                .find((bank: string) => content.startsWith(bank)) || '';
            if (legacyBank) {
                bankName = legacyBank;
                accountNumber = this.paymentAccountDigits(
                    content.slice(legacyBank.length)
                );
            }
        }
        return {
            bank_name: bankName,
            account_number: this.formatPaymentAccountNumber(
                accountNumber, bankName
            )
        };
    }

    public async editSchedulePaymentInfo(info: any) {
        if (!info?.is_mine || !info?.id || this.saving) return;
        const editValue = this.paymentInfoEditValue(info);
        this.paymentInfoEditing = true;
        this.paymentInfoEditingId = String(info.storage_id || info.id || '');
        this.paymentInfoEditingEntryId = String(info.id || '');
        this.paymentInfoDraft = editValue;
        this.paymentBankSearch = editValue.bank_name;
        this.paymentBankDropdownOpen = false;
        await this.service.render();
        setTimeout(() => {
            document.getElementById('payment-editor-title')?.scrollIntoView({
                behavior: 'smooth', block: 'nearest'
            });
        }, 0);
    }

    public cancelSchedulePaymentInfoEdit() {
        this.paymentInfoEditing = false;
        this.paymentInfoEditingId = '';
        this.paymentInfoEditingEntryId = '';
        this.paymentInfoDraft = this.emptyPaymentInfo();
        this.paymentBankSearch = '';
        this.closePaymentBankOptions();
    }

    public async copySchedulePaymentAccount(info: any) {
        const editValue = this.paymentInfoEditValue(info);
        const accountNumber = editValue.account_number
            ? this.paymentAccountDigits(editValue.account_number)
            : String(info?.content || '').trim();
        if (!accountNumber) return;
        try {
            await this.writeClipboard(accountNumber);
            await this.showPaymentToast('계좌번호를 복사했습니다.');
        } catch (error) {
            await this.showPaymentToast('계좌번호를 복사하지 못했습니다.');
        }
    }

    public async copyScheduleAddress() {
        const address = String(
            this.selectedSchedule?.place_address || ''
        ).trim();
        if (!address) return;
        try {
            await this.writeClipboard(address);
            await this.showPaymentToast('주소를 복사했습니다.');
        } catch (error) {
            await this.showPaymentToast('주소를 복사하지 못했습니다.');
        }
    }

    public async saveSchedulePaymentInfo() {
        if (this.saving) return;
        if (!this.selectedSchedule?.id || !this.scheduleAftercare?.is_participant) {
            await this.service.modal.error(
                '이 일정의 참여자만 송금 정보를 등록할 수 있습니다.'
            );
            return;
        }
        if (!this.paymentInfoDraft.bank_name) {
            await this.service.modal.error('은행을 목록에서 선택해주세요.');
            return;
        }
        if (this.paymentAccountDigits().length < 8) {
            await this.service.modal.error('계좌번호를 8자리 이상 입력해주세요.');
            return;
        }
        if (!this.paymentInfoChanged()) return;
        if (!this.paymentInfoEditing && this.ownPaymentEntries().length >= 16) {
            await this.service.modal.error(
                '송금 정보는 한 일정에 최대 16개까지 등록할 수 있습니다.'
            );
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_schedule_payment_info', {
            id: this.detail.meeting.id,
            schedule_id: this.selectedSchedule.id,
            bank_name: this.paymentInfoDraft.bank_name,
            account_number: this.paymentAccountDigits(),
            payment_info_id: this.paymentInfoEditingId,
            content: this.paymentInfoContent()
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '송금 정보를 저장하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        const successMessage = this.paymentInfoEditing
            ? '송금 정보를 수정했습니다.'
            : '송금 정보를 추가했습니다.';
        this.applyScheduleAftercare(data, false);
        await this.service.modal.success(successMessage);
        await this.service.render();
    }

    public async deleteSchedulePaymentInfo(info: any) {
        if (!info?.is_mine || !info?.id || this.saving) return;
        const confirmed = await this.service.modal.warning(
            '등록한 송금 정보를 삭제할까요?',
            '취소',
            '송금 정보 삭제'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        let response: any;
        if (info.is_bundle_entry) {
            const remaining = this.ownPaymentEntries(info.id);
            if (remaining.length) {
                const account = remaining[0];
                response = await wiz.call('save_schedule_payment_info', {
                    id: this.detail.meeting.id,
                    schedule_id: this.selectedSchedule.id,
                    bank_name: account.bank_name,
                    account_number: account.account_number,
                    payment_info_id: info.storage_id,
                    content: this.encodePaymentEntries(remaining)
                });
            } else {
                response = await wiz.call('delete_schedule_payment_info', {
                    id: this.detail.meeting.id,
                    schedule_id: this.selectedSchedule.id,
                    payment_info_id: info.storage_id
                });
            }
        } else {
            response = await wiz.call('delete_schedule_payment_info', {
                id: this.detail.meeting.id,
                schedule_id: this.selectedSchedule.id,
                payment_info_id: info.storage_id || info.id
            });
        }
        const { code, data } = response;
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '송금 정보를 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyScheduleAftercare(data, false);
        await this.service.render();
    }

    public async deleteScheduleExpense(expense: any) {
        if (!expense?.can_delete || this.saving) return;
        const confirmed = await this.service.modal.warning(
            `‘${expense.title}’ 지출을 삭제할까요?`,
            '취소',
            '내역 삭제'
        );
        if (!confirmed) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_schedule_expense', {
            id: this.detail.meeting.id,
            schedule_id: this.selectedSchedule.id,
            expense_id: expense.id
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '지출 내역을 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.applyScheduleAftercare(data, false);
        await this.service.render();
    }

    public formatWon(value: any) {
        return `${Math.max(0, Number(value) || 0).toLocaleString('ko-KR')}원`;
    }

    public expensePayerCount() {
        return (this.scheduleAftercare?.settlement?.people || []).filter(
            (person: any) => Number(person?.paid) > 0
        ).length;
    }

    public expenseTransferPeopleCount() {
        const userIds = (this.scheduleAftercare?.settlement?.transfers || [])
            .map((transfer: any) => transfer?.from_id)
            .filter((userId: string) => !!userId);
        return new Set(userIds).size;
    }

    public setExpenseDetailTab(
        tab: 'expenses' | 'settlement' | 'payment'
    ) {
        if (!['expenses', 'settlement', 'payment'].includes(tab)) return;
        this.expenseDetailTab = tab;
        this.service.render();
    }

    public isExpenseParticipantSelected(userId: string) {
        return (this.expenseDraft.participant_ids || []).includes(userId);
    }

    public async toggleExpenseParticipant(userId: string) {
        const selected = [...(this.expenseDraft.participant_ids || [])];
        const index = selected.indexOf(userId);
        if (index >= 0) selected.splice(index, 1);
        else selected.push(userId);
        this.expenseDraft.participant_ids = selected;
        await this.service.render();
    }

    public setScheduleDetailTab(
        tab: 'schedule' | 'itinerary' | 'memory' | 'expense'
    ) {
        if (!['schedule', 'itinerary', 'memory', 'expense'].includes(tab)) return;
        this.scheduleDetailTab = tab;
        if (
            ['memory', 'expense'].includes(tab)
            && this.selectedSchedule?.is_past
            && !this.scheduleAftercare
            && !this.aftercareLoading
        ) {
            void this.loadScheduleAftercare();
        }
        this.service.render();
    }

    public openImageLightbox(image: string, alt: string = '추억 사진') {
        if (!image) return;
        this.lightboxImage = image;
        this.lightboxAlt = alt;
        this.service.render();
    }

    public closeImageLightbox() {
        this.lightboxImage = '';
        this.lightboxAlt = '';
        this.service.render();
    }

    public async setReportPeriod(period: 'month' | 'year') {
        if (!['month', 'year'].includes(period)) return;
        this.reportPeriod = period;
        await this.loadReport();
    }

    public async shiftReport(direction: number) {
        if (![-1, 1].includes(direction) || this.reportLoading) return;
        const target = new Date(this.reportAnchor);
        if (this.reportPeriod === 'year') {
            target.setFullYear(target.getFullYear() + direction);
        } else {
            target.setMonth(target.getMonth() + direction);
        }
        this.reportAnchor = target;
        await this.loadReport();
    }

    public async loadReport() {
        if (!this.detail?.meeting?.id) return;
        this.reportLoading = true;
        await this.service.render();
        const anchor = this.reportPeriod === 'year'
            ? String(this.reportAnchor.getFullYear())
            : [
                this.reportAnchor.getFullYear(),
                String(this.reportAnchor.getMonth() + 1).padStart(2, '0')
            ].join('-');
        const { code, data } = await wiz.call('report', {
            id: this.detail.meeting.id,
            period: this.reportPeriod,
            anchor
        });
        this.reportLoading = false;
        if (code !== 200) {
            this.reportData = null;
            await this.service.modal.error(
                this.errorMessage(data, '리포트를 불러오지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        this.reportData = data;
        await this.service.render();
    }

    public reportHeatLevel(item: any) {
        const count = Number(item?.meeting_count) || 0;
        if (count <= 0) return 'level-0';
        const maximum = Math.max(
            1,
            ...(this.reportData?.heatmap || []).map(
                (entry: any) => Number(entry?.meeting_count) || 0
            )
        );
        const ratio = count / maximum;
        if (ratio > 0.66) return 'level-3';
        if (ratio > 0.33) return 'level-2';
        return 'level-1';
    }

    public reportHeatmapGridColumn(item: any, index: number) {
        if (this.reportPeriod !== 'month' || index !== 0) return null;
        return String((Number(item?.weekday) || 0) + 1);
    }

    private defaultReportAnchor(schedules: any[]) {
        const now = new Date();
        const completed = (schedules || []).map((schedule: any) => ({
            start: this.parseDisplayDate(schedule?.schedule_at),
            end: this.parseDisplayDate(
                schedule?.schedule_end_at || schedule?.schedule_at
            )
        })).filter((schedule: any) => (
            schedule.start
            && schedule.end
            && schedule.end.getTime() < now.getTime()
        )).sort((left: any, right: any) => (
            right.start.getTime() - left.start.getTime()
        ));
        return completed[0]?.start || now;
    }

    public async shareSelectedSchedule() {
        const schedule = this.selectedSchedule;
        if (!schedule?.id || !this.detail?.meeting?.id) return;

        const meetingName = this.detail.meeting.name || '모임';
        const shareUrl = this.scheduleShareUrl(schedule);
        const place = schedule.place || schedule.place_address || '';
        const shareText = [
            `${meetingName} · ${schedule.title}`,
            this.formatScheduleRange(schedule),
            place
        ].filter((value: string) => !!value).join('\n');

        const nav: any = navigator;
        if (typeof nav.share === 'function') {
            try {
                await nav.share({
                    title: `${meetingName} · ${schedule.title}`,
                    text: shareText,
                    url: shareUrl
                });
                return;
            } catch (error) {
                const failure: any = error;
                if (failure?.name === 'AbortError') return;
            }
        }

        try {
            await this.writeClipboard(shareUrl);
            await this.service.modal.success(
                '일정 링크를 복사했습니다. 모임 멤버에게 공유해주세요.'
            );
        } catch (error) {
            await this.service.modal.error(
                '일정 링크를 공유하지 못했습니다. 잠시 후 다시 시도해주세요.'
            );
        }
    }

    public async exportSelectedSchedule() {
        const schedule = this.selectedSchedule;
        if (!schedule?.id || !this.detail?.meeting?.id) return;

        try {
            const calendar = this.scheduleCalendarContent(schedule);
            const blob = new Blob([calendar], {
                type: 'text/calendar;charset=utf-8'
            });
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = `${this.scheduleCalendarFilename(schedule)}.ics`;
            anchor.style.display = 'none';
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
            await this.service.modal.success(
                '캘린더 파일을 만들었습니다. 원하는 캘린더 앱에서 열어주세요.'
            );
        } catch (error) {
            await this.service.modal.error(
                '캘린더 파일을 만들지 못했습니다. 일정 시간을 확인해주세요.'
            );
        }
    }

    public closeScheduleDetail() {
        if (this.saving) return;
        this.showScheduleDetailModal = false;
        this.selectedSchedule = null;
        this.scheduleAftercare = null;
        this.aftercareLoading = false;
        this.itineraryEditing = false;
        this.scheduleDetailTab = 'schedule';
        this.expenseDetailTab = 'expenses';
        this.lightboxImage = '';
        this.lightboxAlt = '';
        this.service.render();
    }

    public handleScheduleDetailBackdrop() {
        if (this.saving) return;
        if (this.itineraryEditing) {
            this.cancelItineraryEdit();
            return;
        }
        this.closeScheduleDetail();
    }

    public async deleteSelectedSchedule() {
        if (!this.canDeleteSchedule(this.selectedSchedule) || this.saving) return;
        const confirmed = await this.service.modal.warning(
            '일정을 삭제하면 참여 인원과 하루 동선도 함께 삭제되며 복구할 수 없습니다.',
            '취소',
            '일정 삭제'
        );
        if (!confirmed) return;

        const meeting = this.detail.meeting;
        const scheduleId = this.selectedSchedule.id;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_schedule', {
            id: meeting.id,
            schedule_id: scheduleId
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '일정을 삭제하지 못했습니다.')
            );
            await this.service.render();
            return;
        }

        this.showScheduleDetailModal = false;
        this.selectedSchedule = null;
        this.itineraryEditing = false;
        await this.openMeeting(meeting, false);
        await this.service.modal.success('모임 일정이 삭제되었습니다.');
    }

    public beginItineraryEdit() {
        if (!this.canEditSchedule(this.selectedSchedule) || this.saving) return;
        this.itineraryDraft = this.copyStops(this.selectedSchedule.itinerary || []);
        this.routeSummaryExpanded = true;
        this.scheduleDetailTab = 'itinerary';
        this.itineraryEditing = true;
        if (this.itineraryDraft.length === 0) this.addItineraryStop();
        this.service.render();
    }

    public cancelItineraryEdit() {
        if (this.saving) return;
        this.itineraryEditing = false;
        this.itineraryDraft = this.copyStops(this.selectedSchedule.itinerary || []);
        this.service.render();
    }

    public addItineraryStop() {
        if (this.itineraryDraft.length >= this.itineraryMaxStops) return;
        this.itineraryDraft.push({
            time: '',
            place: '',
            activity: '',
            transportMode: '',
            transportDuration: '',
            confirmed: false
        });
        this.service.render();
    }

    public removeItineraryStop(index: number) {
        this.itineraryDraft.splice(index, 1);
        this.service.render();
    }

    public moveItineraryStop(index: number, direction: number) {
        const target = index + direction;
        if (target < 0 || target >= this.itineraryDraft.length) return;
        const current = this.itineraryDraft[index];
        this.itineraryDraft[index] = this.itineraryDraft[target];
        this.itineraryDraft[target] = current;
        this.service.render();
    }

    public async clearItineraryTime(stop: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        stop.time = '';
        await this.service.render();
    }

    public itineraryStopConfirmed(stop: any) {
        return stop?.confirmed === undefined
            ? true
            : !!stop.confirmed;
    }

    public async setItineraryStopConfirmed(stop: any, confirmed: boolean) {
        stop.confirmed = confirmed;
        await this.service.render();
    }

    public itineraryTransport(stop: any) {
        const mode = String(stop?.transportMode || '').trim();
        const duration = String(stop?.transportDuration || '').trim();
        if (mode === '기타') return duration;
        return [mode, duration].filter(Boolean).join(' · ');
    }

    public toggleRouteSummary() {
        this.routeSummaryExpanded = !this.routeSummaryExpanded;
        this.service.render();
    }

    public async saveItinerary() {
        if (!this.canEditSchedule(this.selectedSchedule) || this.saving) {
            await this.service.modal.error(
                '이 일정의 하루 동선을 수정할 권한이 없습니다.'
            );
            return;
        }
        if (this.itineraryDraft.some((stop: any) => !stop.place.trim() && !stop.activity.trim())) {
            await this.service.modal.error('각 동선에 장소나 할 일을 입력해주세요.');
            return;
        }
        if (!this.itineraryTimesAreOrdered(this.itineraryDraft)) {
            await this.service.modal.error(
                '동선 시간은 목록 순서대로 빠른 시간부터 입력해주세요. ' +
                '시간 없이 순서만 저장할 수도 있습니다.'
            );
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_itinerary', {
            id: this.detail.meeting.id,
            schedule_id: this.selectedSchedule.id,
            stops: JSON.stringify(
                this.itineraryDraft.map((stop: any) => ({
                    time: stop.time || '',
                    place: stop.place || '',
                    activity: stop.activity || '',
                    transport: this.itineraryTransport(stop),
                    confirmed: !!stop.confirmed
                }))
            )
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.modal.error(this.errorMessage(data, '하루 동선을 저장하지 못했습니다.'));
            await this.service.render();
            return;
        }

        const index = this.detail.schedules.findIndex((schedule: any) => schedule.id === data.id);
        if (index >= 0) this.detail.schedules[index] = data;
        this.selectedSchedule = data;
        this.itineraryDraft = this.copyStops(data.itinerary || []);
        this.itineraryEditing = false;
        await this.service.modal.success('하루 동선이 저장되었습니다.');
        await this.service.render();
    }

    public setDetailTab(tab: string) {
        if (!['schedule', 'poll', 'report', 'members'].includes(tab)) return;
        this.detailTab = tab;
        this.service.render();
        if (tab === 'report' && !this.reportData && !this.reportLoading) {
            void this.loadReport();
        }
    }

    public setScheduleView(view: string) {
        if (!['calendar', 'list'].includes(view)) return;
        this.scheduleView = view;
        this.schedulePage = 1;
        this.service.render();
    }

    public setScheduleMonthFilter(month: string) {
        if (!['all', 'this', 'next'].includes(month)) return;
        this.scheduleMonthFilter = month;
        this.schedulePage = 1;
        this.service.render();
    }

    public setScheduleStatusFilter(status: string) {
        if (!['all', 'upcoming', 'past'].includes(status)) return;
        this.scheduleStatusFilter = status;
        this.schedulePage = 1;
        this.service.render();
    }

    public setScheduleParticipationFilter(participation: string) {
        if (!['all', 'mine', 'not-mine'].includes(participation)) return;
        this.scheduleParticipationFilter = participation;
        this.schedulePage = 1;
        this.service.render();
    }

    public toggleCalendarMineOnly() {
        this.calendarMineOnly = !this.calendarMineOnly;
        this.service.render();
    }

    public hasActiveScheduleFilters() {
        return this.scheduleMonthFilter !== 'all'
            || this.scheduleStatusFilter !== 'all'
            || this.scheduleParticipationFilter !== 'all';
    }

    public resetScheduleFilters() {
        this.scheduleMonthFilter = 'all';
        this.scheduleStatusFilter = 'all';
        this.scheduleParticipationFilter = 'all';
        this.calendarMineOnly = false;
        this.schedulePage = 1;
        this.service.render();
    }

    public setPollKindFilter(kind: string) {
        if (!['all', 'schedule', 'place'].includes(kind)) return;
        this.pollKindFilter = kind;
        this.service.render();
    }

    public setPollStatusFilter(status: string) {
        if (!['all', 'ongoing', 'closing', 'closed'].includes(status)) return;
        this.pollStatusFilter = status;
        this.service.render();
    }

    public setPollParticipationFilter(participation: string) {
        if (!['all', 'mine', 'pending', 'unparticipated'].includes(participation)) return;
        this.pollParticipationFilter = participation;
        this.service.render();
    }

    public setPollSort(sort: string) {
        if (!['latest', 'oldest'].includes(sort)) return;
        this.pollSort = sort;
        this.service.render();
    }

    public setPollView(view: string) {
        if (!['list', 'grid'].includes(view)) return;
        this.pollView = view;
        this.service.render();
    }

    public togglePollParticipationFilter() {
        this.setPollParticipationFilter(
            this.pollParticipationFilter === 'mine' ? 'all' : 'mine'
        );
    }

    public hasActivePollFilters() {
        return this.pollKindFilter !== 'all'
            || this.pollStatusFilter !== 'all'
            || this.pollParticipationFilter !== 'all'
            || this.pollSort !== 'latest';
    }

    public resetPollFilters() {
        this.pollKindFilter = 'all';
        this.pollStatusFilter = 'all';
        this.pollParticipationFilter = 'all';
        this.pollSort = 'latest';
        this.service.render();
    }

    public filteredPolls() {
        const polls = (this.detail?.polls || []).filter((poll: any) => {
            return this.pollMatchesKind(poll, this.pollKindFilter)
                && this.pollMatchesStatus(poll, this.pollStatusFilter)
                && this.pollMatchesParticipation(
                    poll,
                    this.pollParticipationFilter
                );
        });
        return polls.sort((left: any, right: any) => {
            const leftTime = this.pollCreatedTime(left);
            const rightTime = this.pollCreatedTime(right);
            return this.pollSort === 'oldest'
                ? leftTime - rightTime
                : rightTime - leftTime;
        });
    }

    public pollKindCount(kind: string) {
        return (this.detail?.polls || []).filter((poll: any) => {
            return this.pollMatchesKind(poll, kind)
                && this.pollMatchesStatus(poll, this.pollStatusFilter)
                && this.pollMatchesParticipation(
                    poll,
                    this.pollParticipationFilter
                );
        }).length;
    }

    public pollStatusCount(status: string) {
        return (this.detail?.polls || []).filter((poll: any) => {
            return this.pollMatchesKind(poll, this.pollKindFilter)
                && this.pollMatchesStatus(poll, status)
                && this.pollMatchesParticipation(
                    poll,
                    this.pollParticipationFilter
                );
        }).length;
    }

    public pollParticipationCount(participation: string) {
        return (this.detail?.polls || []).filter((poll: any) => {
            return this.pollMatchesKind(poll, this.pollKindFilter)
                && this.pollMatchesStatus(poll, this.pollStatusFilter)
                && this.pollMatchesParticipation(poll, participation);
        }).length;
    }

    public isPollOngoing(poll: any) {
        if (typeof poll?.is_open === 'boolean') return poll.is_open;
        return ['open', 'active', 'ongoing'].includes(poll?.effective_status);
    }

    public isPollClosingSoon(poll: any) {
        if (!this.isPollOngoing(poll) || !poll?.closes_at) return false;
        const closesAt = new Date(String(poll.closes_at).replace(' ', 'T'));
        if (isNaN(closesAt.getTime())) return false;
        const remaining = closesAt.getTime() - new Date().getTime();
        return remaining > 0 && remaining <= 3 * 24 * 60 * 60 * 1000;
    }

    public hasParticipatedInPoll(poll: any) {
        if (typeof poll?.my_participated === 'boolean') {
            return poll.my_participated;
        }
        return (poll?.options || []).some(
            (option: any) => option.my_selected
        );
    }

    public isCurrentUserScheduleParticipant(schedule: any) {
        if (typeof schedule?.is_participant === 'boolean') {
            return schedule.is_participant;
        }
        const currentUserId = this.service.auth?.session?.id || '';
        return !!currentUserId && (schedule?.participants || []).some(
            (participant: any) => participant.user_id === currentUserId
        );
    }

    public filteredSchedules() {
        return (this.detail?.schedules || []).filter(
            (schedule: any) =>
                this.scheduleMatchesMonth(schedule, this.scheduleMonthFilter)
                && this.scheduleMatchesStatus(
                    schedule,
                    this.scheduleStatusFilter
                )
                && this.scheduleMatchesParticipation(
                    schedule,
                    this.scheduleParticipationFilter
                )
        );
    }

    public calendarSchedules() {
        const schedules = this.detail?.schedules || [];
        return this.calendarMineOnly
            ? schedules.filter(
                (schedule: any) =>
                    this.isCurrentUserScheduleParticipant(schedule)
            )
            : schedules;
    }

    public displayedSchedules() {
        return this.scheduleView === 'calendar'
            ? this.calendarSchedules()
            : this.filteredSchedules();
    }

    public scheduleFilterEmptyTitle() {
        if (this.scheduleView === 'calendar' && this.calendarMineOnly) {
            return '내가 참여한 일정이 없어요';
        }
        if (this.scheduleParticipationFilter === 'mine') {
            return '내가 참여한 일정이 없어요';
        }
        if (this.scheduleParticipationFilter === 'not-mine') {
            return '내가 참여하지 않는 일정이 없어요';
        }
        return '조건에 맞는 일정이 없어요';
    }

    public scheduleFilterEmptyDescription() {
        return this.scheduleView === 'calendar'
            ? '내가 참여한 일정만 보기를 해제하면 모임의 전체 일정을 확인할 수 있어요.'
            : '월·진행 상태·참여 여부 조건을 변경해보세요.';
    }

    public myScheduleCount() {
        return (this.detail?.schedules || []).filter(
            (schedule: any) => this.isCurrentUserScheduleParticipant(schedule)
        ).length;
    }

    public visibleSchedules() {
        const schedules = this.filteredSchedules();
        const page = Math.min(this.schedulePage, this.schedulePageCount());
        const start = (page - 1) * this.schedulePageSize;
        return schedules.slice(start, start + this.schedulePageSize);
    }

    public schedulePageCount() {
        return Math.max(
            1,
            Math.ceil(this.filteredSchedules().length / this.schedulePageSize)
        );
    }

    public schedulePages() {
        const total = this.schedulePageCount();
        const windowSize = Math.min(5, total);
        const start = Math.max(
            1,
            Math.min(this.schedulePage - 2, total - windowSize + 1)
        );
        return Array.from(
            { length: windowSize },
            (_value, index) => start + index
        );
    }

    public setSchedulePage(page: number) {
        const target = Math.max(1, Math.min(page, this.schedulePageCount()));
        if (target === this.schedulePage) return;
        this.schedulePage = target;
        this.service.render();
    }

    public changeCalendarMonth(offset: number) {
        this.calendarDate = new Date(
            this.calendarDate.getFullYear(),
            this.calendarDate.getMonth() + offset,
            1
        );
        this.service.render();
    }

    public goToday() {
        this.calendarDate = new Date();
        this.service.render();
    }

    public calendarTitle() {
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: 'long'
        }).format(this.calendarDate);
    }

    public handleCalendarScheduleClick(schedule: any) {
        if (Date.now() < this.suppressCalendarClickUntil) return;
        this.openScheduleDetail(schedule);
    }

    public startScheduleDrag(
        schedule: any,
        segment: any,
        event: DragEvent
    ) {
        if (
            !this.canEditSchedule(schedule)
            || this.calendarScheduleMovingId
        ) {
            event.preventDefault();
            return;
        }
        this.draggedSchedule = schedule;
        this.calendarDragAnchorKey = (
            segment?.segmentStartKey
            || this.valueDateKey(schedule.schedule_at)
        );
        this.calendarDropDateKey = '';
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', schedule.id || '');
        }
        this.service.render();
    }

    public finishScheduleDrag() {
        this.draggedSchedule = null;
        this.calendarDragAnchorKey = '';
        this.calendarDropDateKey = '';
        this.suppressCalendarClickUntil = Date.now() + 300;
        this.service.render();
    }

    public allowScheduleDrop(day: any, event: DragEvent) {
        if (!this.draggedSchedule || this.calendarScheduleMovingId) return;
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.calendarDropDateKey === day.key) return;
        this.calendarDropDateKey = day.key;
        this.service.render();
    }

    public calendarDropLabel(day: any) {
        const date = day?.date instanceof Date
            ? day.date
            : this.parseDateKey(day?.key || '');
        if (!date) return '여기에 놓기';
        return `${date.getMonth() + 1}월 ${date.getDate()}일에 놓기`;
    }

    public leaveScheduleDrop(day: any, event: DragEvent) {
        const current = event.currentTarget as HTMLElement | null;
        const related = event.relatedTarget as Node | null;
        if (current && related && current.contains(related)) return;
        if (this.calendarDropDateKey === day.key) {
            this.calendarDropDateKey = '';
            this.service.render();
        }
    }

    public allowScheduleWeekDrop(week: any, event: DragEvent) {
        const day = this.calendarWeekDropDay(week, event);
        if (day) this.allowScheduleDrop(day, event);
    }

    public leaveScheduleWeek(event: DragEvent) {
        const current = event.currentTarget as HTMLElement | null;
        const related = event.relatedTarget as Node | null;
        if (current && related && current.contains(related)) return;
        this.calendarDropDateKey = '';
        this.service.render();
    }

    public async dropScheduleOnWeek(week: any, event: DragEvent) {
        const day = this.calendarWeekDropDay(week, event);
        if (day) await this.dropScheduleOnDay(day, event);
    }

    public async dropScheduleOnDay(day: any, event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const schedule = this.draggedSchedule;
        const anchorKey = this.calendarDragAnchorKey;
        this.finishScheduleDrag();
        if (!schedule || !this.canEditSchedule(schedule)) return;

        const scheduleStart = this.parseDateKey(
            this.valueDateKey(schedule.schedule_at)
        );
        const anchorDate = this.parseDateKey(anchorKey);
        const targetDate = this.parseDateKey(day.key);
        if (!scheduleStart || !anchorDate || !targetDate) return;
        const anchorOffset = this.dayDistance(scheduleStart, anchorDate);
        const targetStart = new Date(
            targetDate.getFullYear(),
            targetDate.getMonth(),
            targetDate.getDate() - anchorOffset
        );
        const dayOffset = this.dayDistance(scheduleStart, targetStart);
        if (dayOffset === 0) return;

        const scheduleAt = this.shiftScheduleDateValue(
            schedule.schedule_at, dayOffset
        );
        const scheduleEndAt = this.shiftScheduleDateValue(
            schedule.schedule_end_at || schedule.schedule_at,
            dayOffset
        );
        if (!scheduleAt || !scheduleEndAt) return;

        this.calendarScheduleMovingId = schedule.id;
        await this.service.render();
        const movePayload = {
            id: this.detail.meeting.id,
            schedule_id: schedule.id,
            title: schedule.title || '',
            description: schedule.description || '',
            place: schedule.place || '',
            place_address: schedule.place_address || '',
            place_link: schedule.place_link || '',
            schedule_at: scheduleAt,
            schedule_end_at: scheduleEndAt,
            all_day: !!schedule.all_day,
            participant_ids: JSON.stringify(
                (schedule.participants || [])
                    .map((participant: any) => participant.user_id)
                    .filter((userId: string) => !!userId)
            ),
            recurrence_rule: JSON.stringify(
                schedule.recurrence_rule || { frequency: 'none' }
            ),
            reminder_enabled: !!schedule.reminder_enabled,
            reminders: JSON.stringify(schedule.reminders || []),
            edit_scope: 'this',
            force_save: false
        };
        let response = await wiz.call('update_schedule', movePayload);
        if (response.code === 409) {
            this.calendarScheduleMovingId = '';
            await this.service.render();
            const confirmed = await this.service.modal.error(
                this.scheduleConflictMessage(response.data),
                true,
                '그래도 저장'
            );
            if (!confirmed) return;
            this.calendarScheduleMovingId = schedule.id;
            await this.service.render();
            response = await wiz.call('update_schedule', {
                ...movePayload,
                force_save: true
            });
        }
        const { code, data } = response;
        this.calendarScheduleMovingId = '';
        if (code !== 200) {
            await this.service.modal.error(
                this.errorMessage(data, '일정 날짜를 변경하지 못했습니다.')
            );
            await this.service.render();
            return;
        }
        const index = (this.detail?.schedules || []).findIndex(
            (item: any) => item.id === schedule.id
        );
        if (index >= 0) this.detail.schedules[index] = data;
        if (this.selectedSchedule?.id === schedule.id) {
            this.selectedSchedule = data;
        }
        await this.showPaymentToast(
            `${data.title || '일정'} 날짜를 변경했습니다.`
        );
        await this.service.render();
    }

    public calendarWeeks() {
        if (!this.detail) return [];
        const year = this.calendarDate.getFullYear();
        const month = this.calendarDate.getMonth();
        const first = new Date(year, month, 1);
        const gridStart = new Date(year, month, 1 - first.getDay());
        const todayKey = this.dateKey(new Date());
        const days: any[] = [];

        for (let index = 0; index < 42; index++) {
            const date = new Date(
                gridStart.getFullYear(),
                gridStart.getMonth(),
                gridStart.getDate() + index
            );
            const key = this.dateKey(date);
            days.push({
                key,
                date,
                day: date.getDate(),
                inMonth: date.getMonth() === month,
                isToday: key === todayKey
            });
        }

        const weeks: any[] = [];
        for (let weekIndex = 0; weekIndex < 6; weekIndex++) {
            const weekDays = days.slice(weekIndex * 7, weekIndex * 7 + 7);
            const weekStart = weekDays[0].date;
            const weekEnd = weekDays[6].date;
            const segments: any[] = [];

            this.calendarSchedules().forEach((schedule: any) => {
                const scheduleStart = this.parseDateKey(this.valueDateKey(schedule.schedule_at));
                const scheduleEnd = this.parseDateKey(
                    this.valueDateKey(schedule.schedule_end_at || schedule.schedule_at)
                );
                if (!scheduleStart || !scheduleEnd || scheduleEnd < weekStart || scheduleStart > weekEnd) return;

                const segmentStart = scheduleStart < weekStart ? weekStart : scheduleStart;
                const segmentEnd = scheduleEnd > weekEnd ? weekEnd : scheduleEnd;
                const startColumn = this.dayDistance(weekStart, segmentStart) + 1;
                const span = this.dayDistance(segmentStart, segmentEnd) + 1;
                segments.push({
                    key: `${schedule.id}-${weekDays[0].key}`,
                    schedule,
                    startColumn,
                    endColumn: startColumn + span - 1,
                    span,
                    segmentStartKey: this.dateKey(segmentStart),
                    gridColumn: `${startColumn} / span ${span}`,
                    lane: 1
                });
            });

            segments.sort((left: any, right: any) => {
                if (left.startColumn !== right.startColumn) return left.startColumn - right.startColumn;
                return right.span - left.span;
            });
            const laneEnds: number[] = [];
            segments.forEach((segment: any) => {
                let lane = laneEnds.findIndex((endColumn: number) => segment.startColumn > endColumn);
                if (lane < 0) {
                    lane = laneEnds.length;
                    laneEnds.push(segment.endColumn);
                } else {
                    laneEnds[lane] = segment.endColumn;
                }
                segment.lane = lane + 1;
            });

            weeks.push({
                key: weekDays[0].key,
                days: weekDays,
                segments,
                minHeight: Math.max(104, 49 + laneEnds.length * 40)
            });
        }
        return weeks;
    }

    public totalMembers() {
        return this.meetings.reduce((sum, meeting) => sum + Number(meeting.member_count || 0), 0);
    }

    public totalSchedules() {
        return this.meetings.reduce((sum, meeting) => sum + Number(meeting.schedule_count || 0), 0);
    }

    public formatDate(value: any, withTime: boolean = false) {
        if (!value) return '-';
        const normalized = String(value).replace(' ', 'T');
        const date = new Date(normalized);
        if (isNaN(date.getTime())) return String(value);
        const options: any = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };
        if (withTime) {
            options.weekday = 'short';
            options.hour = '2-digit';
            options.minute = '2-digit';
            options.hourCycle = 'h23';
        }
        return new Intl.DateTimeFormat('ko-KR', options).format(date);
    }

    public formatScheduleRange(schedule: any) {
        const start = schedule?.schedule_at;
        const end = schedule?.schedule_end_at || start;
        if (!start) return '-';
        if (schedule?.all_day) {
            const dateRange = this.valueDateKey(start) === this.valueDateKey(end)
                ? this.formatDate(start)
                : `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
            return `${dateRange} · 종일`;
        }
        if (this.valueDateKey(start) === this.valueDateKey(end)) {
            if (this.formatTime(start) === this.formatTime(end)) return this.formatDate(start, true);
            return `${this.formatDate(start, true)} ~ ${this.formatTime(end)}`;
        }
        return `${this.formatDate(start, true)} ~ ${this.formatDate(end, true)}`;
    }

    public formatScheduleDateLine(schedule: any) {
        const start = this.parseDisplayDate(schedule?.schedule_at);
        const end = this.parseDisplayDate(
            schedule?.schedule_end_at || schedule?.schedule_at
        );
        if (!start) return '-';
        const startLabel = this.formatScheduleDateValue(start);
        if (!end || this.dateKey(start) === this.dateKey(end)) return startLabel;
        return `${startLabel} ~ ${this.formatScheduleDateValue(end)}`;
    }

    public formatScheduleTimeLine(schedule: any) {
        if (schedule?.all_day) return '종일';
        const start = this.formatTime(schedule?.schedule_at);
        const end = this.formatTime(
            schedule?.schedule_end_at || schedule?.schedule_at
        );
        if (!start) return '-';
        return !end || start === end ? start : `${start} ~ ${end}`;
    }

    public formatExpenseScheduleDateLine(schedule: any) {
        const start = schedule?.schedule_at;
        const end = schedule?.schedule_end_at || start;
        if (!start) return '-';
        const startLabel = this.formatDate(start);
        if (!end || this.valueDateKey(start) === this.valueDateKey(end)) {
            return startLabel;
        }
        return `${startLabel} ~ ${this.formatDate(end)}`;
    }

    public formatScheduleTimeRange(schedule: any) {
        const start = schedule?.schedule_at;
        const end = schedule?.schedule_end_at || start;
        if (!start) return '-';
        if (schedule?.all_day) return '종일';
        const startTime = this.formatTime(start);
        const endTime = this.formatTime(end);
        if (this.valueDateKey(start) !== this.valueDateKey(end)) {
            return `${this.formatDate(start, true)} ~ ${this.formatDate(end, true)}`;
        }
        return startTime === endTime
            ? startTime
            : `${startTime} ~ ${endTime}`;
    }

    public formatPollOption(option: any) {
        if (!option.option_at) return option.label;
        if (option.all_day) return `${this.formatDate(option.option_at)} · 종일`;
        if (option.option_end_at) {
            return `${this.formatDate(option.option_at)} · ${this.formatTime(option.option_at)} ~ ${this.formatTime(option.option_end_at)}`;
        }
        return this.formatDate(option.option_at, true);
    }

    public formatTime(value: any) {
        if (!value) return '';
        return String(value).replace(' ', 'T').slice(11, 16);
    }

    public pollOptionShortTime(option: any) {
        if (option.all_day) return '종일';
        const start = this.formatTime(option.option_at);
        const end = this.formatTime(option.option_end_at);
        return end ? `${start}~${end}` : start;
    }

    public userInitial(name: string) {
        return (name || '?').trim().charAt(0);
    }

    public pollKindLabel(kind: string) {
        return kind === 'schedule' ? '일정 투표' : '장소 투표';
    }

    public pollStatusLabel(poll: any) {
        if (poll.effective_status === 'stopped') return '중단됨';
        if (poll.effective_status === 'ended') return '마감됨';
        return '진행 중';
    }

    public pollStatusDescription(poll: any) {
        if (poll.effective_status === 'stopped') return '생성자가 투표를 중단했습니다.';
        if (poll.effective_status === 'ended') {
            return poll.end_reason === 'manual'
                ? '생성자가 투표를 종료했습니다.'
                : '투표 마감 시간이 지났습니다.';
        }
        return poll.closes_at ? `${this.formatDate(poll.closes_at, true)}까지` : '마감 설정 없음';
    }

    public pollSelectionTitle(poll: any) {
        if (!poll.is_open) return '투표 종료 · 결과 확인';
        if (poll.kind === 'place' && !poll.multiple_choice) return '한 곳만 선택';
        if (poll.selection_mode === 'calendar') return '캘린더에서 복수 선택';
        return '복수 선택 가능';
    }

    public pollSelectionDescription(poll: any) {
        if (!poll.is_open) return '기존 참여 결과는 그대로 확인할 수 있어요.';
        if (poll.kind === 'place' && !poll.multiple_choice) return '가장 원하는 장소 한 곳을 선택하세요.';
        if (poll.selection_mode === 'calendar') return '날짜를 누른 뒤 가능한 시간을 추가하거나 선택하세요.';
        return '가능한 일정이나 장소를 빠짐없이 선택하세요.';
    }

    public minimumPollCloseAt() {
        const date = new Date();
        date.setMinutes(date.getMinutes() + 1, 0, 0);
        return this.localDateTimeValue(date);
    }

    public pollOptionSummary(poll: any) {
        if (poll.kind === 'schedule' && poll.selection_mode === 'calendar') {
            return `기간 캘린더형 · ${poll.options.length}개 시간 · ${poll.response_count}명 참여`;
        }
        if (poll.kind === 'schedule') {
            return `후보 선택형 · ${poll.options.length}개 선택지 · ${poll.response_count}명 참여`;
        }
        return `${poll.options.length}개 장소 · ${poll.response_count}명 참여`;
    }

    public pollListSummary(poll: any) {
        const optionCount = (poll?.options || []).length;
        if (poll?.kind === 'place') {
            return `${optionCount}개 장소 · ${Number(poll?.response_count || 0)}명 참여`;
        }
        if (poll?.range_start && poll?.range_end) {
            return `기간 ${this.formatDate(poll.range_start)} ~ ${this.formatDate(poll.range_end)} · ${optionCount}개 선택지`;
        }
        return `${optionCount}개 선택지 · ${Number(poll?.response_count || 0)}명 참여`;
    }

    public pollListStatus(poll: any) {
        if (!this.isPollOngoing(poll)) return this.pollStatusDescription(poll);
        if (!poll?.closes_at) {
            return poll?.created
                ? `생성일 ${this.formatDate(poll.created)}`
                : '마감일이 정해지지 않았습니다.';
        }

        const closesAt = new Date(String(poll.closes_at).replace(' ', 'T'));
        const remaining = closesAt.getTime() - new Date().getTime();
        if (isNaN(closesAt.getTime()) || remaining <= 0) {
            return this.pollStatusDescription(poll);
        }

        const days = Math.ceil(remaining / (24 * 60 * 60 * 1000));
        const hours = Math.max(1, Math.ceil(remaining / (60 * 60 * 1000)));
        const remainingLabel = remaining <= 24 * 60 * 60 * 1000
            ? `${hours}시간`
            : `${days}일`;
        return `마감까지 ${remainingLabel} · ${this.formatDate(poll.closes_at, true)}`;
    }

    public pollRespondents(poll: any) {
        if (Array.isArray(poll?.respondent_details)) {
            return poll.respondent_details;
        }

        const respondents = new Map<string, any>();
        const respondentNames = new Set<string>();
        (poll?.options || []).forEach((option: any) => {
            (option?.voter_details || []).forEach((voter: any) => {
                const key = voter?.id || voter?.name;
                if (key && !respondents.has(key)) {
                    respondents.set(key, voter);
                    if (voter?.name) respondentNames.add(voter.name);
                }
            });
            (option?.voters || []).forEach((name: string) => {
                if (name && !respondentNames.has(name)) {
                    respondents.set(name, { id: name, name, color: 'violet' });
                    respondentNames.add(name);
                }
            });
        });
        return Array.from(respondents.values());
    }

    public hasDepartedRespondent(poll: any) {
        return this.pollRespondents(poll).some(
            (respondent: any) => respondent?.is_current_member === false
        );
    }

    public pollParticipationPercent(poll: any) {
        const total = Number(poll?.member_count || this.detail?.members?.length || 0);
        if (!total) return 0;
        return Math.min(
            100,
            Math.round((Number(poll?.response_count || 0) / total) * 100)
        );
    }

    public pollPercent(option: any, poll: any) {
        const total = Number(poll.response_count || 0);
        if (!total) return 0;
        return Math.round((Number(option.vote_count || 0) / total) * 100);
    }

    public scheduleParticipantNames(schedule: any) {
        return (schedule?.participants || [])
            .map(
                (participant: any) =>
                    participant.user_name
                    || participant.user_email
                    || '이름 없는 멤버'
            )
            .join(', ');
    }

    public scheduleMonthState(schedule: any) {
        const start = this.parseDisplayDate(schedule?.schedule_at);
        if (!start) return 'other';
        const now = new Date();
        if (
            start.getFullYear() === now.getFullYear()
            && start.getMonth() === now.getMonth()
        ) return 'current';
        const next = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        if (
            start.getFullYear() === next.getFullYear()
            && start.getMonth() === next.getMonth()
        ) return 'next';
        return 'other';
    }

    public scheduleMonthLabel(schedule: any) {
        const state = this.scheduleMonthState(schedule);
        if (state === 'current') return '이번 달';
        if (state === 'next') return '다음 달';
        const start = this.parseDisplayDate(schedule?.schedule_at);
        if (!start) return '날짜 미정';
        const currentMonth = new Date();
        currentMonth.setDate(1);
        currentMonth.setHours(0, 0, 0, 0);
        return start < currentMonth ? '이전 달' : '이후 일정';
    }

    public scheduleState(value: any, endValue: any = null) {
        if (!value) return '';
        const date = new Date(String(endValue || value).replace(' ', 'T'));
        return date.getTime() < new Date().getTime() ? '지난 일정' : '예정';
    }

    public canEditSchedule(schedule: any) {
        if (!schedule) return false;
        if (typeof schedule.can_edit === 'boolean') return schedule.can_edit;
        const currentUserId = this.service.auth?.session?.id || '';
        return (
            schedule.creator_id === currentUserId
            || (schedule.participants || []).some(
                (participant: any) => participant.user_id === currentUserId
            )
        );
    }

    public canDeleteSchedule(schedule: any) {
        if (!schedule) return false;
        if (typeof schedule.can_delete === 'boolean') return schedule.can_delete;
        const currentUserId = this.service.auth?.session?.id || '';
        return (
            this.detail?.meeting?.my_role === 'owner'
            || schedule.creator_id === currentUserId
        );
    }

    public scheduleEditPermissionMessage(schedule: any) {
        if (this.canEditSchedule(schedule)) {
            return '일정 참여 인원 또는 작성자로서 내용과 동선을 편집할 수 있습니다.';
        }
        return '일정 수정과 동선 편집은 참여 인원 또는 작성자만 할 수 있습니다.';
    }

    public scheduleDeletePermissionMessage(schedule: any) {
        return this.canDeleteSchedule(schedule)
            ? '이 일정을 삭제할 수 있습니다.'
            : '일정은 작성자 또는 모임장만 삭제할 수 있습니다.';
    }

    public initial(name: string) {
        return (name || '?').trim().charAt(0).toUpperCase();
    }

    public trackById(index: number, item: any) {
        return item.id;
    }

    public trackByDay(index: number, item: any) {
        return item.key;
    }

    public trackByWeek(index: number, item: any) {
        return item.key;
    }

    public trackByCalendarSegment(index: number, item: any) {
        return item.key;
    }

    public trackByParticipant(index: number, item: any) {
        return item.user_id || item.user_email || index;
    }

    public dateKey(date: Date) {
        return [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0')
        ].join('-');
    }

    private valueDateKey(value: any) {
        if (!value) return '';
        return String(value).replace(' ', 'T').slice(0, 10);
    }

    private pollMatchesKind(poll: any, kind: string) {
        return kind === 'all' || poll?.kind === kind;
    }

    private pollMatchesStatus(poll: any, status: string) {
        if (status === 'all') return true;
        if (status === 'closing') return this.isPollClosingSoon(poll);
        return status === 'ongoing'
            ? this.isPollOngoing(poll)
            : !this.isPollOngoing(poll);
    }

    private pollMatchesParticipation(poll: any, participation: string) {
        if (participation === 'all') return true;
        if (participation === 'mine') return this.hasParticipatedInPoll(poll);
        if (participation === 'pending') {
            return !this.hasParticipatedInPoll(poll) && this.isPollOngoing(poll);
        }
        return !this.hasParticipatedInPoll(poll);
    }

    private pollCreatedTime(poll: any) {
        const date = new Date(
            String(poll?.created || poll?.closes_at || '').replace(' ', 'T')
        );
        return isNaN(date.getTime()) ? 0 : date.getTime();
    }

    private scheduleMatchesMonth(schedule: any, month: string) {
        if (month === 'all') return true;
        const start = this.parseDisplayDate(schedule?.schedule_at);
        const end = this.parseDisplayDate(
            schedule?.schedule_end_at || schedule?.schedule_at
        );
        if (!start || !end) return false;
        const now = new Date();
        const offset = month === 'next' ? 1 : 0;
        const rangeStart = new Date(
            now.getFullYear(),
            now.getMonth() + offset,
            1
        );
        const rangeEnd = new Date(
            now.getFullYear(),
            now.getMonth() + offset + 1,
            1
        );
        return end >= rangeStart && start < rangeEnd;
    }

    private scheduleMatchesStatus(schedule: any, status: string) {
        if (status === 'all') return true;
        const state = this.scheduleState(
            schedule?.schedule_at,
            schedule?.schedule_end_at
        );
        return status === 'upcoming'
            ? state === '예정'
            : state === '지난 일정';
    }

    private scheduleMatchesParticipation(
        schedule: any,
        participation: string
    ) {
        if (participation === 'all') return true;
        const isParticipant = this.isCurrentUserScheduleParticipant(schedule);
        return participation === 'mine' ? isParticipant : !isParticipant;
    }

    private parseDisplayDate(value: any) {
        if (!value) return null;
        const date = new Date(String(value).replace(' ', 'T'));
        return isNaN(date.getTime()) ? null : date;
    }

    private formatScheduleDateValue(date: Date) {
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long'
        }).format(date);
    }

    private emptyMeeting() {
        return { name: '', password: '', description: '', image: '' };
    }

    private defaultScheduleParticipantIds() {
        return (this.detail?.members || [])
            .map((member: any) => member.user_id)
            .filter((userId: string) => !!userId);
    }

    private scheduleInputValue(value: any) {
        if (!value) return '';
        return String(value).replace(' ', 'T').slice(0, 16);
    }

    private scheduleShareUrl(schedule: any) {
        const meetingId = this.detail?.meeting?.id || '';
        const url = new URL(
            `/meetings/${encodeURIComponent(meetingId)}`,
            location.origin
        );
        url.searchParams.set('schedule', schedule?.id || '');
        return url.toString();
    }

    private async writeClipboard(value: string) {
        const nav: any = navigator;
        if (nav.clipboard?.writeText) {
            await nav.clipboard.writeText(value);
            return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        let copied = false;
        try {
            textarea.focus();
            textarea.select();
            copied = document.execCommand('copy');
        } finally {
            textarea.remove();
        }
        if (!copied) throw new Error('clipboard unavailable');
    }

    private async showPaymentToast(message: string) {
        if (this.paymentToastTimer) clearTimeout(this.paymentToastTimer);
        this.paymentToastMessage = message;
        await this.service.render();
        this.paymentToastTimer = setTimeout(async () => {
            this.paymentToastMessage = '';
            this.paymentToastTimer = null;
            await this.service.render();
        }, 2200);
    }

    private scheduleCalendarContent(schedule: any) {
        const start = this.scheduleCalendarDate(schedule?.schedule_at);
        if (!start) throw new Error('invalid schedule start');
        const rawEnd = this.scheduleCalendarDate(
            schedule?.schedule_end_at || schedule?.schedule_at
        );
        const end = rawEnd && rawEnd.getTime() > start.getTime()
            ? rawEnd
            : new Date(start.getTime() + 60 * 60 * 1000);
        const meetingName = this.detail?.meeting?.name || '모임';
        const participants = this.scheduleParticipantNames(schedule);
        const itinerary = (schedule?.itinerary || []).map(
            (stop: any, index: number) => {
                const time = stop.time || '시간 미정';
                const place = stop.place || '장소 미정';
                const activity = stop.activity ? ` · ${stop.activity}` : '';
                return `${index + 1}. ${time} ${place}${activity}`;
            }
        );
        const description = [
            `모임: ${meetingName}`,
            schedule.description || '',
            participants ? `참여자: ${participants}` : '',
            itinerary.length > 0 ? `동선:\n${itinerary.join('\n')}` : '',
            `일정 링크: ${this.scheduleShareUrl(schedule)}`
        ].filter((value: string) => !!value).join('\n');
        const locationValue = Array.from(new Set(
            [schedule.place, schedule.place_address]
                .map((value: any) => String(value || '').trim())
                .filter((value: string) => !!value)
        )).join(', ');
        const startLine = schedule?.all_day
            ? `DTSTART;VALUE=DATE:${this.calendarAllDayStamp(schedule.schedule_at)}`
            : `DTSTART:${this.calendarTimestamp(start)}`;
        const endLine = schedule?.all_day
            ? `DTEND;VALUE=DATE:${this.calendarAllDayStamp(schedule.schedule_end_at || schedule.schedule_at, 1)}`
            : `DTEND:${this.calendarTimestamp(end)}`;
        const lines = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//MoaTime//Meeting Schedule//KO',
            'CALSCALE:GREGORIAN',
            'METHOD:PUBLISH',
            `X-WR-CALNAME:${this.escapeCalendarText(meetingName)}`,
            'BEGIN:VEVENT',
            `UID:${this.escapeCalendarText(schedule.id)}@schedule.jeongcr.wizide.com`,
            `DTSTAMP:${this.calendarTimestamp(new Date())}`,
            startLine,
            endLine,
            `SUMMARY:${this.escapeCalendarText(schedule.title || '모임 일정')}`,
            `DESCRIPTION:${this.escapeCalendarText(description)}`,
            `LOCATION:${this.escapeCalendarText(locationValue)}`,
            `URL:${this.escapeCalendarText(this.scheduleShareUrl(schedule))}`,
            'END:VEVENT',
            'END:VCALENDAR'
        ];
        return lines.map((line: string) => this.foldCalendarLine(line))
            .join('\r\n') + '\r\n';
    }

    private scheduleCalendarDate(value: any) {
        const normalized = String(value || '').trim().replace(' ', 'T');
        if (!normalized) return null;
        if (/Z$|[+-]\d{2}:?\d{2}$/.test(normalized)) {
            const zoned = new Date(normalized);
            return isNaN(zoned.getTime()) ? null : zoned;
        }
        const match = normalized.match(
            /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/
        );
        if (!match) return null;
        const [, year, month, day, hour, minute, second = '0'] = match;
        const utc = Date.UTC(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hour) - 9,
            Number(minute),
            Number(second)
        );
        const date = new Date(utc);
        return isNaN(date.getTime()) ? null : date;
    }

    private calendarTimestamp(date: Date) {
        return date.toISOString()
            .replace(/[-:]/g, '')
            .replace(/\.\d{3}Z$/, 'Z');
    }

    private calendarAllDayStamp(value: any, dayOffset: number = 0) {
        const date = this.parseDateKey(this.valueDateKey(value));
        if (!date) throw new Error('invalid all-day schedule date');
        date.setDate(date.getDate() + dayOffset);
        return this.dateKey(date).replace(/-/g, '');
    }

    private escapeCalendarText(value: any) {
        return String(value || '')
            .replace(/\\/g, '\\\\')
            .replace(/\r?\n/g, '\\n')
            .replace(/;/g, '\\;')
            .replace(/,/g, '\\,');
    }

    private foldCalendarLine(line: string) {
        const Encoder: any = (window as any).TextEncoder;
        const encoder = Encoder ? new Encoder() : null;
        const byteLength = (value: string) => encoder
            ? encoder.encode(value).length
            : value.length;
        const rows: string[] = [];
        let current = '';
        let limit = 75;
        for (const character of line) {
            if (current && byteLength(current + character) > limit) {
                rows.push(current);
                current = character;
                limit = 74;
            } else {
                current += character;
            }
        }
        rows.push(current);
        return rows.map(
            (row: string, index: number) => index === 0 ? row : ` ${row}`
        ).join('\r\n');
    }

    private scheduleCalendarFilename(schedule: any) {
        const meetingName = this.detail?.meeting?.name || '모임';
        return `${meetingName}-${schedule?.title || '일정'}`
            .replace(/[\\/:*?"<>|]/g, '-')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 80) || '모임-일정';
    }

    private emptySchedule() {
        const date = new Date();
        date.setHours(date.getHours() + 1, 0, 0, 0);
        const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString().slice(0, 16);
        const endDate = new Date(date.getTime() + 2 * 60 * 60 * 1000);
        const endLocal = new Date(endDate.getTime() - endDate.getTimezoneOffset() * 60000)
            .toISOString().slice(0, 16);
        const recurrenceEnd = new Date(date);
        recurrenceEnd.setMonth(recurrenceEnd.getMonth() + 1);
        return {
            title: '',
            schedule_at: local,
            schedule_end_at: endLocal,
            all_day: false,
            all_day_start: this.dateKey(date),
            all_day_end: this.dateKey(endDate),
            place: '',
            place_address: '',
            place_link: '',
            description: '',
            recurrence_id: '',
            recurrence_frequency: 'none',
            recurrence_interval: 1,
            recurrence_weekdays: [this.mondayWeekday(date)],
            recurrence_end_type: 'count',
            recurrence_end_date: this.dateKey(recurrenceEnd),
            recurrence_count: 10,
            edit_scope: 'this',
            reminder_enabled: false,
            reminders: [this.reminderDraft(30)]
        };
    }

    private schedulePayloadData() {
        const data = { ...this.scheduleData };
        delete data.all_day_start;
        delete data.all_day_end;
        if (data.all_day) {
            data.schedule_at = this.scheduleData.all_day_start
                ? `${this.scheduleData.all_day_start}T00:00`
                : '';
            data.schedule_end_at = this.scheduleData.all_day_end
                ? `${this.scheduleData.all_day_end}T23:59:59`
                : '';
        }
        const frequency = data.recurrence_frequency || 'none';
        const recurrenceRule: any = { frequency };
        if (frequency !== 'none') {
            recurrenceRule.interval = Math.max(
                1, Number(data.recurrence_interval) || 1
            );
            recurrenceRule.weekdays = [...(data.recurrence_weekdays || [])];
            recurrenceRule.end_type = data.recurrence_end_type || 'count';
            if (recurrenceRule.end_type === 'date') {
                recurrenceRule.end_date = data.recurrence_end_date;
            } else {
                recurrenceRule.count = Math.max(
                    2, Number(data.recurrence_count) || 2
                );
            }
        }
        const reminders = data.reminder_enabled
            ? (data.reminders || []).map((item: any) => ({
                minutes: item.preset === 'custom'
                    ? Math.max(1, Number(item.custom_minutes) || 1)
                    : Number(item.preset)
            })) : [];
        data.recurrence_rule = JSON.stringify(recurrenceRule);
        data.reminders = JSON.stringify(reminders);
        data.force_save = false;
        for (const key of [
            'recurrence_id', 'recurrence_frequency', 'recurrence_interval',
            'recurrence_weekdays', 'recurrence_end_type',
            'recurrence_end_date', 'recurrence_count'
        ]) delete data[key];
        return data;
    }

    private mondayWeekday(date: Date) {
        return (date.getDay() + 6) % 7;
    }

    private reminderDraft(minutes: any) {
        const numeric = Math.max(1, Number(minutes) || 30);
        return {
            preset: [10, 30, 60, 1440].includes(numeric)
                ? String(numeric) : 'custom',
            custom_minutes: numeric
        };
    }

    private scheduleConflictMessage(data: any) {
        const conflicts = Array.isArray(data?.conflicts) ? data.conflicts : [];
        const lines = conflicts.slice(0, 5).map((item: any) => {
            const start = this.parseDisplayDate(item.schedule_at);
            const end = this.parseDisplayDate(item.schedule_end_at);
            const occurrence = this.parseDisplayDate(item.occurrence_at);
            const existingLabel = start
                ? `${start.getMonth() + 1}/${start.getDate()} ${this.formatTime(start)}`
                : String(item.schedule_at || '');
            const endLabel = end && start && end.getTime() > start.getTime()
                ? `~${this.formatTime(end)}` : '';
            const occurrenceLabel = occurrence
                ? `${occurrence.getMonth() + 1}/${occurrence.getDate()} 발생`
                : '해당 일정';
            const category = item.meeting_name
                ? ` · ${item.meeting_name}` : '';
            const type = item.overlap_type === 'full' ? '완전 겹침' : '일부 겹침';
            return `• ${occurrenceLabel} ↔ ${existingLabel}${endLabel} `
                + `${item.title || '일정'}${category} (${type})`;
        });
        const more = conflicts.length > 5 ? `\n외 ${conflicts.length - 5}건` : '';
        return `겹치는 일정이 있습니다.\n\n${lines.join('\n')}${more}\n\n그래도 저장할까요?`;
    }

    private shiftScheduleDateValue(value: any, dayOffset: number) {
        const date = this.parseDisplayDate(value);
        if (!date) return '';
        date.setDate(date.getDate() + dayOffset);
        return this.localDateTimeValue(date);
    }

    private calendarWeekDropDay(week: any, event: DragEvent) {
        const element = event.currentTarget as HTMLElement | null;
        const days = week?.days || [];
        if (!element || days.length !== 7) return null;
        const rect = element.getBoundingClientRect();
        if (!rect.width) return null;
        const relativeX = Math.max(
            0,
            Math.min(rect.width - 1, event.clientX - rect.left)
        );
        const index = Math.min(6, Math.floor(relativeX / (rect.width / 7)));
        return days[index] || null;
    }

    private emptyPoll() {
        const today = this.dateKey(new Date());
        const end = new Date();
        end.setDate(end.getDate() + 7);
        const closesAt = new Date();
        closesAt.setDate(closesAt.getDate() + 3);
        closesAt.setHours(23, 59, 0, 0);
        return {
            kind: 'schedule',
            selection_mode: 'options',
            allow_option_additions: true,
            multiple_choice: true,
            title: '',
            description: '',
            range_start: today,
            range_end: this.dateKey(end),
            closes_at: this.localDateTimeValue(closesAt),
            options: []
        };
    }

    private emptyPollOptionDraft() {
        return {
            date: '',
            time: '19:00',
            label: '',
            address: '',
            link: '',
            image: ''
        };
    }

    private emptyPollOptionAddDraft() {
        return {
            date: '',
            start_time: '19:00',
            end_time: '21:00',
            all_day: false
        };
    }

    private showPollFormError(message: string) {
        this.pollFormError = message;
        this.service.render();
    }

    private parseDateKey(value: string) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
        const [year, month, day] = value.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return isNaN(date.getTime()) ? null : date;
    }

    private dayDistance(start: Date, end: Date) {
        const startUtc = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
        const endUtc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
        return Math.round((endUtc - startUtc) / 86400000);
    }

    private optionIdentityKey(option: any) {
        const date = this.valueDateKey(option.option_at);
        const startTime = this.formatTime(option.option_at);
        const endTime = this.formatTime(option.option_end_at);
        return `${date}|${startTime}|${endTime}|${option.all_day ? '1' : '0'}`;
    }

    private localDateTimeValue(date: Date) {
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString().slice(0, 16);
    }

    private async syncMeetingRoute() {
        const meetingId = WizRoute.segment.id || '';
        if (!meetingId) {
            if (this.detail) {
                this.detail = null;
                this.scrollPageTop();
                await this.service.render();
            }
            return;
        }
        if (this.detail?.meeting?.id === meetingId || this.loading) return;
        await this.openMeeting({ id: meetingId }, true, false);
    }

    private async openRequestedAction() {
        if (WizRoute.segment.id) return;
        const action = new URLSearchParams(location.search).get('action');
        if (action === 'create') {
            this.openCreate();
            return;
        }
        if (action === 'join') this.openJoin();
    }

    private pollCloseIsoValue() {
        const closesAt = new Date(this.pollData.closes_at);
        return isNaN(closesAt.getTime()) ? '' : closesAt.toISOString();
    }

    private normalizePlaceLink(value: string) {
        const raw = (value || '').trim();
        if (!raw) return '';
        const candidate = raw.includes('://') ? raw : `https://${raw}`;
        try {
            const url = new URL(candidate);
            return ['http:', 'https:'].includes(url.protocol) && !!url.hostname
                ? url.toString()
                : '';
        } catch {
            return '';
        }
    }

    private copyStops(stops: any[]) {
        return stops.map((stop: any) => {
            const transport = this.parseItineraryTransport(stop.transport || '');
            return {
                time: stop.time || '',
                place: stop.place || '',
                activity: stop.activity || '',
                transportMode: transport.mode,
                transportDuration: transport.duration,
                confirmed: this.itineraryStopConfirmed(stop)
            };
        });
    }

    private itineraryTimesAreOrdered(stops: any[]) {
        const enteredTimes = stops
            .map((stop: any) => String(stop?.time || '').trim())
            .filter((time: string) => !!time);
        return enteredTimes.every(
            (time: string, index: number) =>
                index === 0 || enteredTimes[index - 1] <= time
        );
    }

    private parseItineraryTransport(value: string) {
        const raw = String(value || '').trim();
        if (!raw) return { mode: '', duration: '' };

        const modes = ['대중교통', '자동차', '자전거', '도보', '택시'];
        const separated = raw.split(/\s*·\s*/);
        if (separated.length > 1 && modes.includes(separated[0])) {
            return {
                mode: separated[0],
                duration: separated.slice(1).join(' · ')
            };
        }

        const matchedMode = modes.find((mode: string) => raw.startsWith(`${mode} `));
        if (matchedMode) {
            return {
                mode: matchedMode,
                duration: raw.slice(matchedMode.length).trim()
            };
        }

        return { mode: '기타', duration: raw };
    }

    private errorMessage(data: any, fallback: string) {
        if (typeof data === 'string' && data) return data;
        if (data && typeof data.message === 'string') return data.message;
        return fallback;
    }

    private emptyMember() {
        return {
            username: '',
            name: ''
        };
    }

    private emptyMemory() {
        return {
            review: '',
            photos: [],
            visibility: 'participants'
        };
    }

    private emptyExpense() {
        return {
            title: '',
            amount: '',
            payer_id: '',
            participant_ids: []
        };
    }

    private emptyPaymentInfo() {
        return {
            bank_name: '',
            account_number: ''
        };
    }

    private normalizePaymentAftercare(data: any) {
        if (!data || !Array.isArray(data.payment_infos)) return data;
        const paymentInfos: any[] = [];
        for (const info of data.payment_infos) {
            const bundled = this.parsePaymentBundle(info?.content);
            if (!bundled.length) {
                paymentInfos.push({
                    ...info,
                    storage_id: info.storage_id || info.id
                });
                continue;
            }
            for (const account of bundled) {
                paymentInfos.push({
                    ...info,
                    id: `${info.id}:${account.id}`,
                    storage_id: info.id,
                    bundle_entry_id: account.id,
                    bank_name: account.bank_name,
                    account_number: account.account_number,
                    formatted_account_number: this.formatPaymentAccountNumber(
                        account.account_number, account.bank_name
                    ),
                    content: `${account.bank_name} ${this.formatPaymentAccountNumber(
                        account.account_number, account.bank_name
                    )}`,
                    is_bundle_entry: true,
                    is_legacy: false
                });
            }
        }
        data.payment_infos = paymentInfos;
        data.my_payment_info = paymentInfos.find(
            (info: any) => info.is_mine
        ) || null;
        return data;
    }

    private applyScheduleAftercare(data: any, syncMemory: boolean = false) {
        this.scheduleAftercare = this.normalizePaymentAftercare(data) || null;
        this.paymentInfoEditing = false;
        this.paymentInfoEditingId = '';
        this.paymentInfoEditingEntryId = '';
        this.paymentInfoDraft = this.emptyPaymentInfo();
        this.paymentBankSearch = '';
        this.paymentBankDropdownOpen = false;
        if (syncMemory) {
            const memory = data?.my_memory;
            this.memoryDraft = memory
                ? {
                    review: memory.review || '',
                    photos: [...(memory.photos || [])],
                    visibility: memory.visibility || 'participants'
                }
                : this.emptyMemory();
        }
        this.setDefaultExpensePayer();
    }

    private syncSelectedScheduleMemoryPreview() {
        if (!this.selectedSchedule || !this.scheduleAftercare) return;
        const memories = this.scheduleAftercare.memories || [];
        const previewMemory = memories.find(
            (memory: any) => (memory.photos || []).length > 0
        );
        const patch = {
            memory_count: memories.length,
            memory_preview: previewMemory?.photos?.[0] || ''
        };
        Object.assign(this.selectedSchedule, patch);
        const schedule = (this.detail?.schedules || []).find(
            (item: any) => item.id === this.selectedSchedule.id
        );
        if (schedule) Object.assign(schedule, patch);
    }

    private setDefaultExpensePayer() {
        if (!this.scheduleAftercare?.is_participant) return;
        const currentUserId = this.service.auth?.session?.id || '';
        const participants = this.scheduleAftercare.participants || [];
        const hasValidPayer = this.expenseDraft.payer_id && participants.some(
            (participant: any) =>
                participant.user_id === this.expenseDraft.payer_id
        );
        if (!hasValidPayer) {
            this.expenseDraft.payer_id = participants.some(
                (participant: any) => participant.user_id === currentUserId
            )
                ? currentUserId
                : (participants[0]?.user_id || '');
        }
        if (!this.expenseDraft.participant_ids?.length) {
            this.expenseDraft.participant_ids = participants.map(
                (participant: any) => participant.user_id
            );
        }
    }

    private async addMemoryPhotos(files: File[]) {
        if (!files.length || this.saving) return;
        const remaining = Math.max(0, 4 - this.memoryDraft.photos.length);
        if (remaining === 0) {
            await this.service.modal.error('사진은 최대 4장까지 올릴 수 있습니다.');
            return;
        }
        const imageFiles = files.filter(
            (file: File) => String(file.type || '').startsWith('image/')
        );
        const accepted = imageFiles.slice(0, remaining);
        for (const file of accepted) {
            try {
                const image = await this.resizeMemoryPhoto(file);
                if (image.length > 1800000) {
                    await this.service.modal.error(
                        `${file.name} 파일이 너무 큽니다. 다른 사진을 선택해주세요.`
                    );
                    continue;
                }
                this.memoryDraft.photos.push(image);
            } catch (error) {
                await this.service.modal.error(
                    `${file.name} 사진을 불러오지 못했습니다.`
                );
            }
        }
        if (imageFiles.length < files.length) {
            await this.service.modal.error('이미지 파일만 올릴 수 있습니다.');
        } else if (imageFiles.length > remaining) {
            await this.service.modal.error('사진은 최대 4장까지 올릴 수 있습니다.');
        }
        await this.service.render();
    }

    private resizeMemoryPhoto(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => reject(new Error('read_failed'));
            reader.onload = () => {
                const image = new Image();
                image.onerror = () => reject(new Error('decode_failed'));
                image.onload = () => {
                    const maxSize = 960;
                    const scale = Math.min(
                        1,
                        maxSize / Math.max(image.width, image.height)
                    );
                    const width = Math.max(1, Math.round(image.width * scale));
                    const height = Math.max(1, Math.round(image.height * scale));
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const context = canvas.getContext('2d');
                    if (!context) {
                        reject(new Error('canvas_failed'));
                        return;
                    }
                    context.fillStyle = '#ffffff';
                    context.fillRect(0, 0, width, height);
                    context.drawImage(image, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', 0.78));
                };
                image.src = String(reader.result || '');
            };
            reader.readAsDataURL(file);
        });
    }

    private async finishMeetingExit(message: string) {
        this.showSettingsModal = false;
        this.detail = null;
        await this.router.navigateByUrl('/meetings');
        await this.service.modal.success(message);
    }

    private scrollPageTop() {
        const outlet = document.querySelector('router-outlet');
        const container = outlet ? outlet.parentElement : null;
        if (container) container.scrollTo({ top: 0, behavior: 'smooth' });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export default PageMembersComponent;